<!-- content -->
<!-- <div class="jumbotron jumbotron-fluid">
    <div class="container">
        <div class="text-center">
            <h1>Products</h1>
            <div><span class="home-breadcrumb" routerLink="">Home</span>
                <span> <i class="fa fa-long-arrow-right px-2"></i> Products</span>
            </div>
        </div>
    </div>
</div> -->
<!-- <style *ngIf="CONFIG.title !== 'BombayHardware'  && CONFIG.title !== 'LushNGreen' && CONFIG.title !== 'Babys Pride'">
  .my-pagination /deep/ .ngx-pagination .current {
    background: #ad342a;
    margin-top: 14px;
  }
</style>

<style *ngIf="CONFIG.title === 'BombayHardware'">
  .my-pagination /deep/ .ngx-pagination .current {
    background: #1e1e73;
    margin-top: 14px;
  }
</style> -->
<!-- <style *ngIf="CONFIG.title === 'Babys Pride' || CONFIG.title === 'LushNGreen'">
  .my-pagination /deep/ .ngx-pagination .current {
    background: #43950d ;
    margin-top: 14px;
  }
  
</style> -->
<style>
  
  .cartButtonkub:hover
  {
    background-color: #2a7d2e !important;
    color: white !important;

  }
  .cartButtonkubweight:hover
  {
    background-color: #2a7d2e !important;
    color: white !important;

  }
 
</style>
<style *ngIf="CONFIG.title === 'Kubendran'">
  @media screen and (min-width:0px) {
    /* .col-md-3{
      display:none;
  
    } */
    .fa fa-filter{
      display:block;
    }
    .respfilter{
      display:block;
    }
    
  }
  @media screen and (min-width:1100px) {
    .col-md-3{
      display:block;
    }
    .respfilter{
      display:none;
    }
    .fa fa-filter{
      display:none;
    }
   
  }
  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2a7d2e;
    overflow-x: hidden;
    transition: 0.1s;
    padding-top: 60px;
    z-index:1
  }
  
  .sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }
  
  .sidenav a:hover {
    color: #f1f1f1;
  }
  
  .sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
  }
  
  </style>
  <!-- <div id="openfilter" class="sidenav">
    <a href="javascript:void(0)" style="float:right;font-size:50px" class="nav-link menu-text" (click)="closeNavkub()"><p>&#8592;</p></a>
    <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
              [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
              [type]="type" [material]="material" [categoriesList]="categoryList" [configTitle]="CONFIG.title">
            </app-product-filter>
  
  </div> -->

<!-- new section added for shubcards -->

  <section *ngIf="CONFIG.title === 'ShubhCards'" style="width: 100%;">

        <div class="image-container">
          <img  *ngIf="activeTabIndex1==0 " class="desktop-only" src="../../../../../assets/images/ShubhCards/listingbanner.jpg" alt="Centered Image">
          <img   *ngIf="activeTabIndex1==3" class="desktop-only" src="../../../../../assets/images/ShubhCards/luxury.jpg" alt="Centered Image">
          <img  *ngIf="activeTabIndex1==1" class="desktop-only" src="../../../../../assets/images/ShubhCards/classic.jpg" alt="Centered Image">
          <img  *ngIf="activeTabIndex1==2" class="desktop-only" src="../../../../../assets/images/ShubhCards/elite.jpg" alt="Centered Image">
          <img *ngIf="activeTabIndex1==4" class="desktop-only" src="../../../../../assets/images/ShubhCards/premium.jpg" alt="Centered Image">
          <img class="mobile-only" *ngIf="activeTabIndex1==0 " src="../../../../../assets/images/ShubhCards/mob-list-img.jpg" alt="Centered Image">
          <img   *ngIf="activeTabIndex1==3" class="mobile-only" src="../../../../../assets/images/ShubhCards/luxury.jpg" alt="Centered Image">
          <img  *ngIf="activeTabIndex1==1" class="mobile-only" src="../../../../../assets/images/ShubhCards/classic.jpg" alt="Centered Image">
          <img  *ngIf="activeTabIndex1==2" class="mobile-only" src="../../../../../assets/images/ShubhCards/elite.jpg" alt="Centered Image">
          <img *ngIf="activeTabIndex1==4" class="mobile-only" src="../../../../../assets/images/ShubhCards/premium.jpg" alt="Centered Image">
          <div class="centered-text">
            
           
             
              <h1 class="dancing-script desktop-only" style="font-size: 7.5rem;">Creative</h1>
              <h1 class="dancing-script mobile-only" style="font-size: 2.5rem;">Creative</h1>
              <h1 class="desktop-only" style="font-size: 2.5rem;font-weight: 400">Invitations</h1>
              <h1 class="mobile-only" style="font-size: 1.5rem;font-weight: 400">Invitations</h1>
              
          </div>
        </div>
     
   

  </section>
  <section class="wrapper ht_home_category align-center col-12" id="shubhcards-tab" *ngIf="CONFIG.title=='ShubhCards'" >
    <div class="checkout-alerts">
      <app-alerts *ngIf="checkoutAlerts"></app-alerts>
    </div>
    <div class="tabs-vim" *ngIf="showTheme==false" >
        <!-- <input type="radio" name="css-tabs" id="tab-1" checked class="tab-switch-vim "> -->
        <!-- <label for="tab-1" class="tab-label-vim mob-font" style="white-space: nowrap;border-right:none"><p class="pro_list_color"   tabindex="1" (click)="getCategoryData('all')" >ALL</p></label> -->
        <div *ngFor="let cate of categoryList;let j=index" >
          <input type="radio" name="css-tabs" id=tab-{{j+2}} class="tab-switch-vim ">
        <label for=tab-{{j+2}} class="tab-label-vim"  style="white-space: nowrap;border-right:none" ><p class="pro_list_color nav-link1"   style="text-transform: uppercase" (click)="getCategoryData(cate.name)" [class.active]="j === activeTabIndex1">{{cate.name}}</p></label>
        </div>
        
    
      
  <!--    
        <input type="radio" name="css-tabs" id="tab-3" class="tab-switch-vim ">
        <label for="tab-3" class="tab-label-vim"  style="white-space: nowrap;border-right:none"><p class="pro_list_color"  class="vimpro_list"  tabindex="1">Foldable Crate</p></label>
    
        <input type="radio" name="css-tabs" id="tab-4" class="tab-switch-vim ">
        <label for="tab-4" class="tab-label-vim"  style="white-space: nowrap;border-right:none
        "><p  class="pro_list_color" class="vimpro_list"  tabindex="1">Pallet Set</p></label>
    
        <input type="radio" name="css-tabs" id="tab-5" class="tab-switch-vim ">
        <label for="tab-5" class="tab-label-vim" id="tab-label-vim_1" style="white-space: nowrap;border-right:none"  ><p class="pro_list_color"  class="vimpro_list"  tabindex="1">Food Container</p></label>
     -->
      </div>
      <div class="tabs-vim tabs-vim-theme" *ngIf="showTheme==true" >
       
        
        <div *ngFor="let cate of themes;let j=index">
          <input type="radio" name="css-tabs" id=tab-{{j+1}} class="tab-switch-vim ">
        <label for=tab-{{j+1}} class="tab-label-vim "  style="white-space: nowrap;border-right:none"><p class="pro_list_color nav-link1 vimpro_list"   tabindex="1" style="text-transform: uppercase" (click)="getThemeData(cate.name,j)"  [class.active]="j === activeTabIndex">{{cate.name}}</p></label>
        
        </div>
        
    
      
  
      </div>
      <div class="vimpro-container1" *ngIf="showTheme==false">
        <div class="new-shub-grid">
          <div class="container image-container-list  justify-content-center align-items-center" *ngFor="let pro of products | paginate
          : {
              id: 'pagination-controls',
              itemsPerPage: countPerPage,
              currentPage: currentPageInPagination,
              totalItems: totalLength
            } ;let i=index" style="box-shadow: unset;border-bottom: 1px solid #fd7417;box-shadow: unset;margin-bottom: 10px;">
             <div class="container" style="position: relative;max-width: 100%;height: 85%;">
              <img [src]="pro.assets[0].image_source" class="img-thumbnail" style="height: 100%; width: 100%;border: none;" >


             </div>
              
                <p style="width: 70%;font-size: 20px;color: #fd7417; font-family: 'Garamond', serif;" class="desktop-only" ><b>{{pro.description.short_desc}}</b></p>
                <p style="width: 70%;font-size: 12px;color: #fd7417; font-family: 'Garamond', serif;line-height: normal;" class="mobile-only" >{{pro.description.short_desc}}</p>
                <button  class="enqButton desktop-only" (click)="submitEnquiry_NotbasedOnLogin(pro)"  style="position: relative;top: -10%;border: 3px solid #fd7417 !important;background-color: #fd7417 !important;width: 11%;float: inline-end;color: white!important;">SUBMIT ENQUIRY</button>
                <button  class="enqButton mobile-only" (click)="submitEnquiry_NotbasedOnLogin(pro)"  style="position: relative;top: -10%;border: 3px solid #fd7417 !important;background-color: #fd7417 !important;width: 20%;float: inline-end;color: white!important;">ENQUIRY</button>
                
                
              
           
          </div>
  
        </div>
        
        </div>
        <div class="vimpro-container1" *ngIf="showTheme==true">
          <div class="new-shub-grid">
            <div class="container image-container-list d-flex justify-content-center align-items-center" *ngFor="let pro of products | paginate
            : {
                id: 'pagination-controls',
                itemsPerPage: countPerPage,
                currentPage: currentPageInPagination,
                totalItems: totalLength
              } ;let i=index">
                <div >
                  <img [src]="pro.assets[0].image_source" class="img-thumbnail" style="height: 100%; width: 100%;border: none;" (click)="productDetails(pro.id)">
    
                </div>       
             
            </div>
    
          </div>
          
          </div>
      <div style="display: flex;justify-content: flex-end;">
        <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
           id="pagination-controls"></pagination-controls>
        </div>
  </section>
 
<!-- new section added for shubcards -->
  <section class="row special-listing-width" id="productRow"  style="margin-left: 10px;" *ngIf="CONFIG.title === 'SpecialWires'" >
    <div class="col-md-3">
    <div class="inq-menu-left-st">
      <div class="collection-filter">
        <div class="total-items" id="totalItems">
          <p style="color: #0195da">
            <span><b style="color: #0195da">Items found</b></span> - {{ totalItemsOrProducts }}
          </p>
          <!-- <p style="font-family: 'proxima-regular','sans-serif' !important;" *ngIf="CONFIG.title === 'Aiema'"><span><b>Companies found</b></span> - {{filterItemsOfType().length}} </p> -->
        </div>
        <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
          [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
          [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">

        </app-product-filter>
      </div>
    </div>
  </div>
  <div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'SpecialWires'"
  style="padding-right: 0px !important; padding-left: 0px !important">
 
  <div>
    <div class="inq-menu-right-st">
      <h2 class="text-primary" id="productListHead" style="color: #0195da !important">Products</h2>
      <div class="breadCrumbListing">
        <span class="home-breadcrumb" routerLink="">Home</span>
        <span><i class="px-2">/</i> Products</span>
      </div>
      <div *ngIf="totalLength > 0" class="thumb1-special">
        <div style="margin-right: 20px" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
          <div class="row inq-pro-sec-st listProduct">
  <div *ngIf="CONFIG.title === 'SpecialWires'" class="deera-container">
                 
    <div *ngIf="product.product_type=='Variable'">
      <div id="img-list" style="margin-top: 10px;" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
      }}" container="body" *ngIf="fields[1].visibility">
    <div class="d-flex justify-content-between">
      <div class="cariencetitle" style="height: 36px;">
        <p (click)="productDetails(product.id)" class="product-list-tile3">{{product.name}}</p>
      </div>
    </div>
    </div>
      <div class="product-list-cards-specialwires3" style="color: lightgray">
        
        <div class="special-img1" *ngIf="product.current_index==-1">
              <img [src]="product.variant.option_values[0].child[0].assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-specialwires" />
        </div>
        <div class="special-img1" *ngIf="product.current_index!=-1">
          <!-- <div *ngFor="let img_colour of product.variant.option_values[product.current_index].child;let i = index" class="">
            <div *ngIf="img_colour.is_default"> -->
              <img [src]="product.variant.option_values[product.current_index].child[product.child_index].assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-specialwires" />
            <!-- </div>
        </div> -->
        </div>
        <div class="specialwires-description">
          
    <div>
      <div *ngIf="product.current_index!=-1" style=" font-weight: 500;margin-left: 10px; color: #000; margin-bottom: 5px;" class="carience-listing-price" >
        ₹{{product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index].pricing.raw.price}}
       </div>

       <div style="width: 80%;margin-top: 25px;margin-left: 10px;">
        <div class="dropdown" *ngIf="product.current_index==-1">
          <p style="color: #f33601; font-size: 10px;">Select Size</p>
          <button class="dropdown-toggle dropdownstyle1 dropspecial" type="checkbox" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Size
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;" (blur)="closeDropDown()" type='text' novalidate>
            <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
          </div>
          </div>
          </div>
    <div style="margin-top: 25px;">
      
    
    
        <div style="width: 80%;"  *ngIf="product.variant.option_values !=0">
        <div class="dropdown" style="display:flex;justify-content: center;margin-bottom:20px;">
        <button  *ngIf="product.current_index!=-1" class="dropdown-toggle dropdownstyle1 dropspecial" type="button" id="dropdownMenuButton" style="width: 100%;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
        <a  *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
        </div>
        </div>
    
    </div>
    <div *ngIf="product.current_index!=-1" class="dropdown" style="margin-bottom:5px;margin-left: 5px;width: 80%;">
      <button class="dropdown-toggle dropdownstyle1 dropspecial2" style="width: auto;"  type="button" id="dropdownMenuButton"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{product.variant.option_values[product.current_index].child[product.child_index].type}}
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
        style="min-width: 40%;max-width: fit-content;">
        <a *ngFor="let weight of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let k=index"
          (click)="selectColour(weight.type,product.id,k)"
          class="dropdown-item">{{weight.type}}</a>
      </div>
    </div>
   
    </div>

    <div class="list-specialcart" style="width: 100%;">
      <li class="header-cart small-cart-bh" style="position: relative;width: 7%;left: 80%;transform: translate(0px, 51px);">
        <span class="fa fa-shopping-cart " style="color: #000;">
                <div class="min-cart-product-wrapper summary-bh" style="height:fit-content;" id="cartpopups">
                  <div>
                    <a>{{get_count(product.id)>0?"":"Select Size"}}</a>
                </div> 
                <div class="row justify-content-center" style="margin: 5px" *ngFor="let cart of get_prod(product.id); let i = index;">
                    <div class="col-10 isempty">
                  <h6 style="font-size: 12px;">{{cart.product_name}}</h6>
                  <p style="font-size: small; margin-bottom: 5px;"> {{cart.quantity}} 
                    <span style="font-size: smaller;padding-right: 5px;">&#x292C;</span>₹{{cart.cost | number : '1.2-2'}}</p>
                  </div>
                </div>
                </div>
              
        </span>
      </li>
            </div>
            <div *ngIf="product.current_index==-1">
              <button class="button-62" [disabled]="product.current_index==-1" style="margin-left: 10px;margin-top: 20px;" >
              Add to Cart
              </button>  
             </div>
             <div *ngIf="product.current_index!==-1">
            <div *ngFor="let price of product.variant.option_values[product.current_index!=-1?product.current_index:0].child;let i = index">
               <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id) ==
               -1" class="button-62" [disabled]="product.current_index==-1" style="margin-left: 10px;margin-top: 20px;" (click)="addToCartSpecialWires(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id )" >
               Add to Cart
               </button>
             <!-- </div> -->
            
              </div>
              <div *ngFor="let rate of appService.cartProducts.results;let j = index">
                <div class="btn btn-primary inq-btn-st specialViewCart" style="background-color: #2177b8f2!important;" id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id) != -1 && (rate.product_id == product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id)">
                <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id))"></i></span>
                <input type="number" style="width: 40%; text-align: center" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1" 
                (input)="changeSpecial1Value(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id)].quantity" />
                 <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id))"></i></span>
                </div>
              </div>
               </div>
    
      <!-- <div class="" *ngFor="let price of product.variant.option_values[product.current_index!=-1?product.current_index:0].child;let i = index">
        <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id) ==
        -1" class="button-62" [disabled]="product.current_index==-1" style="margin-left: 10px;margin-top: 20px;" (click)="addToCartSpecialWires(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id )" >
        Add to Cart
        </button>   
        
        <div class="btn btn-primary inq-btn-st specialViewCart" style="background-color: #2177b8f2!important;" id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id) >=0">
        <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:1].child[product.child_index!=null?product.child_index:0].id))"></i></span>
        <input type="number" style="width: 40%; text-align: center" pattern="[0-9]" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1" 
      (input)="changeSpecial1Value(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id)].quantity" />
         <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id))"></i></span> 
        
        
        </div>
        </div> -->
    </div>
    </div>
      </div>
    </div>
    <div *ngIf="product.product_type=='Simple'">
      <div id="img-list" style="margin-top: 10px;" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
      }}" container="body" *ngIf="fields[1].visibility">
    <div class="d-flex justify-content-between">
      <div class="cariencetitle" style="height: 36px;">
        <p class="product-list-tile3" (click)="productDetails(product.id)">{{product.name}}</p>
      </div>
    </div>
    </div>
      <div class="product-list-cards-specialwires3" style="color: lightgray">
        <div class="special-img1">
      
      <img [src]="product.assets[0].image_source" id="img-list"
      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
      class="product-list-image-specialwires"/>
      </div>
      <div class="specialwires-description">
      <div class="d-flex justify-content-between"><p style="font-size: 10px; color: red;margin-top: 20px;margin-left: 10px;">Custamizable as per requirement</p></div>
      <div class="d-flex justify-content-between">
      <button class="button-62" (click)="submitEnquiryForSpecial(product)" style="margin-top: 50px;">
        Submit Enquiry
        </button> 
      
      
      <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
      <div *ngFor="let cart of appService.cartProducts.results; let i = index">
      <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
      <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
      <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      </div>
      </div>
      </div>
      </div>
      </div>
    </div>     
            </div>
  </div>
</div>
</div>
</div>
<div *ngIf="totalLength < 1">
<img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
</div>
</div>
<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
style="float: right" id="pagination-controls"></pagination-controls>
</div>
</div>
<div class="col-md-12 desk" *ngIf="CONFIG.title === 'SpecialWires'"
style="padding-right: 0px !important; padding-left: 0px !important; max-width: 75%;">

<div>
  <div class="inq-menu-right-st" >
    <h2 class="text-primary" id="productListHead" style="color: #0195da !important">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div>
    <div *ngIf="totalLength > 0" class="thumb1-special">
      <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <div class="row inq-pro-sec-st listProduct">
<div *ngIf="CONFIG.title === 'SpecialWires'" class="deera-container">
               
  <div *ngIf="product.product_type=='Variable'" class="product-list-cards-specialwires2">
    <div class="product-list-cards-specialwires1" style="color: lightgray">
      <div class="special-img" *ngIf="product.current_index==-1">
        <img [src]="product.variant.option_values[0].child[0].assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="product-list-image-specialwires" />
  </div>
  <div class="special-img" *ngIf="product.current_index!=-1">
    <!-- <div *ngFor="let img_colour of product.variant.option_values[product.current_index].child;let i = index" class="">
      <div *ngIf="img_colour.is_default"> -->
        <img [src]="product.variant.option_values[product.current_index].child[product.child_index].assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="product-list-image-specialwires" />
      <!-- </div>
  </div> -->
  </div>
      <!-- <div class="special-img" *ngIf="product.current_index!=-1">
        <div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
          <div *ngIf="img_colour.is_default">
            <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
              onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
              class="product-list-image-specialwires" />
          </div>
      </div>
</div> -->
    </div>
    <div class="specialwires-description">
    <div id="img-list" style="flex-basis: 100%;justify-content: center;
    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
    }}" container="body" *ngIf="fields[1].visibility">
  <div class="d-flex justify-content-between">
    <div class="cariencetitle">
      <p (click)="productDetails(product.id)" class="product-list-tile3">{{product.name}}</p>
    </div>
  </div>
  </div>
<div>
<div  class="">
  <div  style="display:flex;justify-content: center;">
  
  <div style=" display:flex;justify-content: center;font-weight: 500; margin-bottom: 10px;" class="carience-listing-price" >
   ₹{{product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index].pricing.raw.price}}
  </div>
  </div>
  </div>
<div style="margin-left: 10px;
margin-top: 30px;display: flex  ;" >

<!-- <div *ngIf="product.variant.option_values !=0">
  <div class="dropdown dropdownstyle1">
    <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      type
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
      <a *ngFor="let size of product.variant.option_values" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.option}}</a>
    </div>
  </div>
</div>
<div class="11" >
<div *ngIf="product.childs.size !=0">
  <div class="dropdown">
    <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;width: 100px;">
        {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
      </div>
      
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
      <a *ngFor="let size of product.childs.size" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.option}}</a>
    </div>
  </div>
</div>
</div> -->


  <div class="dropdown" style="margin-left: 10px;"  *ngIf="product.current_index==-1">
    <p style="color: #f33601; font-size: 10px;">Select Size</p>
    <button class="dropdown-toggle dropdownstyle1 dropspecial" style="width: 100px;" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      Size
    </button>
    <div class="dropdown-menu special_click" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
      <a *ngFor="let size of product.variant.option_values;let j=index" (blur)="closeDropDown()" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
    </div>
    </div>

    <div style="width: 80%;"  *ngIf="product.variant.option_values !=0">
    <div class="dropdown" style="display:flex;justify-content: center;margin-bottom:20px;">
    <button  *ngIf="product.current_index!=-1" class="dropdown-toggle dropdownstyle1 dropspecial" type="button" id="dropdownMenuButton" style="width: 100%;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{product.variant.option_values[product.current_index!=-1?product.current_index:0].option}}
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
    <a  *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionSpecialWires1(size.option,product.id,j)" class="dropdown-item special-dropitem">{{size.option}}</a>
    </div>
    </div>

</div>
<div class="dropdown" *ngIf="product.current_index!=-1" style="display:flex;justify-content: center;margin-bottom:20px;">

<button class="dropdown-toggle dropdownstyle1 dropspecial" style="width: 80%;" type="button" id="dropdownMenuButton"
  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  {{product.variant.option_values[product.current_index].child[product.child_index].type}}
</button>
<div class="dropdown-menu" aria-labelledby="dropdownMenuButton"
  style="min-width: 45%;max-width: fit-content;">
  <a *ngFor="let weight of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let k=index"
    (click)="selectColour(weight.type,product.id,k)"
    class="dropdown-item special-dropitem">{{weight.type}}</a>
</div>
</div>
</div>

</div>
<div class="list-specialcart" style="width: 100%;">
<li class="header-cart account-popup d-flex" style="position: relative;width: 7%;left: 80%;transform: translate(0px, 37px);">
<span class="fa fa-shopping-cart small-cart-bh">
 
        <div class="min-cart-product-wrapper popup-content">
          <div>
            <a>{{get_count(product.id)>0?"":"Select Size"}}</a>
        </div>
        <div class="row justify-content-center" style="margin: 5px" *ngFor="let cart of get_prod(product.id); let i = index;">
          <!-- {{cart.product.parent.id}} -->
            <div class="col-10 isempty">
          <h6 style="font-size: 12px;">{{cart.product_name}}</h6>
          <p style="font-size: small;"> {{cart.quantity}} 
              <span style="font-size: smaller;padding-right: 5px;">&#x292C;</span>₹{{cart.cost | number : '1.2-2'}}</p>
             </div>
        </div>
        </div>
        

</span>
<!-- <div style="height:50px; margin-top:7%">
  <span class="fa fa-shopping-cart small-cart-bh-2">
    <div *ngFor="let pro of this.appService.cartProducts.results;let i=index" class="summary-bh">
      <div *ngIf="pro.product_id==product.id" class="isempty">
        <div *ngFor="let c of pro.subcart;let j=index">
          <a>{{pro.subcart[j]}} x{{pro.subquantity[j]}}</a>
        </div>
      </div>
    </div>
    <div *ngIf="!this.appService.subProductinCart.includes(product.subname)"  class="summary-bh">
      <a>Select Size</a>
    </div>
  </span>
</div> -->
</li>
    </div>
    <!-- <div *ngIf="!special_add_cart">
      <button class="button-62" [disabled]="" style="margin-left: 79px;margin-top: 10px;background: gray;" >
      Add to Cart
      </button>  
    </div> -->
   
    <div *ngIf="product.current_index==-1">
      <button class="button-62" [disabled]="product.current_index==-1" style="margin-left: 79px;margin-top: 10px;" >
      Add to Cart
      </button>  
     </div>
     <div *ngIf="product.current_index!==-1">
    <div *ngFor="let price of product.variant.option_values[product.current_index!=-1?product.current_index:0].child;let i = index">
       <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id) ==
       -1" class="button-62" [disabled]="product.current_index==-1" style="margin-left: 79px;margin-top: 10px;" (click)="addToCartSpecialWires(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id )" >
       Add to Cart
       </button>
     <!-- </div> -->
    
      </div>
      <div *ngFor="let rate of appService.cartProducts.results;let j = index">
        <div class="btn btn-primary inq-btn-st specialViewCart" style="background-color: #2177b8f2!important;" id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id) != -1 && (rate.product_id == product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id)">
        <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id))"></i></span>
        <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
        (input)="changeSpecial1Value(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=-1?product.child_index:0].id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id)].quantity" />
         <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItemNew(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=-1?product.current_index:0].child[product.child_index!=null?product.child_index:0].id))"></i></span>
        </div>
      </div>
       </div>
   
<!-- <div class="" style="display: flex; justify-content: center;margin-bottom: 20px;" *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index">

<button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
-1" class="button-62"  (click)="addToCartcarience(price.id)" >
Add to Cart
</button>   

<div class="btn btn-primary inq-btn-st specialViewCart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
<span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
<span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
<span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 
</div>
</div> -->
</div>
</div>
<div *ngIf="product.product_type=='Simple'"  class="product-list-cards-specialwires2">
  <div class="product-list-cards-specialwires1" style="color: lightgray">
    <div class="special-img">
  
  <img [src]="product.assets[0].image_source" id="img-list"
  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
  class="product-list-image-specialwires"/>
  </div>
  </div>
  <div class="specialwires-description">
    <div id="img-list" style="flex-basis: 100%;justify-content: center;
    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
    }}" container="body" *ngIf="fields[1].visibility">
  <div class="d-flex justify-content-between">
    <div class="cariencetitle">
      <p class="product-list-tile3" style="margin-top: 30px;" (click)="productDetails(product.id)">{{product.name}}</p>
    </div>
  </div>
  </div>
  <div class="d-flex justify-content-center"><p style="font-size: 12px; transform: translate(0px, 20px);color: red;margin-top: 20px;">Custamizable as per requirement</p></div>
  <div class="d-flex justify-content-between">
  <button class="button-62" (click)="submitEnquiryForSpecial(product)" style=" margin-left: 79px;margin-top: 70px;">
    Submit Enquiry
    </button> 
  
  
  <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
  <div *ngFor="let cart of appService.cartProducts.results; let i = index">
  <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
  <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
  <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
  <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
  </div>
  </div>
  </div>
  </div>
  </div>
        
        </div>
  </div>
</div>
</div>
</div>
</div>
<div *ngIf="totalLength < 1">
<img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
</div>
</div>
<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
style="float: right" id="pagination-controls"></pagination-controls>
</div>
  </section >
  <section class="row special-listing-width" id="productRow"  style="margin-left: 10px;" *ngIf="CONFIG.title === 'Babys Pride'" >
    <div style="max-width: 20%;flex: 0 0 22%;">
    <div class="inq-menu-left-st">
      <div class="collection-filter">
        <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
            [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
            [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">
          </app-product-filter>
        
      </div>
    </div>
  </div>
  <div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'Babys Pride'"
  style="padding-right: 0px !important; padding-left: 0px !important;margin-top: 20px;">
 
  <div>
    <div class="inq-menu-right-st">
      <h2 class="text-primary" id="productListHead" style="color: #bb086c !important;margin-left: 9px;">Products</h2>
      <div class="breadCrumbListing">
        <span class="home-breadcrumb" routerLink="">Home</span>
        <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
      </div>
      <span *ngIf="allInOneData[1]=='' || allInOneData[1] == undefined" style="font-family: system-ui;font-size: 12px;font-weight: 600;color: gray;margin-left: 10px;">DRESSES FOR All</span>
      <span *ngIf="allInOneData[1]!=='' && allInOneData[1] !== undefined" style="font-family: system-ui;font-size: 12px;font-weight: 600;color: gray;margin-left: 10px;">DRESSES FOR {{allInOneData[1]}}</span>
      <div *ngIf="totalLength > 0" class="thumb1-baby">
        <div style="margin-right: 10px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
          <div class="row inq-pro-sec-st listProduct">
  <div *ngIf="CONFIG.title === 'Babys Pride'" class="deera-container">
    <div class="product-list-cards-baby" style="color: lightgray;box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);">
      <div class="baby-img button-overlay">
  
        <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="product-list-image-baby2" />
          <div *ngIf="product.is_new_arrival == true" class="add_baby-btn">
            <div style=" width: 42px; height: 18px; border-radius: 10px;background-color:#9b0858; margin-left: 5px;" class="baby_newone"><p style="text-align: center;color: white;font-size: 12px;font-weight: 400;">NEW</p></div>
          </div>
          <span class="add_schift-btn" (click)="productDetails(product.id)">
                
            <div class="babymarker" style=" background-color: #b90870;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 10%;">
              
          </span></div>
            </span>
      </div>
      <div class="product-list-description-baby2">
        <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
          id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
          }}" container="body" *ngIf="fields[1].visibility">
          <div class="d-flex justify-content-between">
            <div>
              <p (click)="productDetails(product.id)" class="product-list-tile-baby1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
              </p>
            </div>
          </div>
        </div>
  
        <div class="d-flex justify-content-between mt-1">
          <div>
            <span class="col-right" *ngIf="product.variant.option_values">
            <div style="display: flex;"> 
              <span style="font-size: 14px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}.00</span>
              <p class="product-list-price-baby" >
                  ₹{{product.variant.option_values[0].pricing.raw.price}}
            </p>
          </div>  
        </span>
          <!-- <span *ngFor="let items of product.variant.option_values; let j = index">
              <span  *ngIf="appService.productIdinCart.indexOf(items.id) != -1">
                <span *ngFor="let cart of appService.cartProducts.results; let i = index">
                  <span *ngIf="cart.product_id === items.id" style="display: flex;">
                    <span *ngIf="items.is_default">
                        <p class="product-list-price1">₹{{ cart.product.pricing.raw.price| number : "1.2-2"}}
  
                    </p>
                  </span>
                  </span>
                </span>
                </span>
              </span> -->
          </div>
          <!-- <div class="inner-star-icon review-mob pd-1">
            <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          </div> -->
        </div>
        <!-- <div class="col-right" id="simple" *ngIf="CONFIG.title ==='Babys Pride'">
          <div class="col-right">
            <p class="sizeText">{{ product.variant.name }} :</p>
          </div>
          <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
            <button type="button" id="button" 
              class="btn btn-primary sizebox sizebutton" [class.active]="items.is_default" (click)="onConfirm1(product,items,items.id,j)" value="items.id">
              {{ items.option }}
            </button>
            <hr />
          </div>
        </div> -->
        <!-- <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
      justify-content: center;">
  
        <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="deera-atc1" (click)="addToCartBaby(price.id,product)" [disabled]="isDisabled">
        ADD TO CART
        <span> <i class="fa fa-shopping-cart"></i></span>
        </button>   
        
        
        <div [class]="CONFIG.title == 'Babys Pride'? 'DeeraviewCart' : 'mayanviewCart'" style="font-size: small;font-weight: bold;width: 56%;margin-top: 12px;text-align: center;" 
         *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
            
              <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                  (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
          <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
          (input)="changeBabyVarValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
              <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
  
  
            </div>
        </div> -->
      </div>
    </div>     
  
    </div>
  </div>
  </div>
  </div>
  </div>
  <div *ngIf="totalLength < 1">
  <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
  </div>
  </div>
  <div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
     id="pagination-controls"></pagination-controls>
  </div>
</div>
<div class="col-md-12 desk" *ngIf="CONFIG.title === 'Babys Pride'"
style="padding-right: 0px !important; padding-left: 0px !important; max-width: 77%;">

<div>
  <div class="inq-menu-right-st">
    <!-- <h2 class="text-primary" id="productListHead" style="color: #bb086c !important">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div> -->
    <div style="display: flex;">
      <div>
    <span *ngIf="allInOneData[1]=='' || allInOneData[1] == undefined" style="font-family: system-ui;font-size: 14px;font-weight: 600;color: gray;">DRESSES FOR All</span>
    <span *ngIf="allInOneData[1]!=='' && allInOneData[1] !== undefined" style="font-family: system-ui;font-size: 14px;font-weight: 600;color: gray;">DRESSES FOR {{allInOneData[1]}}</span>
  </div>
    <div class="sort" [formGroup]="sortingForm">
      <p style="margin-right: 10px;font-size: 13px;font-weight: 700;color: gray;">SORT BY </p>
      
      <select style="font-family: system-ui;font-weight: 500;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
        <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
      </select>
    <!-- <select style="font-family: system-ui;font-weight: 500;" id=" SORT BY" *ngIf="sort_selected === false"  (change)="selectSort($event.target.value)"  >
      <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" style="font-size: 12px;font-family: system-ui;">{{sorting.name}}</option>
    </select> -->
  </div>
  </div>
    <div *ngIf="totalLength > 0" class="thumb1-baby">
      <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <!-- <div >Dresses for All</div> -->
     
        <div class="row inq-pro-sec-st listProduct1">
<div *ngIf="CONFIG.title === 'Babys Pride'" class="deera-container">
  
  <div class="product-list-cards-baby2" style="color: lightgray;box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);margin-top: 15px;">

    <div class="deera-img button-overlay" style="height: 100%;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-baby1" />
        <span class="add_schift-btn" (click)="productDetails(product.id)">
                
          <span style=" background-color: #b90870;display: block; width: 24px;padding-right: 2px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 10%;">
            
        </span></span>
          </span>
          <div *ngIf="product.is_new_arrival == true" class="add_baby-btn">
            <div style="width: 50px;height: 22px; border-radius: 10px;background-color:#9b0858; margin-left: 10px;" class="baby_newone"><p style="text-align: center;color: white;font-size: 13px;font-weight: 400;">NEW</p></div>
          </div>
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div class="d-flex justify-content-between">
          <!-- <div> -->
          <div>
            <p (click)="productDetails(product.id)" class="product-list-tile-baby1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
            </p>
          </div>
          <!-- <div> -->
          <!-- <p [class]="CONFIG.title=='Deera' list-label? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="d-flex justify-content-between mt-1">

          <span class="col-right">
          <div style="display: flex;"> 
          <span style="font-size: 15px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}</span>
            <p class="product-list-price-baby" >
                ₹{{product.variant.option_values[0].pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
        <!-- <span *ngFor="let items of product.variant.option_values; let j = index">
            <span  *ngIf="appService.productIdinCart.indexOf(items.id) != -1">
              <span *ngFor="let cart of appService.cartProducts.results; let i = index">
                <span *ngIf="cart.product_id === items.id" style="display: flex;">
                  <span *ngIf="items.is_default">
                      <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
                    <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ cart.product.pricing.raw.msrp }}</span>
                    <span style="font-size: 14px !important;margin-left: 3px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / cart.product.unit | number : "1.2-2"}}/piece</span>

                  </p>
                </span>
                </span>
              </span>
              </span>
            </span> -->
        <!-- <div class="inner-star-icon review-mob pd-1">
          <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
        </div> -->
      </div>
      <!-- <div class="col-right" id="simple" *ngIf="CONFIG.title ==='Babys Pride'">
        <div class="col-right">
          <p class="sizeText">{{ product.variant.name }} :</p>
        </div>
        <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
          <button type="button" id="button" 
            class="btn btn-primary sizebox sizebutton" [class.active]="items.is_default" (click)="onConfirm1(product,items,items.id,j)" value="items.id">
            {{ items.option }}
          </button>
          <hr />
        </div>
      </div> -->
      <!-- <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
    justify-content: center;">

      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="deera-atc1" (click)="addToCartBaby(price.id,product)" [disabled]="isDisabled">
      ADD TO CART
      <span> <i class="fa fa-shopping-cart"></i></span>
      </button>   
      
      
      <div [class]="CONFIG.title == 'Babys Pride'? 'DeeraviewCart' : 'mayanviewCart'" style="font-size: small;font-weight: bold;width: 56%;margin-top: 12px;text-align: center;" 
       *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
          
            <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
        <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
        (input)="changeDeeraVarValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
            <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>


          </div>
      </div> -->
    </div>
  </div>     

  </div>
</div>
</div>
</div>
</div>
<div *ngIf="totalLength < 1">
<img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
</div>
</div>
<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
style="float: right" id="pagination-controls"></pagination-controls>
</div>
  </section >
  <section class="special-listing-width senb_prod_left" id="productRow" *ngIf="CONFIG.title === 'SriSenbaga'" >
    <div style="max-width: 20%;flex: 0 0 22%;">
    <div class="inq-menu-left-st">
      <div class="collection-filter">
        <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
            [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
            [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [author]="author" [categoriesList]="categoryList" [configTitle]="CONFIG.title">
          </app-product-filter>
        
      </div>
    </div>
  </div>
  <div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'SriSenbaga'"
  style="padding-right: 10px !important; padding-left: 0px !important;">
 
  <div>
    <div class="inq-menu-right-st">
      <h2 class="text-primary" id="productListHead" style="color: #303571 !important;margin-left: 9px;">Products</h2>
      <div class="breadCrumbListing">
        <span class="home-breadcrumb" routerLink="">Home</span>
        <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
      </div>
      <div *ngIf="totalLength > 0" class="thumb1-baby" style="width: 100%;padding-left: 4px;">
        <div style="width: 100%;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageSenbaga, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
          <div class="row inq-pro-sec-st listProduct">
  <div *ngIf="CONFIG.title === 'SriSenbaga'" class="deera-container">
    <div class="product-list-cards-baby" style="color: lightgray;box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);height: 300px;">
      <div class="baby-img button-overlay" style="height: 150px;">
  
        <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
          class="product-list-image-baby2" style="width: 100%;" />
          <!-- <div *ngIf="product.is_new_arrival == true" class="add_baby-btn">
            <div style=" width: 42px; height: 18px; border-radius: 10px;background-color:#9b0858; margin-left: 5px;" class="baby_newone"><p style="text-align: center;color: white;font-size: 12px;font-weight: 400;">NEW</p></div>
          </div> -->
          <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                
            <div class="babymarker" style=" background-color: #c6b716;display: list-item;width: 20px;height: 20px;border-radius: 17px;cursor: pointer;"> <span class="fa fa-shopping-cart" style="position: absolute;font-size: 13px;color: white;top: 17%;margin-left: 17%;">
              
          </span></div>
            </span>
      </div>
      <div class="product-list-description-baby2">
        <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
          id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
          }}" container="body" *ngIf="fields[1].visibility">
          <div >
            <div>
              <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="product-list-tile-baby1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
              </p>
            </div>
          </div>
        </div>
  
        <div class="d-flex mt-1" style="justify-content: center;">
          <div>
            <span class="col-right" >
            <div style="display: flex;"> 
              <span style="font-size: 14px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span>
              <p class="product-list-price-baby" >
                  ₹{{product.pricing.raw.price}}.00
            </p>
          </div>  
        </span>
          </div>
          <!-- <div class="inner-star-icon review-mob pd-1">
            <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
            <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          </div> -->
        </div>
        <div style="display: flex;justify-content: center;">
          <div style="display: flex;">
          <div>
            <button *ngIf="
                appService.productIdinCart.indexOf(product.id) ==
                  -1 &&
                product.product_type == 'Simple' &&
                appService.productIdinCart.indexOf(product.id) ==
                  -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
              Add to Cart
            </button>
            <div *ngFor="
                let cart of appService.cartProducts.results;
                let i = index
              ">
              <div class="btn viewCart_Taz_list" *ngIf="
                  cart.product_id === product.id ||
                  cart.product_id === product.checkVariantInCart
                ">
                <span>
                  <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                    style="font-size: 12px; cursor: pointer;color: white"></i></span>
                <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                  cart.quantity
                  }}</span>
                <span>
                  <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                    style="font-size: 12px; cursor: pointer;color: white;"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>     
  
    </div>
  </div>
  </div>
  </div>
  </div>
  <div *ngIf="totalLength < 1">
  <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
  </div>
  </div>
  <div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
     id="pagination-controls"></pagination-controls>
  </div>
</div>
<div class="col-md-12 desk" *ngIf="CONFIG.title === 'SriSenbaga'"
style="padding-right: 0px !important; padding-left: 0px !important; max-width: 77%;">

<div>
  <div class="inq-menu-right-st">
    <!-- <h2 class="text-primary" id="productListHead" style="color: #bb086c !important">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div> -->
    <div style="display: flex;justify-content: end;">
    <div class="sort" [formGroup]="sortingForm">
      <p style="margin-right: 10px;font-size: 13px;font-weight: 700;color: gray;">SORT BY </p>
      
      <select style="font-family: system-ui;font-weight: 500;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
        <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
      </select>
    <!-- <select style="font-family: system-ui;font-weight: 500;" id=" SORT BY" *ngIf="sort_selected === false"  (change)="selectSort($event.target.value)"  >
      <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" style="font-size: 12px;font-family: system-ui;">{{sorting.name}}</option>
    </select> -->
  </div>
  </div>
    <div *ngIf="totalLength > 0" class="thumb1-baby">
      <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageSenbaga, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <!-- <div >Dresses for All</div> -->
     
        <div class="row inq-pro-sec-st listProduct1 sri_prod">
<div *ngIf="CONFIG.title === 'SriSenbaga'" class="deera-container sri_prod">
  
  <div class="product-list-cards-baby2" style="color: lightgray;box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);margin-top: 15px;height: 370px;">

    <div class="deera-img button-overlay" style="height: 210px;display: flex;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-baby1" style="height: 100%;" />
        <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                
          <span style=" background-color: #303571;display: block; width: 24px;padding-right: 2px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 10%;">
            
        </span></span>
          </span>
          <!-- <div *ngIf="product.is_new_arrival == true" class="add_baby-btn">
            <div style="width: 50px;height: 22px; border-radius: 10px;background-color:#9b0858; margin-left: 10px;" class="baby_newone"><p style="text-align: center;color: white;font-size: 13px;font-weight: 400;">NEW</p></div>
          </div> -->
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div >
          <!-- <div> -->
          <div>
            <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="product-list-tile-baby1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
            </p>
          </div>
          <!-- <div> -->
          <!-- <p [class]="CONFIG.title=='Deera' list-label? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="mt-1">

          <span class="col-right">
          <div style="display: flex;justify-content: center;"> 
          <span style="font-size: 14px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span>
            <p class="product-list-price-baby" >
                ₹{{product.pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
        <!-- <div class="inner-star-icon review-mob pd-1">
          <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
          <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
        </div> -->
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="display: flex;margin-bottom: 10%;">
        <div>
          <button *ngIf="
              appService.productIdinCart.indexOf(product.id) ==
                -1 &&
              product.product_type == 'Simple' &&
              appService.productIdinCart.indexOf(product.id) ==
                -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
            Add to Cart
          </button>
          <div *ngFor="
              let cart of appService.cartProducts.results;
              let i = index
            ">
            <div class="btn viewCart_Taz_list" *ngIf="
                cart.product_id === product.id ||
                cart.product_id === product.checkVariantInCart
              ">
              <span>
                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white"></i></span>
              <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                cart.quantity
                }}</span>
              <span>
                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white;"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>     

  </div>
</div>
</div>
</div>
</div>
<div *ngIf="totalLength < 1">
<img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
</div>
</div>
<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
style="float: right" id="pagination-controls"></pagination-controls>
</div>
  </section >
  <section class="row special-listing-width lush-list-top" style="margin-right: 0px;padding-top: 5%;" *ngIf="CONFIG.title === 'LushNGreen'" >
    <div class="col-md-12 desktop-only lushListPOS">
      <div>
        <div class="lushhomebes1">BEST SELLER</div>
        <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
        <div class="lushhomebes2">Best Seller Product This Week</div>
        <!-- <div class="lushbests" *ngIf="noData" style="display: flex;justify-content: center;">
          <img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" alt="">
        </div> -->
        <div class="lushbests" >
        <div class="thumb2-lushlist">
          
          <div *ngFor="let product of newarrivalLush; let i = index">
            <div style="width: 90%;">
  
              <div class="inq-pro-sec-st listProducthome">
  
                <div class="product-list-cards-baby2" style=" margin-top: 15px;width: 100%;">
  
                  <div class="deera-img button-overlay" style="width: 100%; cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
  
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="newcollection-image-baby"
                      width="100%" />
                  </div>
  
                  <div class="product-list-description-baby1" style="width: 100%;">
                    <div class="d-flex" style="cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                      <!-- <div class="d-flex justify-content-between" style="cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"> -->
                      <div>
                        <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="baby-newcol-name"> {{product.name}}
                        </p>
                      </div>
                    </div>
  
                    <div class="d-flex mt-1" style="justify-content: center;">
  
                      <span class="col-right">
                        <div style="display: flex;">
  
                          <p class="product-list-price-baby"> ₹{{product.pricing.raw.price}}
                          </p>
                          <span class="lush-strikelist">₹{{product.pricing.raw.msrp}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           </div>
    

    </div>
  </div>
      </div>
    </div>
    <div class="col-md-12 mobile-only lushListPOS">
      <div>
        <div class="lushhomebes1">BEST SELLER</div>
        <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
        <div class="lushhomebes2">Best Seller Product This Week</div>
        <div class="lushbests" *ngIf="noData" style="display: flex;justify-content: center;">
          <img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" alt="">
        </div>
        <div class="lushbests"  *ngIf="!noData">
        <div class="thumb2-lushlist">
          
          <div *ngFor="let product of newarrivalLushMobile; let i = index">
            <div style="width: 90%;">
  
              <div class="inq-pro-sec-st listProducthome">
  
                <div class="product-list-cards-Lushnn" style="width: 100%;">
  
                  <div class="deera-img button-overlay" style="width: 100%; cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
  
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="newcollection-image-baby"
                      width="100%" />
                  </div>
  
                  <div class="product-list-description-baby1" style="width: 100%;">
                    <div class="d-flex" style="cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                      <!-- <div class="d-flex justify-content-between" style="cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"> -->
                      <div>
                        <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="baby-newcol-name"> {{product.name}}
                        </p>
                      </div>
                    </div>
  
                    <div class="d-flex mt-1" style="justify-content: center;">
  
                      <span class="col-right">
                        <div style="display: flex;">
  
                          <p class="product-list-price-baby"> ₹{{product.pricing.raw.price}}
                          </p>
                          <span class="lush-strikelist">₹{{product.pricing.raw.msrp}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           </div>
    

    </div>
  </div>
      </div>
    </div>
    <div class="inq-menu-left-st mobile-only">
      <div class="collection-filter" *ngIf="currentCategoryTaz == 'Plants' ">
        <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
            [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
            [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">
          </app-product-filter>
        
      </div>
    </div>
  <div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'LushNGreen'"
  style="padding-right: 0px !important; padding-left: 0px !important;padding-top: 25px;margin-left: 10px; "  id="targetSectionMobile" #targetSectionMobile>
 
  <div>
    <div class="inq-menu-right-st">
      <div class="lushhomebes1">{{currentCategoryTaz}}</div>
<div style="display: flex;justify-content: center;">
<hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
</div>
      <div class="breadCrumbListing">
        <span class="home-breadcrumb" routerLink="">Home</span>
        <span (click)="clearAll()"><i class="px-2">/</i> {{currentCategoryTaz}}</span>
      </div>
      <div *ngIf="totalLength > 0" class="thumb1-baby lushThumbahh" >
        <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
          <div class="row inq-pro-sec-st listProduct">
  <div *ngIf="CONFIG.title === 'LushNGreen'" class="deera-container">
    <div class="product-list-cards-baby" style="color: lightgray;">
      <div class="baby-img button-overlay">
        <div class="listing_Card_Promo">
          <span *ngFor="let product1 of product.discounts_text" class="product_offer_card">
            <span class="schift_key_offer" [innerHTML]="product1.product_card_view_promotion"></span>
          </span>
        </div>
        <img [src]="product.assets[0].image_source" id="img-list"
          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null"
          class="product-list-image-baby2" />
          <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null">
                
            <div class="babymarker" style=" background-color: #a9c70b;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 10%;">
              
          </span></div>
            </span>
      </div>
      <div class="product-list-description-baby2">
        <div  id="img-list" *ngIf="fields[1].visibility">
          <div class="d-flex justify-content-between">
            <div>
              <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null" class="product-list-tile-baby1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1" style="padding-bottom: 15px;" *ngIf="product.product_type=='Simple'">
        <div>
          <span class="col-right">
            <div style="display: flex;"> 
              <p class="product-list-price-baby" >
                ₹{{product.pricing.raw.price}}
          </p>
              <span style="font-size: 13px !important;margin-left: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 2%;">₹{{ product.pricing.raw.msrp }}</span>
              
          </div>  
        </span>
        </div>
        </div>
        <div class="d-flex justify-content-between mt-1" style="padding-bottom: 15px;" *ngIf="product.product_type=='Variable' && !product.variant.option_values[current_index].child ">
          <div>
            <span class="col-right">
            <div style="display: flex;"> 
              <p class="product-list-price-baby" >
                ₹{{product.variant.option_values[0].pricing.raw.price}}
          </p>
              <span style="font-size: 13px !important;margin-left: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 2%;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}</span>
              
          </div>  
        </span>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1" style="padding-bottom: 15px;" *ngIf="product.product_type=='Variable' && product.variant.option_values[current_index].child ">
          <div>
            <span class="col-right">
            <div style="display: flex;"> 
              <p class="product-list-price-baby" >
                ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}
          </p>
              <span style="font-size: 13px !important;margin-left: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 2%;">₹{{ product.variant.option_values[0].child[0].pricing.raw.msrp }}</span>
              
          </div>  
        </span>
          </div>
        </div>
        <!-- <div class="col-right" id="simple" *ngIf="CONFIG.title ==='Babys Pride'">
          <div class="col-right">
            <p class="sizeText">{{ product.variant.name }} :</p>
          </div>
          <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
            <button type="button" id="button" 
              class="btn btn-primary sizebox sizebutton" [class.active]="items.is_default" (click)="onConfirm1(product,items,items.id,j)" value="items.id">
              {{ items.option }}
            </button>
            <hr />
          </div>
        </div> -->
        <!-- <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
      justify-content: center;">
  
        <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="deera-atc1" (click)="addToCartBaby(price.id,product)" [disabled]="isDisabled">
        ADD TO CART
        <span> <i class="fa fa-shopping-cart"></i></span>
        </button>   
        
        
        <div [class]="CONFIG.title == 'Babys Pride'? 'DeeraviewCart' : 'mayanviewCart'" style="font-size: small;font-weight: bold;width: 56%;margin-top: 12px;text-align: center;" 
         *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
            
              <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                  (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
          <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
          (input)="changeBabyVarValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
              <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
  
  
            </div>
        </div> -->
      </div>
    </div>     
  
    </div>
  </div>
  </div>
  </div>
  </div>
  <div *ngIf="totalLength < 1">
  <img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" class="img-fluid1" />
  </div>
  </div>
  <div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" style="float: right;font-size: 14px;" (pageChange)="pageChange($event)"
     id="pagination-controls"></pagination-controls>
  </div>
</div>
<hr class="desk" style="color: #d5d5d5;margin-left: -9px;width: 101%;">
<div class="desk" style="padding-top: 30px; width: 100%;" id="targetSection" #targetSection><div class="lushhomebes1">{{currentCategoryTaz}}</div>
<div style="display: flex;justify-content: center;">
<hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
</div>
<div class="col-md-12 " *ngIf="CONFIG.title === 'LushNGreen'"
style="padding-right: 0px !important; padding-left: 0px !important;display: flex;justify-content: center;margin-top: 15px;">
<div style="max-width: 30%;flex: 0 0 22%;    margin-top: 15px;" *ngIf="currentCategoryTaz == 'Plants' ">
  <div class="inq-menu-left-st" style="padding-right: 0rem !important;">
    <div class="collection-filter">
      <!-- <div class="total-items" id="totalItems">
        <p style="color: #bb086c">
          <span><b style="color: #bb086c">Items found</b></span> - {{ totalItemsOrProducts }}
        </p>
      </div> -->
      
      <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
          [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
          [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">
        </app-product-filter>
      
    </div>
  </div>
</div>
<div>
  <div class="inq-menu-right-st" style="padding-left: 1%;" >
    <!-- <h2 class="text-primary" id="productListHead" style="color: #bb086c !important">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div> -->
    <!-- <div style="display: flex;">
    <div class="sort" [formGroup]="sortingForm">
      <p style="margin-right: 10px;font-size: 13px;font-weight: 700;color: gray;">SORT BY </p>
      
      <select style="font-family: system-ui;font-weight: 500;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
        <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
      </select>
  </div>
  </div> -->
    <div *ngIf="totalLength > 0" class="thumb1-baby">
      <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <!-- <div >Dresses for All</div> -->
     
        <div class="row inq-pro-sec-st listProduct1">
<div *ngIf="CONFIG.title === 'LushNGreen'" class="deera-container">
  
  <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

    <div class="deera-img button-overlay" style="height: 100%;">
      <div class="listing_Card_Promo">
        <span *ngFor="let product1 of product.discounts_text" class="product_offer_card">
          <span class="schift_key_offer" [innerHTML]="product1.product_card_view_promotion"></span>
        </span>
      </div>
      <img [src]="product.assets[0].image_source" id="img-list"
      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null"
      class="product-list-image-baby1" alt="" decoding="async" fetchpriority="high" style="width: 100%;" />
      <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
        class="product-list-image-baby1" /> -->
        <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null">
                
          <span style=" background-color: #a9c70b;display: block; width: 24px;padding-right: 2px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 10%;">
            
        </span></span>
          </span>
    </div>
    
    <div class="product-list-description-baby1">
  

      <div class="d-flex justify-content-between">
        <div style="display: flex;">
          <p 
            (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id, '/' + currentCategoryTaz, product.name + '-' + product.id) : null"
            class="product-list-tile-baby1 tooltip-container">
            {{ metaDataMapService.findData(product, groups[0].fields[1].nestedinfo) | titlecase }}
            <span class="tooltip-text">
              {{ metaDataMapService.findData(product, groups[0].fields[1].nestedinfo) | titlecase }}
            </span>
          </p>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-1" *ngIf="product.product_type=='Simple'">
        <span class="col-right">
          <div style="display: flex;"> 
            <p class="product-list-price-baby" >
              ₹{{product.pricing.raw.price}}
            
        </p>
          <span style="font-size: 13px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 3%;">₹{{ product.pricing.raw.msrp }}</span>
            
        </div>  
      </span>
        </div>

        <div class="d-flex justify-content-between mt-1" *ngIf="product.product_type=='Variable' && !product.variant.option_values[current_index].child ">
          <div>
            <span class="col-right">
            <div style="display: flex;"> 
              <p class="product-list-price-baby" >
                ₹{{product.variant.option_values[0].pricing.raw.price}}
          </p>
              <span style="font-size: 13px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 3%;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}</span>
              
          </div>  
        </span>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1" *ngIf="product.product_type=='Variable' && product.variant.option_values[current_index].child ">
          <div>
            <span class="col-right">
            <div style="display: flex;"> 
              
              <p class="product-list-price-baby" >
                  ₹{{product.variant.option_values[0].child[0].pricing.raw.price}}
            </p>
            <span style="font-size: 13px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;font-weight: 500;margin-top: 3%;">₹{{ product.variant.option_values[0].child[0].pricing.raw.msrp }}</span>
          </div>  
        </span>
          </div>
        </div>
    </div>
  </div>     

  </div>
</div>
</div>
</div>
</div>
<div *ngIf="totalLength < 1">
<!-- <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1 no_image_Lush" /> -->
<img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" class="img-fluid1 no_image_Lush" />
</div>

<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
style="float: right" id="pagination-controls"></pagination-controls>
</div>
</div>
</div>
  </section >
  <section  class=" special-listing-width desktop-only " id="productRow" *ngIf="CONFIG.title === 'Schift Cosmetics'" style="background-color: #f4e9e3;padding-bottom: 100px;width: 100%;">
    <div class="">
      <div>
        <div class="container" >
          <div class="breadCrumbListing" style="margin-top: 15px">
            <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: #777;font-family: sans-serif;zoom: 1;">Home</span>
            <span (click)="clearAll()" style="font-size: 13.8px;color: #777;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>Products</span>
          </div>
          <div style="margin-top: 2%;"><h2 style="margin-bottom: 1em;
            font-weight: 600;font-family: 'Lexend',sans-serif;font-size:1.5rem;color: #000000b3;margin-top: -0.5rem;">{{currentCategoryTaz}}</h2>
            <h1 style="display: none;">{{metaSchiftTitle}}</h1>
            <p style="line-height: 1.6em;color:#000000B3;font-family: 'Hind',sans-serif;font-size:15px;">{{categoryDescription}}
  
            </p>
            </div>
              <!-- <p style="line-height: 1.6em;color:#000000B3;font-family: 'Hind',sans-serif;font-size:15px;">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Dolore eu fugiat nulla pariatur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt.
  
              </p> -->
             
  
        </div>
  <div *ngIf="noData" style="display: flex;justify-content: center;">
<img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" alt="">
  </div>
        <div class="container" style="margin-top: 2%;" *ngIf="!noData">
          <ul class="products" style="display: grid; grid-template-columns: repeat(4,1fr);">
            <li class="product" style="width: 100%;  margin-bottom: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              <div style="text-align: left; width: 90%;" class="button-overlay">
                <div class="listing_Card_Promo">
                  <span *ngFor="let product1 of product.discounts_text" class="product_offer_card">
                    <span class="schift_key_offer" [innerHTML]="product1.product_card_view_promotion"></span>
                  </span>
                </div>
                <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null" alt="" decoding="async" fetchpriority="high" style="width: 100%;cursor: pointer;">
                <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
                
                  <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
                    
                </span></span>
                  </span>
              </div>
              <div  style="text-align: left; width: 90%;">
                <div >
                  <span class="product-category"  style="display: flex;">
                   <div class="product-category" *ngFor="let categories of product.categories" style="font-size: 12px;margin-top: 7px;color: rgb(147, 144, 144); margin-right: 3px;">{{categories.categories}}&nbsp;</div>  
                  </span>
                  <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;height: 40px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;line-height: 1.25;max-height: 40px;text-transform: none;
                  font-size: 1em;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">{{product.name}}</h2>
                  <span class="woocommerce-Price-amount amount" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 12px;"><bdi><span class="woocommerce-Price-currencySymbol">₹</span>{{product.pricing.raw.price}}</bdi></span>
  <!-- <span *ngIf="product.pricing.raw.msrp !== 0" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 14px;color: rgb(150, 148, 148);text-decoration: line-through;margin-left: 10px;">₹{{product.pricing.raw.msrp}}</span> -->
                </div>
  
              </div>
  
            </li>
          </ul>
  
        </div>
      </div>
  
    </div>
  
  </section>
  <section  class="row special-listing-width mobile-only " id="productRow" *ngIf="CONFIG.title === 'Schift Cosmetics'" style="background-color: #f4e9e3;padding-bottom: 100px;">
    <div class="row">
      <div class="col-10" style="min-width: 97%;max-width: 97%;">
        <div class="container" >
          <div class="breadCrumbListing" style="margin-left: 7px;">
            <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: #777;font-family: sans-serif;zoom: 1;">Home</span>
            <span (click)="clearAll()" style="font-size: 13.8px;color: #777;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>Products</span>
          </div>
          <div style="margin-top: 2%;"><h2 style="margin-bottom: 1em; margin-left: 20px; margin-top: 10px;
            font-weight: 600;font-family: 'Lexend',sans-serif;font-size: 25px;color: #000000b3;">{{currentCategoryTaz}}</h2>
            </div>
            <!-- <div>
              <p style="line-height: 1.6em;color:#565555b3;font-family: 'Hind',sans-serif;font-size:13px;margin-left: 20px;">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Dolore eu fugiat nulla pariatur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt.
  
              </p>
            </div> -->
                   <div>
              <p style="line-height: 1.6em;color:#565555b3;font-family: 'Hind',sans-serif;font-size:13px;margin-left: 17px;">{{categoryDescription}}
              </p>
            </div>
        </div>
        <div *ngIf="noData" style="display: flex;justify-content: center;">
          <img src="../../../../../assets/images/schift/comingsoon-removebg-preview.png" alt="">
            </div>
        <div class="container" style="margin-top: 5%;padding-right: 4px;">
          <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
            <li class="product" style="width: 100%; margin-bottom: 10px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              
              <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
                <div class="listing_Card_Promo">
                  <span *ngFor="let product1 of product.discounts_text" class="product_offer_card">
                    <span class="schift_key_offer" [innerHTML]="product1.product_card_view_promotion"></span>
                  </span>
                </div>
                <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" alt="" decoding="async" fetchpriority="high" style="width: 100%;">
                <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
                
                  <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
                    
                </span></span>
                  </span>
              </div>
             
              <div style="text-align: left; width: 90%;margin-left: 12px;">
                <div >
                  <span class="product-category"  style="display: flex;">
                   <div class="product-category" *ngFor="let categories of product.categories" style="font-size: 8px;margin-top: 7px;color: rgb(147, 144, 144); margin-right: 3px;">{{categories.categories}}&nbsp;</div>  
                  </span>
                  <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;height: 40px;
                  font-size: 15px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;line-height: 1.25;max-height: 50px;text-transform: none;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">{{product.name}}</h2>
                  <span class="woocommerce-Price-amount amount" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 12px;"><bdi><span class="woocommerce-Price-currencySymbol">₹</span>{{product.pricing.raw.price}}</bdi></span>
  
                </div>
  
              </div>
  
            </li>
          </ul>
  
        </div>
      </div>
  
    </div>
  
  </section>
  <section  class=" special-listing-width desktop-only " id="" *ngIf="CONFIG.title === 'HOB' || CONFIG.title === 'PaulCaroline'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;">
   <div *ngIf="CONFIG.title === 'HOB'">
    <!-- <div class="banner_hob" style="width: 100%;" *ngFor="let banner of desk_images; let i=index;" >
      <img   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{banner.image_source}}" alt="{{banner.alt_text}}">
    </div> -->
    <div class="banner_hob" style="width: 100%;" >
      <!-- <img   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{banner.image_source}}" alt="{{banner.alt_text}}"> -->
      <img *ngIf="listingbanner"   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{listingbanner}}">
      <img *ngIf="!listingbanner"   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{desk_images[0].image_source}}">
    </div>
      <div class="listingban_content_hob">
        <div>
          <div style="display:flex;justify-content: center;">
            <div>
              <!-- <p *ngIf="allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts' " style="line-height: 85px;text-align: center;font-size: 71px;color: #ffffff;font-weight: 300;font-family: system-ui;">Unite in Style.<br> Fashion for <strong style="font-size: 77px;color: #ffffff;font-weight: 750;font-family: system-ui;">Him</strong>.</p> -->
              <!-- <p *ngIf="allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear' " style="line-height: 85px;text-align: center;font-size: 71px;color: #ffffff;font-weight: 300;font-family: system-ui;">Unite in Style.<br> Fashion for <strong style="font-size: 77px;color: #ffffff;font-weight: 750;font-family: system-ui;">Her</strong>.</p> -->
            </div>
          </div>
        </div>
    </div>
   </div>
   <div *ngIf="CONFIG.title === 'PaulCaroline'">
    <div class="banner_hob" style="width: 100%;" >
      <!-- <img   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{banner.image_source}}" alt="{{banner.alt_text}}"> -->
      <img *ngIf="listingbanner"   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{listingbanner}}">
      <img *ngIf="!listingbanner"   style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{desk_images[0].image_source}}">
    </div>
   </div>
    
   

  <div style="margin-left: 6%; margin-top: 5%; margin-bottom: 1%;" id="targetSection" #targetSection>
    <p style="font-size: 28px;font-weight: 700;font-family: system-ui;text-transform: uppercase;" *ngIf="allInOneData[1] !==[] && allInOneData[1]!==null">
      {{currentCategoryHOB}}
    </p>
    <p style="font-size: 28px;font-weight: 700;font-family: system-ui;text-transform: uppercase;" *ngIf="(allInOneData[1] ==[] || allInOneData[1]==null) && CONFIG.title === 'HOB'">
      House of Bold
    </p>
    <p  style="font-size: 28px;font-weight: 700;font-family: system-ui;text-transform: uppercase;" *ngIf="(allInOneData[1] ==[] || allInOneData[1]==null) && CONFIG.title === 'PaulCaroline'">
      Paul Caroline
    </p>
    <p style="font-size: 27px;font-family:system-ui;font-weight: 400;">COLLECTIONS</p>
  </div>
<div  class="grid-hob" *ngIf="CONFIG.title === 'HOB'" >
  <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType().slice(0,6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
     
        <div class="row inq-pro-sec-st listProduct1 hob_prod">
<div class="deera-container hob_prod">
  
  <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

    <div class="deera-img button-overlay" style="display: flex;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-hob" style="height: 100%;" />
        <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                
          <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
            
        </span></span>
          </span>
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div >
          <div>
            <p (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-1">

          <span class="col-right">
          <div style="display: flex;justify-content: center;"> 
          <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
            <p class="product-list-price-hob" >
                ₹{{product.pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="display: flex;margin-bottom: 10%;">
        <div>
          <button *ngIf="
              appService.productIdinCart.indexOf(product.id) ==
                -1 &&
              product.product_type == 'Simple' &&
              appService.productIdinCart.indexOf(product.id) ==
                -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
            Add to Cart
          </button>
          <div *ngFor="
              let cart of appService.cartProducts.results;
              let i = index
            ">
            <div class="btn viewCart_Taz_list" *ngIf="
                cart.product_id === product.id ||
                cart.product_id === product.checkVariantInCart
              ">
              <span>
                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white"></i></span>
              <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                cart.quantity
                }}</span>
              <span>
                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white;"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>     

  </div>
</div>
</div>

</div>
<div  class="grid-hob"  *ngIf="CONFIG.title === 'PaulCaroline' && (allInOneData[1] == 'Men' || allInOneData[1] == 'Women' || allInOneData[1] == 'Men Round Neck' || allInOneData[1] == 'Women Round Neck')">
  <div  *ngFor="let product of filterItemsOfType()  | paginate: {id: 'pagination-controls', itemsPerPage: countPerPagePaul, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
     
        <div class="row inq-pro-sec-st listProduct1 hob_prod">
<div class="deera-container hob_prod">
  
  <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

    <div class="deera-img button-overlay" style="display: flex;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-hob" style="height: 100%;" />
        <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                
          <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
            
        </span></span>
          </span>
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div >
          <div>
            <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-1">

          <span class="col-right">
          <div style="display: flex;justify-content: center;"> 
          <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
            <p class="product-list-price-hob" >
              £ {{product.pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="display: flex;margin-bottom: 10%;">
        <div>
          <button *ngIf="
              appService.productIdinCart.indexOf(product.id) ==
                -1 &&
              product.product_type == 'Simple' &&
              appService.productIdinCart.indexOf(product.id) ==
                -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
            Add to Cart
          </button>
          <div *ngFor="
              let cart of appService.cartProducts.results;
              let i = index
            ">
            <div class="btn viewCart_Taz_list" *ngIf="
                cart.product_id === product.id ||
                cart.product_id === product.checkVariantInCart
              ">
              <span>
                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white"></i></span>
              <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                cart.quantity
                }}</span>
              <span>
                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white;"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>     

  </div>
</div>
</div>


</div>
<div  class="grid-hob"  *ngIf="CONFIG.title === 'PaulCaroline' && (allInOneData[1] == 'Men Polo' || allInOneData[1] == 'Women Polo')">
  <div  *ngFor="let product of PaulPoloProduct;let i = index">
     
    <div class="row inq-pro-sec-st listProduct1 hob_prod">
<div class="deera-container hob_prod">

<div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

<div class="deera-img button-overlay" style="display: flex;">

  <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetailsPolo(product.id,poloid)"
    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
    class="product-list-image-hob" style="height: 100%;" />
    <span class="add_schift-btn" (click)="productDetailsPolo(product.id,poloid)">
            
      <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
        
    </span></span>
      </span>
</div>

<div class="product-list-description-baby1">
  <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
    id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
    }}" container="body" *ngIf="fields[1].visibility">
    <div >
      <div>
        <p (click)="productDetails(product.id)" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
        </p>
      </div>
    </div>
  </div>

  <div class="mt-1">

      <span class="col-right">
      <div style="display: flex;justify-content: center;"> 
      <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
        <p class="product-list-price-hob" >
          £ {{product.pricing.raw.price}}.00
          
      </p>
    </div>  
  </span>
  </div>
  <div style="display: flex;justify-content: center;">
    <div style="display: flex;margin-bottom: 10%;">
    <div>
      <button *ngIf="
          appService.productIdinCart.indexOf(product.id) ==
            -1 &&
          product.product_type == 'Simple' &&
          appService.productIdinCart.indexOf(product.id) ==
            -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
        Add to Cart
      </button>
      <div *ngFor="
          let cart of appService.cartProducts.results;
          let i = index
        ">
        <div class="btn viewCart_Taz_list" *ngIf="
            cart.product_id === product.id ||
            cart.product_id === product.checkVariantInCart
          ">
          <span>
            <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
              style="font-size: 12px; cursor: pointer;color: white"></i></span>
          <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
            cart.quantity
            }}</span>
          <span>
            <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
              style="font-size: 12px; cursor: pointer;color: white;"></i></span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>     

</div>
</div>
</div>

</div>
<div *ngIf="CONFIG.title === 'PaulCaroline'">
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)" style="display: flex;justify-content: end;margin-right: 30px;"
     id="pagination-controls"></pagination-controls>
  </div>
<div style="margin-bottom: 40px;">
  <div style="width: 100%;">
    <img  *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts')" style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/hob/BOLDASIA BANNERS-06.jpg" alt="">
    <img  *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear')" style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/hob/BOLDASIA BANNERS-02.jpg" alt="">
    <img  *ngIf="CONFIG.title === 'PaulCaroline'" style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/paulc/paulc_banner.jpg" alt="">
  </div>
  <div class="home_2btn_hob">
    <div style="display: flex;justify-content: center;margin-bottom: 20px;">
      <!-- <p *ngIf="CONFIG.title === 'HOB'"  style="line-height: 50px;text-align: center;font-size: 60px;color: white;font-weight: 300;font-family: system-ui;"><strong style="font-size: 60px;color: white;font-weight: 600;font-family: system-ui;margin-right: 4px;">BOLD</strong>  ARRIVALS</p> -->
      <p *ngIf="CONFIG.title === 'PaulCaroline'"  style="line-height: 50px;text-align: center;font-size: 60px;color: black;font-weight: 300;font-family: system-ui;"><strong style="font-size: 60px;color: black;font-weight: 600;font-family: system-ui;margin-right: 4px;">PREMIUM </strong>  T-SHIRTS</p>
    </div>
    <div style="display: flex;justify-content: center;">
  <!-- <button class="bann_but_hob" *ngIf="CONFIG.title === 'HOB'">
  SHOP NOW
  </button> -->
  <button class="bann_but_hob"  *ngIf="CONFIG.title === 'PaulCaroline'">
    SHOP NOW
    </button>
    </div>
  </div>
</div>
<div style="display: grid; grid-template-columns: repeat(3,1fr);margin-left: 20px;" *ngIf="CONFIG.title !== 'PaulCaroline'">
  <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType().slice(6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
     
        <div class="row inq-pro-sec-st listProduct1 hob_prod">
<div class="deera-container hob_prod">
  
  <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

    <div class="deera-img button-overlay" style="display: flex;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-hob" style="height: 100%;" />
        <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                
          <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
            
        </span></span>
          </span>
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div >
          <div>
            <p (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-1">

          <span class="col-right">
          <div style="display: flex;justify-content: center;"> 
          <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
            <p class="product-list-price-hob" >
                ₹{{product.pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="display: flex;margin-bottom: 10%;">
        <div>
          <button *ngIf="
              appService.productIdinCart.indexOf(product.id) ==
                -1 &&
              product.product_type == 'Simple' &&
              appService.productIdinCart.indexOf(product.id) ==
                -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
            Add to Cart
          </button>
          <div *ngFor="
              let cart of appService.cartProducts.results;
              let i = index
            ">
            <div class="btn viewCart_Taz_list" *ngIf="
                cart.product_id === product.id ||
                cart.product_id === product.checkVariantInCart
              ">
              <span>
                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white"></i></span>
              <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                cart.quantity
                }}</span>
              <span>
                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white;"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>     

  </div>
</div>
</div>
</div>
<div *ngIf="CONFIG.title !== 'PaulCaroline'">
  <!-- <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)" style="display: flex;justify-content: end;margin-right: 30px;"
     id="pagination-controls"></pagination-controls> -->
     <div style="display: flex;justify-content: center;">
      <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
      </div>
  </div>
  <div style="margin-top: 40px;" *ngIf="CONFIG.title!=='PaulCaroline'">
    <div style="width: 100%;">
      <img  *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts')" style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/hob/BOLDASIA BANNERS-08.jpg" alt="">
      <img  *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear')" style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/hob/BOLDASIA BANNERS-07.jpg" alt="">
    </div>
    <!-- <div class="listing_shopbtn_hob">
      <div style="display: flex;justify-content: end;">
      <div style="width: 55%;">
        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <p class="hob_detail_off_cont1">EXTRA <strong class="hob_detail_off_contbold">20% OFF *</strong></p>
        </div>
        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <p class="hob_detail_off_cont2">SELECTIVE ITEMS</p>
        </div>
        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <p class="hob_detail_off_cont3">* <span class="hob_detail_off_cont4">C</span>onditions apply</p>
        </div>

      <div style="display: flex;justify-content: center;">
    <button class="bann_but_hob">
    SHOP NOW
    </button>
      </div>
    </div>
      </div>
    </div> -->
  </div>
  </section>
  <section  class=" special-listing-width mobile-only " id="" *ngIf="CONFIG.title === 'HOB'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;">
    <div *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear')">
      <div class="banner_hob" style="width: 100%;" *ngFor="let banner of mobilewomenBanner; let i=index;">
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{banner.image_source}}" alt="{{banner.alt_text}}">
      </div>
    </div>
    <div *ngIf="CONFIG.title === 'HOB' && (allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts')">
      <div class="banner_hob" style="width: 100%;" *ngFor="let banner of mobilemenBanner; let i=index;">
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{banner.image_source}}" alt="{{banner.alt_text}}">
      </div>
    </div>
   

  <div style="margin-left: 3%; margin-top: 5%; margin-bottom: 1%;">
    <p style="font-size: 24px;font-weight: 700;font-family: system-ui;text-transform: uppercase;">
      {{currentCategoryHOB}}
    </p>
    
    <p style="font-size: 23px;font-family:system-ui;font-weight: 400;">COLLECTIONS</p>
  </div>
<!-- <div style="display: grid; grid-template-columns: repeat(2,1fr);margin-left: 20px;">
  <div style="margin-right: 20px;margin-top: 7%;" *ngFor="let product of filterItemsOfType().slice(0,6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
     
        <div class="row inq-pro-sec-st listProduct1 hob_prod">
<div class="deera-container hob_prod">
  
  <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">

    <div class="deera-img button-overlay" style="display: flex;">

      <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
        class="product-list-image-hob" style="height: 100%;" />
        <span class="add_schift-btn" (click)="productDetails(product.id)">
                
          <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
            
        </span></span>
          </span>
    </div>
    
    <div class="product-list-description-baby1">
      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
        }}" container="body" *ngIf="fields[1].visibility">
        <div >
          <div>
            <p (click)="productDetails(product.id)" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
            </p>
          </div>
        </div>
      </div>

      <div class="mt-1">

          <span class="col-right">
          <div style="display: flex;justify-content: center;"> 
            <p class="product-list-price-hob" >
                ₹{{product.pricing.raw.price}}.00
              
          </p>
        </div>  
      </span>
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="display: flex;margin-bottom: 10%;">
        <div>
          <button *ngIf="
              appService.productIdinCart.indexOf(product.id) ==
                -1 &&
              product.product_type == 'Simple' &&
              appService.productIdinCart.indexOf(product.id) ==
                -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
            Add to Cart
          </button>
          <div *ngFor="
              let cart of appService.cartProducts.results;
              let i = index
            ">
            <div class="btn viewCart_Taz_list" *ngIf="
                cart.product_id === product.id ||
                cart.product_id === product.checkVariantInCart
              ">
              <span>
                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white"></i></span>
              <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                cart.quantity
                }}</span>
              <span>
                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                  style="font-size: 12px; cursor: pointer;color: white;"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>     

  </div>
</div>
</div>
</div> -->
<div class="container" style="margin-top: 5%;padding-right: 15px; padding-left: 10px;">
  <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
    <li class="product" style="width: 100%; margin-bottom: 10px;" *ngFor="let product of filterItemsOfType().slice(0,6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
      
      <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
        <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" alt="" decoding="async" fetchpriority="high" style="width: 100%;">
        <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
        
          <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
            
        </span></span>
          </span>
      </div>
     
      <div style="text-align: left; width: 90%;margin-left: 12px;">
        <div >
          <!-- <span class="product-category"  style="display: flex;">
           <div class="product-category" *ngFor="let categories of product.categories" style="font-size: 10px;margin-top: 7px;color: rgb(147, 144, 144); margin-right: 3px;">{{categories.categories}}&nbsp;</div>  
          </span> -->
          <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;
          font-size: 15px;" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">{{product.name  | titlecase}}</h2>
          <span class="woocommerce-Price-amount amount" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 12px;"><bdi><span class="woocommerce-Price-currencySymbol">₹</span>{{product.pricing.raw.price}}</bdi></span>

        </div>

      </div>

    </li>
  </ul>

</div>
<div *ngIf="CONFIG.title === 'HOB'">
  <div style="width: 100%;" *ngIf="allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear'">
    <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="../../../../../assets/images/hob/Femaleprodmid.png" alt="Female Banner">
</div>
<div style="width: 100%;" *ngIf="allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts'">
  <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="../../../../../assets/images/hob/Maleprodmid.png" alt="Male Banner">
</div>
</div>

<div class="container" style="margin-top: 5%;padding-right: 10px; padding-left: 10px;" *ngIf="CONFIG.title === 'HOB'">
  <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
    <li class="product" style="width: 100%; margin-bottom: 10px;" *ngFor="let product of filterItemsOfType().slice(6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
      
      <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
        <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" alt="" decoding="async" fetchpriority="high" style="width: 100%;">
        <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
        
          <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
            
        </span></span>
          </span>
      </div>
     
      <div style="text-align: left; width: 90%;margin-left: 12px;">
        <div >
          <!-- <span class="product-category"  style="display: flex;">
           <div class="product-category" *ngFor="let categories of product.categories" style="font-size: 10px;margin-top: 7px;color: rgb(147, 144, 144); margin-right: 3px;">{{categories.categories}}&nbsp;</div>  
          </span> -->
          <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;
          font-size: 15px;" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">{{product.name}}</h2>
          <span class="woocommerce-Price-amount amount" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 12px;"><bdi><span class="woocommerce-Price-currencySymbol">₹</span>{{product.pricing.raw.price}}</bdi></span>

        </div>

      </div>

    </li>
  </ul>

</div>
<div>
  <!-- <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)" style="display: flex;justify-content: end;margin-right: 30px;"
     id="pagination-controls"></pagination-controls> -->
     <div style="display: flex;justify-content: center;">
      <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
      </div>
  </div>
  <div style="margin-top: 40px;" *ngIf="CONFIG.title === 'HOB'">
      <div style="width: 100%;" *ngIf="allInOneData[1] =='Women' || this.allInOneData[1] =='T-shirts_Tops' || this.allInOneData[1] =='Blouses_Shirts_Dresses' || this.allInOneData[1] =='Pants_Shorts_Skirts' || allInOneData[1] =='Casual Wear'">
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="../../../../../assets/images/hob/Femaleprodbot.png" alt="Female Banner">
    </div>
    <div style="width: 100%;" *ngIf="allInOneData[1] =='Men' || this.allInOneData[1] =='T-shirts_Polo' || this.allInOneData[1] =='Shirts_Jackets' || this.allInOneData[1] =='Pants_Shorts'">
      <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="../../../../../assets/images/hob/Maleprodbot.png" alt="Male Banner">
    </div>
  </div>
  </section>
  <section  class=" special-listing-width mobile-only " id="" *ngIf="CONFIG.title === 'PaulCaroline'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;">
    <div *ngIf="CONFIG.title === 'PaulCaroline'">
      <div class="banner_hob" style="width: 100%;" >
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="{{listingbanner}}" >
      </div>
    </div>
   

  <div style="margin-left: 3%; margin-top: 5%; margin-bottom: 1%;">
    <p style="font-size: 24px;font-weight: 700;font-family: system-ui;text-transform: uppercase;">
      {{allInOneData[1]}}
    </p>
    
    <p style="font-size: 23px;font-family:system-ui;font-weight: 400;">COLLECTIONS</p>
  </div>
<div class="container" style="margin-top: 5%;padding-right: 15px; padding-left: 10px;">
  <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
    <li class="product" style="width: 100%; margin-bottom: 10px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
      
      <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
        <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="productDetails(product.id)" alt="" decoding="async" fetchpriority="high" style="width: 100%;">
        <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
        
          <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
            
        </span></span>
          </span>
      </div>
     
      <div style="text-align: left; width: 90%;margin-left: 12px;">
        <div >
          <!-- <span class="product-category"  style="display: flex;">
           <div class="product-category" *ngFor="let categories of product.categories" style="font-size: 10px;margin-top: 7px;color: rgb(147, 144, 144); margin-right: 3px;">{{categories.categories}}&nbsp;</div>  
          </span> -->
          <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;
          font-size: 15px;" (click)="productDetails(product.id)">{{product.name}}</h2>
          <span class="woocommerce-Price-amount amount" style="font-family: Trebuchet MS, sans-serif;font-weight: 600; font-size: 12px;"><bdi><span class="woocommerce-Price-currencySymbol">£</span>{{product.pricing.raw.price}}</bdi></span>

        </div>

      </div>

    </li>
  </ul>

</div>

<div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)" style="display: flex;justify-content: end;margin-right: 30px;"
     id="pagination-controls"></pagination-controls>
  </div>
  
  </section>
  <section  class=" special-listing-width desktop-only " id="" *ngIf="CONFIG.title === 'Taazah'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;">
  <div class="col-md-12 " *ngIf="CONFIG.title === 'Taazah'"
style="padding-right: 0px !important; padding-left: 0px !important;">
<div>
  <div style="padding-left: 50px;background-color: #1b52a4;width: 100%;height: 50px;padding-top: 1%;margin-top: -1px;">
    <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;">Home</span>
        <span style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>{{currentCategoryTaz}}</span>
  </div>
  <div class="">
    
    <div>

      <div class="container" style="display: flex;justify-content: space-between; margin-left: 7%; margin-right: 5%; width: 90%; margin-top: 1.5%;" >
        
        <div style="margin-top: 2%;">
        <h1 style="margin-bottom: 1em;
          font-weight: 600;font-family: 'Lexend',sans-serif;font-size:25px;color: #1b52a4;margin-top: -0.5rem;">{{currentCategoryTaz}}</h1>
          </div>
          <div class="sort" [formGroup]="sortingForm">
            <select style="font-family: system-ui;font-weight: 500; margin-top: 20px;height: 20px;border: none;color: gray;cursor: pointer;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
              <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;color: gray; cursor: pointer;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
            </select>
        </div>

      </div>

      <div class="container" style="background-color: #f7f7f7 ;margin-left: 7%; margin-right: 0px;">
        <ul class="products" style="display: grid; grid-template-columns: repeat(4,1fr);">
          <li class="product" style="width: 100%;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: taz_increment, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
            <div class="deera-container">

              <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 15px;">
            
                <div class="deera-img button-overlay" style="height: 100%;display: flex;justify-content: center;">
            
                  <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null"
                    onerror="this.onerror=null;this.src='assets/images/taazah/NoImage.png';" alt="{{ product.name }}" title="{{product.name}}"
                    class="product_list_image_taz_list" />
                </div>
                <div class="product-list-description-baby1">
                    <div style="display: flex;text-align: center;justify-content: center;" *ngIf="product.stock_status == 'Available'">
                      <p style="font-size: 12px;color: gray;">{{product.stock_status}} (In Stock)</p>
                  </div>
                  <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                    id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                    }}" container="body" *ngIf="fields[1].visibility">
                    <div style="display: flex;justify-content: center;">
                      <div style="display: flex;text-align: center;justify-content: center;width: 55%;">
                        <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null" class="taz-newcol-name">{{metaDataMapService.findData(product,groups[0].fields[1].nestedinfo) | titlecase}}
                        </p>
                      </div>
                    </div>
                  </div>
            
                  <div class="d-flex mt-1" style="display: flex;justify-content: center;" *ngIf="product.product_type !== 'Variable' ">
            
                      <span class="col-right">
                        <div style="display: flex;justify-content: center; margin-bottom: 10%;" class="justify-center-baby">
                          <p class="taz-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span>
                      </div>
                  </span>
                  
                  </div>
                  <div style="display: flex;">
                  <div style="display: flex;justify-content: space-between; width: 82%; margin-bottom: 7%;margin-left: 7%;">
                  <div>
                    <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null">
                      View Details
                    </button>
                    <button *ngIf="
                        appService.productIdinCart.indexOf(product.id) ==
                          -1 &&
                        product.product_type == 'Simple' &&
                        appService.productIdinCart.indexOf(product.id) ==
                          -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                      Add to Cart
                    </button>
                    <div *ngFor="
                        let cart of appService.cartProducts.results;
                        let i = index
                      ">
                      <div class="btn viewCart_Taz_list" 
     style="width: 100px; display: flex; align-items: center; justify-content: space-around;" 
     *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
  <button style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 32px;border: none;border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
    <i class="fa fa-minus" (click)="decreaseItem(i)"
       style="font-size: 12px; cursor: pointer; color: white; margin-top: 10px;"></i>
  </button>
  <div>
  <span style="color: black; font-size: 12px; width: 30px; display: inline-block; text-align: center;transform: translate(0px, -10%);">
    {{ cart.quantity }}
  </span>
</div>
  <button style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 32px;border: none;border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
    <i class="fa fa-plus" (click)="increaseItem(i)"
       style="font-size: 12px; cursor: pointer; color: white;margin-top: 10px;"></i>
  </button>
</div>
                    </div>
                  </div>
                  <div>
                    <i class="fa fa-shopping-cart" style="color: transparent!important;-webkit-text-stroke: .5px rgb(174, 174, 174);margin-top: 15px;cursor: pointer;font-size: 18px;" (click)="buyNow(product)"></i>
                  </div>
                </div>
              </div>
                </div>
              </div>     
            
              </div>

          </li>
        </ul>

      </div>
<div *ngIf="totalLength < 1">
<img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
</div>
<div style="display: flex;justify-content: center;">
<button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
</div>
</div>
</div>
</div>
<!-- <div class="mobile-only cashback_container_taz">
  <div class="code_number_taz">
      <p class="taz_offcod">USE CODE : T A A Z A S U P E R 0 0 1</p>    
  </div>
  <div class="cashback_img_taz">
      <img src="../../../../assets/images/taazah/taz2mob.png">
  </div>
</div>  -->
 
  </div>
 
</section>
  <div  *ngIf="CONFIG.title === 'Taazah'" class="desktop-only" style="background-color: #f7f7f7;" >
    <div style=" display: flex;justify-content: center;padding-bottom: 50px;" >
      <div class="cashback_container_taz" style="width: 95%;">
        <!-- <div class="code_number_taz">
            <h3>USE CODE : T A A Z A S U P E R 0 0 1</h3>    
        </div> -->
        <div class="cashback_img_taz">
            <img src="../../../../assets/images/taazah/taz2.jpg" alt="Offer Banner" title="Offer Banner">
        </div>
        </div>
    </div>
  </div>
  <section  class=" special-listing-width desktop-only " id="" *ngIf="CONFIG.title === 'UrbanBox'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;padding-left: 4%;padding-right: 4%;">
    <div class="col-md-12 " *ngIf="CONFIG.title === 'UrbanBox'"
  style="padding-right: 0px !important; padding-left: 0px !important;">
  <div>
    <!-- <div style="padding-left: 50px;background-color: #1b52a4;width: 100%;height: 50px;padding-top: 1%;">
      <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;">Home</span>
          <span style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>{{allInOneData[1]}}</span>
    </div> -->
    <div class="">
      
      <div>
  
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 0%; padding-top: 2%;padding-left: 0px;padding-right: 0px;" >
          
          <!-- <div style="margin-top: 2%;">
          <h1 style="margin-bottom: 1em;
            font-weight: 600;font-family: 'Lexend',sans-serif;font-size:25px;color: #1b52a4;margin-top: -0.5rem;">{{allInOneData[1]}}</h1>
            </div> -->
            <!-- <div class="sort" [formGroup]="sortingForm">
              <select style="font-family: system-ui;font-weight: 500; margin-top: 20px;height: 20px;border: none;color: gray;cursor: pointer;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
                <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;color: gray;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
              </select>
          </div> -->
          <p style="font-size: 26px;color: #820000;font-weight: 500;font-family: sans-serif;"><span style="font-size: 26px;color: #820000;font-weight: 500;font-family: sans-serif;cursor:pointer;" (click)="selectAllSrima()">Products /</span>
            <span style="font-size: 26px;color: #820000;font-weight: 500;font-family: sans-serif;margin-left: 2px;">{{currentCategory}}</span></p>
        </div>
        <div class="tabs_srima">
          <ul style="display: grid;grid-template-columns: repeat(7, 1fr);justify-content: space-between;flex-wrap: wrap;margin-bottom: 0px;">
            <li [class.active]="selectedTab === -1" (click)="selectAllSrima()" class="srima_tab">
              All
            </li>
            <li *ngFor="let category of allCategoriesSri; let i = index" class="srima_tab"
                [class.active]="i === selectedTab"
                (click)="selectTab(i,category.name)">
              {{ category.name }}
            </li>
          </ul>
        </div>
        <div  class="grid-hob" *ngIf="CONFIG.title === 'UrbanBox'" >
          <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType().slice(0,6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
             
                <div class="row inq-pro-sec-st listProduct1 hob_prod">
        <div class="deera-container hob_prod">
          
          <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 40px;">
        
            <div class="deera-img button-overlay" style="display: flex;">
        
              <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-hob" style="height: 100%;margin: 0px;" />
                <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                        
                  <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
                    
                </span></span>
                  </span>
            </div>
            
            <div class="product-list-description-Urban">
              <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                }}" container="body" *ngIf="fields[1].visibility">
                <div >
                  <div>
                    <p (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
                    </p>
                  </div>
                </div>
              </div>
        
              <div class="mt-1">
        
                  <span class="col-right">
                  <div style="display: flex;justify-content: center;"> 
                  <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                    <p class="product-list-price-hob" >
                        ₹{{product.pricing.raw.price}}.00
                      
                  </p>
                </div>  
              </span>
              </div>
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;margin-bottom: 10%;">
                <div>
                  <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    Buy Now
                  </button>
                  <button *ngIf="
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 &&
                      product.product_type == 'Simple' &&
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                    Add to Cart
                  </button>
                  <div *ngFor="
                      let cart of appService.cartProducts.results;
                      let i = index
                    ">
                    <div class="btn viewCart_Taz_list" *ngIf="
                        cart.product_id === product.id ||
                        cart.product_id === product.checkVariantInCart
                      ">
                      <span>
                        <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white"></i></span>
                      <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                        cart.quantity
                        }}</span>
                      <span>
                        <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white;"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>     
        
          </div>
        </div>
        </div>
        
        </div>
        <div style="margin-top: 40px;">
          <div style="width: 100%;">
            <img style="width: 100%;background-size: cover;color: white;object-fit: cover;cursor: pointer;" src="../../../../../assets/images/hob/BOLDASIA BANNERS-06.jpg" alt="">
          </div>
        </div>
        <div style="display: grid; grid-template-columns: repeat(3,1fr);margin-left: 20px;">
          <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType().slice(6) | paginate: {id: 'pagination-controls', itemsPerPage: countPerPageBold, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
             
                <div class="row inq-pro-sec-st listProduct1 hob_prod">
        <div class="deera-container hob_prod">
          
          <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 40px;">
        
            <div class="deera-img button-overlay" style="display: flex;">
        
              <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-hob" style="height: 100%;margin: 0px;" />
                <span class="add_schift-btn" (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                        
                  <span style=" background-color: #000002;display: block; width: 25px;padding-right: 2px;border-radius: 25px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: white;margin-left: 2%;">
                    
                </span></span>
                  </span>
            </div>
            
            <div class="product-list-description-Urban">
              <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                }}" container="body" *ngIf="fields[1].visibility">
                <div >
                  <div>
                    <p (click)="product.stock_status != 'Out of Stock' ? productDetailsHOB($event,product.id,product.categories[0].categories,product.name+'-'+product.id) : null" class="product-list-tile-hob">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
                    </p>
                  </div>
                </div>
              </div>
        
              <div class="mt-1">
        
                  <span class="col-right">
                  <div style="display: flex;justify-content: center;"> 
                  <!-- <span style="font-size: 16px !important;margin-right: 8px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                    <p class="product-list-price-hob" >
                        ₹{{product.pricing.raw.price}}.00
                      
                  </p>
                </div>  
              </span>
              </div>
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;margin-bottom: 10%;">
                <div>
                  <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    Buy Now
                  </button>
                  <button *ngIf="
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 &&
                      product.product_type == 'Simple' &&
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                    Add to Cart
                  </button>
                  <div *ngFor="
                      let cart of appService.cartProducts.results;
                      let i = index
                    ">
                    <div class="btn viewCart_Taz_list" *ngIf="
                        cart.product_id === product.id ||
                        cart.product_id === product.checkVariantInCart
                      ">
                      <span>
                        <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white"></i></span>
                      <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                        cart.quantity
                        }}</span>
                      <span>
                        <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white;"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>     
        
          </div>
        </div>
        </div>
        </div>
  <div *ngIf="totalLength < 1">
  <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
  </div>
  <div style="display: flex;justify-content: center;">
  <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
  </div>
  </div>
  </div>
  </div>
  <!-- <div class="mobile-only cashback_container_taz">
    <div class="code_number_taz">
        <p class="taz_offcod">USE CODE : T A A Z A S U P E R 0 0 1</p>    
    </div>
    <div class="cashback_img_taz">
        <img src="../../../../assets/images/taazah/taz2mob.png">
    </div>
  </div>  -->
   
    </div>
   
  </section>
  <section  class="row special-listing-width mobile-only " id="productRow" *ngIf="CONFIG.title === 'UrbanBox'" style="padding-bottom: 50px;background-color: #e1e1e1;">
    <div class="">
      <div class="col-10" style="min-width: 97%;max-width: 97%;margin-left: 1%;">
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 1%;margin-bottom: 15px;" >
  <p style="font-size: 20px;color: #820000;font-weight: 500;font-family: system-ui;">Categories</p>
        </div>
        <div class="tabs_srima">
          <ul style="display: grid;grid-template-columns: repeat(3, 1fr);">
            <li [class.active]="selectedTab === -1" (click)="selectAllSrima()" class="srima_tab">
              All
            </li>
            <li *ngFor="let category of allCategoriesSri; let i = index" class="srima_tab"
                [class.active]="i === selectedTab"
                (click)="selectTab(i,category.name)">
              {{ category.name }}
            </li>
          </ul>
        </div>
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 1%;margin-top: 25px;margin-bottom: 25px;" >
          <p style="font-size: 20px;color: #820000;font-weight: 500;font-family: sans-serif;"><span style="font-size: 20px;color: #820000;font-weight: 500;font-family: sans-serif;cursor:pointer;" (click)="selectAllSrima()">Products /</span>
            <span style="font-size: 20px;color: #820000;font-weight: 500;font-family: sans-serif;">{{currentCategory}}</span></p>
                </div>
        <div class="" style="margin-top: 5%;">
          <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
            <li class="product" style=" width: 96%;margin-bottom: 10px;margin-left: 3%;background-color: white;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              
              <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
                <!-- <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="productDetails(product.id)" alt="" decoding="async" fetchpriority="high" style="width: 100%;"> -->
                <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                    onerror="this.onerror=null;this.src='assets/images/taazah/NoImage.png';" alt="{{ product.name }}"
                    class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail image_Srimaware" decoding="async" fetchpriority="high" style="width: 100%;" />
                <!-- <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
                
                  <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
                    
                </span></span>
                  </span> -->
              </div>
             
              <div style="text-align: left;">
                <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                      id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                      }}" container="body" *ngIf="fields[1].visibility">
                      <div style="display: flex;justify-content: center;">
                        <div style="display: flex;text-align: center;justify-content: center;width: 90%;">
                          <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="taz-newcol-name Urbanist_Bold">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex" style="display: flex;justify-content: center;" >
              
                        <span class="col-right">
                          <div style="display: flex;justify-content: center; margin-bottom: 10%;" class="justify-center-baby">
                            <p class="taz-newcol-price Urbanist_Bold"> ₹{{product.pricing.raw.price}}/-
                            </p>
                            <!-- <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        </div>
                    </span>
                    
                    </div>
  
              </div>
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;justify-content: center; width: 85%; margin-bottom: 15px;">
                <div>
                  <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    Buy Now
                  </button>
                  <button *ngIf="
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 &&
                      product.product_type == 'Simple' &&
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                    Add to Cart
                  </button>
                  <div *ngFor="
                      let cart of appService.cartProducts.results;
                      let i = index
                    ">
                    <div class="btn viewCart_Taz_list" *ngIf="
                        cart.product_id === product.id ||
                        cart.product_id === product.checkVariantInCart
                      ">
                      <span>
                        <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white"></i></span>
                      <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                        cart.quantity
                        }}</span>
                      <span>
                        <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white;"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </li>
          </ul>
          
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
          </div>
        <div style="display: flex;justify-content: center;">
          <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
          </div>
      </div>
  
    </div>
  
  </section>
  <section class="quote vistas-homebackground" *ngIf="CONFIG.title == 'UrbanBox'">
    <div class="title-div similar_hob">
      <p class="content-title3 title-box title main-title_smmm Urbanist_Bold">
        Related Products
      </p>
    </div> 
    <br class="desktop-only"><br>
    <div class="desktop-only" style="padding-left: 4%;padding-right: 4%;">
      <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">  
         
        <ng-container class="revinfo" *ngFor="let product of recommededProducts; let i = index">
          <ng-template carouselSlide >
    <div style="margin-bottom: 30px;width: 98%;">
    
        
        <div class="baby-newcollection">
          <div class="product-list-description-baby">
            <div class="product-centering-baby">
            <div>
              <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby"  />
            </div>
                <div class="d-flex baby_newprodname">
                  
                  <div style="width: 100%;margin-bottom: 25px;">
                    <div style="display: flex;cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    <p class="PaulHomeText1"> {{product.name}}
                    </p>
                  </div>
                   
                  
                  </div>
              </div>
            </div>
              </div>
        </div>
    
      
              </div>
            </ng-template>   
          </ng-container>
                    
      </owl-carousel-o>
     
  </div>
  <div class="mobile-only" style="margin-left: -10px;padding-bottom: 20%;">
    <div>
      <div class="container">
      <owl-carousel-o [options]="ProductSliderConfig9" class="slider rounder-corner-nav"style="position: relative;margin-left: 7px;" >
      <ng-container 
        *ngFor="let product of recommededProducts; let i = index">
        <ng-template carouselSlide>
            <div>
              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                  <div >
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            style="width: 95%;"  class="newcollection-image-baby"  />
                  </div>
                      <div class="d-flex baby_newprodname">
                        
                        <div style="width: 100%;">
                          <div style="display: flex;cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="PaulHomeText1 taz_prodnmob earthy-product-title" style="font-family: sans-serif;"> {{product.name}}
                          </p>
                        </div>
                          
                        
                        </div>
                    </div>
                  </div>
                    </div>
              </div>
            </div>             
        </ng-template>                 
      </ng-container>
    </owl-carousel-o>
    
      </div>
    </div>
    </div>
  </section>
  <section  class=" special-listing-width desktop-only " id="" *ngIf="CONFIG.title === 'Srimaware'" style="padding-bottom: 50px;width: 100%;background-color: #f7f7f7;padding-left: 10%;padding-right: 10%;">
    <div class="col-md-12 " *ngIf="CONFIG.title === 'Srimaware'"
  style="padding-right: 0px !important; padding-left: 0px !important;">
  <div>
    <!-- <div style="padding-left: 50px;background-color: #1b52a4;width: 100%;height: 50px;padding-top: 1%;">
      <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;">Home</span>
          <span style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>{{allInOneData[1]}}</span>
    </div> -->
    <div class="">
      
      <div>
  
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 0%; padding-top: 2%;padding-left: 0px;padding-right: 0px;" >
          
          <!-- <div style="margin-top: 2%;">
          <h1 style="margin-bottom: 1em;
            font-weight: 600;font-family: 'Lexend',sans-serif;font-size:25px;color: #1b52a4;margin-top: -0.5rem;">{{allInOneData[1]}}</h1>
            </div> -->
            <!-- <div class="sort" [formGroup]="sortingForm">
              <select style="font-family: system-ui;font-weight: 500; margin-top: 20px;height: 20px;border: none;color: gray;cursor: pointer;" id=" SORT BY" (change)="selectSort($event.target.value)"  >
                <option  *ngFor="let sorting of sortorders" value="{{sorting.value}}" formControlName="sort_value" style="font-size: 12px;font-family: system-ui;color: gray;" [selected]="sortingForm.get('sort_value').value == sorting.value">{{sorting.name}}</option>
              </select>
          </div> -->
          <p style="font-size: 26px;color: #5e338f;font-weight: 500;font-family: sans-serif;"><span style="font-size: 26px;color: #5e338f;font-weight: 500;font-family: sans-serif;cursor:pointer;" (click)="selectAllSrima()">Products /</span>
            <span style="font-size: 26px;color: #5e338f;font-weight: 500;font-family: sans-serif;margin-left: 2px;">{{currentCategory}}</span></p>
        </div>
        <div class="tabs_srima">
          <ul style="justify-content: space-between;flex-wrap: wrap;margin-bottom: 0px;">
            <li [class.active]="selectedTab === -1" (click)="selectAllSrima()" class="srima_tab">
              All
            </li>
            <li *ngFor="let category of allCategoriesSri; let i = index" class="srima_tab"
                [class.active]="i === selectedTab"
                (click)="selectTab(i,category.name)">
              {{ category.name }}
            </li>
          </ul>
        </div>
        <div class="container_srima" style="background-color: #f7f7f7 ; margin-right: 0px;margin-left: 0px;padding-left: 0px;padding-right: 0px;">
          <ul class="products" style="display: grid; grid-template-columns: repeat(4,1fr);margin-left: -0.5%;">
            <li class="product" style="width: 100%;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: taz_increment, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              <div class="deera-container">
  
                <div class="product-list-cards-baby2" style="color: lightgray;margin-top: 17%; background-color: white;margin-left: 2.5%;margin-right: 2.5%;border: .5px solid #e7dede;;">
              
                  <div class="deera-img button-overlay" style="height: 100%;display: flex;justify-content: center;">
              
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      onerror="this.onerror=null;this.src='assets/images/taazah/NoImage.png';" alt="{{ product.name }}"
                      class="product_list_image_taz_list" />
                  </div>
                  <div class="product-list-description-baby1">
                      
                    <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                      id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                      }}" container="body" *ngIf="fields[1].visibility">
                      <div style="display: flex;justify-content: center;">
                        <div style="display: flex;text-align: center;justify-content: center;width: 75%;">
                          <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="taz-newcol-name">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;text-align: center;justify-content: center;flex-wrap: wrap;height: 35px;" *ngIf="product.stock_status == 'Available' && product.product_type !== 'Simple'">
                      <p style="font-size: 12px;color: black;font-weight: 500;font-family: 'sans-serif';">{{product.stock_status}} Size : </p>
                      <p style="font-size: 12px;color: black;font-weight: 500;font-family: 'sans-serif'; margin-left:5px;" *ngFor="let size of product.variant.option_values; let i=index">{{size.option}}</p>
                  </div>
                  <div style="display: flex;text-align: center;justify-content: center; height: 35px;" *ngIf="product.stock_status == 'Available' && product.product_type === 'Simple'">
                    <p style="font-size: 12px;color: black;font-weight: 500;font-family: 'sans-serif';">{{product.stock_status}}</p>
                </div>
                    <div class="d-flex" style="display: flex;justify-content: center;" >
              
                        <span class="col-right">
                          <div style="display: flex;justify-content: center; margin-bottom: 10%;" class="justify-center-baby">
                            <p class="taz-newcol-price"> Rs.{{product.pricing.raw.price}}/-
                            </p>
                            <!-- <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        </div>
                    </span>
                    
                    </div>
                    <div style="display: flex;justify-content: center;">
                    <div style="display: flex;justify-content: center; width: 85%; margin-bottom: 5%;">
                    <div>
                      <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                        BUY NOW
                      </button>
                      <button *ngIf="
                          appService.productIdinCart.indexOf(product.id) ==
                            -1 &&
                          product.product_type == 'Simple' &&
                          appService.productIdinCart.indexOf(product.id) ==
                            -1 " class="btn taz_cart_btn srima_add_btn" (click)="addToCart(product)">
                        Add to Cart
                      </button>
                      <div *ngFor="
                          let cart of appService.cartProducts.results;
                          let i = index
                        ">
                        <div class="btn viewCart_Taz_list" style="margin-top: 36% !important;" *ngIf="
                            cart.product_id === product.id ||
                            cart.product_id === product.checkVariantInCart
                          ">
                          <span>
                            <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                              style="font-size: 12px; cursor: pointer;color: white"></i></span>
                          <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                            cart.quantity
                            }}</span>
                          <span>
                            <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                              style="font-size: 12px; cursor: pointer;color: white;"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  </div>
                </div>     
              
                </div>
  
            </li>
          </ul>
  
        </div>
  <div *ngIf="totalLength < 1">
  <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
  </div>
  <div style="display: flex;justify-content: center;">
  <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
  </div>
  </div>
  </div>
  </div>
  <!-- <div class="mobile-only cashback_container_taz">
    <div class="code_number_taz">
        <p class="taz_offcod">USE CODE : T A A Z A S U P E R 0 0 1</p>    
    </div>
    <div class="cashback_img_taz">
        <img src="../../../../assets/images/taazah/taz2mob.png">
    </div>
  </div>  -->
   
    </div>
   
  </section>
  <section  class="row special-listing-width mobile-only " id="productRow" *ngIf="CONFIG.title === 'Srimaware'" style="padding-bottom: 50px;background-color: #e1e1e1;">
    <div class="">
      <div class="col-10" style="min-width: 97%;max-width: 97%;margin-left: 1%;">
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 1%;margin-bottom: 15px;" >
  <p style="font-size: 20px;color: #5e338f;font-weight: 500;font-family: system-ui;">Categories</p>
        </div>
        <div class="tabs_srima">
          <ul style="display: grid;grid-template-columns: repeat(3, 1fr);">
            <li [class.active]="selectedTab === -1" (click)="selectAllSrima()" class="srima_tab">
              All
            </li>
            <li *ngFor="let category of allCategoriesSri; let i = index" class="srima_tab"
                [class.active]="i === selectedTab"
                (click)="selectTab(i,category.name)">
              {{ category.name }}
            </li>
          </ul>
        </div>
        <div class="container" style="display: flex;margin-right: 0px;margin-left: 1%;margin-top: 25px;margin-bottom: 25px;" >
          <p style="font-size: 20px;color: #5e338f;font-weight: 500;font-family: sans-serif;"><span style="font-size: 20px;color: #5e338f;font-weight: 500;font-family: sans-serif;cursor:pointer;" (click)="selectAllSrima()">Products /</span>
            <span style="font-size: 20px;color: #5e338f;font-weight: 500;font-family: sans-serif;">{{currentCategory}}</span></p>
                </div>
        <div class="" style="margin-top: 5%;">
          <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
            <li class="product" style=" width: 96%;margin-bottom: 10px;margin-left: 3%;background-color: white;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              
              <div style="text-align: left; width: 90%; margin-left: 10px;" class="button-overlay">
                <!-- <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="productDetails(product.id)" alt="" decoding="async" fetchpriority="high" style="width: 100%;"> -->
                <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                    onerror="this.onerror=null;this.src='assets/images/taazah/NoImage.png';" alt="{{ product.name }}"
                    class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail image_Srimaware" decoding="async" fetchpriority="high" style="width: 100%;" />
                <!-- <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
                
                  <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
                    
                </span></span>
                  </span> -->
              </div>
             
              <div style="text-align: left;">
                <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                      id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                      }}" container="body" *ngIf="fields[1].visibility">
                      <div style="display: flex;justify-content: center;">
                        <div style="display: flex;text-align: center;justify-content: center;width: 90%;">
                          <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="taz-newcol-name">{{metaDataMapService.findData(product,fields[1].nestedinfo) | titlecase}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex;text-align: center;justify-content: center;flex-wrap: wrap;height: 38px;" *ngIf="product.stock_status == 'Available' && product.product_type == 'Variable' ">
                      <p style="font-size: 13px;color: black;font-weight: 500;font-family: 'sans-serif';">{{product.stock_status}} Size : </p>
                      <p style="font-size: 13px;color: black;font-weight: 500;font-family: 'sans-serif'; margin-left:5px;" *ngFor="let size of product.variant.option_values; let i=index">{{size.option}}</p>
                  </div>
                  <div style="display: flex;text-align: center;justify-content: center;flex-wrap: wrap;height: 38px;" *ngIf="product.stock_status == 'Available' && product.product_type == 'Simple' ">
                    <p style="font-size: 13px;color: black;font-weight: 500;font-family: 'sans-serif';">{{product.stock_status}}</p>
                </div>
                    <div class="d-flex" style="display: flex;justify-content: center;" >
              
                        <span class="col-right">
                          <div style="display: flex;justify-content: center; margin-bottom: 10%;" class="justify-center-baby">
                            <p class="taz-newcol-price"> Rs.{{product.pricing.raw.price}}/-
                            </p>
                            <!-- <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        </div>
                    </span>
                    
                    </div>
  
              </div>
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;justify-content: center; width: 85%; margin-bottom: 15px;">
                <div>
                  <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    Buy Now
                  </button>
                  <button *ngIf="
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 &&
                      product.product_type == 'Simple' &&
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                    Add to Cart
                  </button>
                  <div *ngFor="
                      let cart of appService.cartProducts.results;
                      let i = index
                    ">
                    <div class="btn viewCart_Taz_list" *ngIf="
                        cart.product_id === product.id ||
                        cart.product_id === product.checkVariantInCart
                      ">
                      <span>
                        <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white"></i></span>
                      <span class="inq-sp-2" style="color: white;font-size: 12px;;margin-top: 4px;">{{
                        cart.quantity
                        }}</span>
                      <span>
                        <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                          style="font-size: 12px; cursor: pointer;color: white;"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </li>
          </ul>
          
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
          </div>
        <div style="display: flex;justify-content: center;">
          <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
          </div>
      </div>
  
    </div>
  
  </section>
  <section class="quote vistas-homebackground" *ngIf="CONFIG.title == 'Srimaware'">
    <div class="title-div similar_hob">
      <p class="content-title3 title-box title main-title_smmm">
        Related Products
      </p>
    </div> 
    <br class="desktop-only"><br>
    <div class="desktop-only" style="padding-left: 10%;padding-right: 10%;">
      <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">  
         
        <ng-container class="revinfo" *ngFor="let product of newarrival; let i = index">
          <ng-template carouselSlide >
    <div style="margin-bottom: 30px;width: 98%;">
    
        
        <div class="baby-newcollection">
          <div class="product-list-description-baby">
            <div class="product-centering-baby">
            <div>
              <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby"  />
            </div>
                <div class="d-flex baby_newprodname">
                  
                  <div style="width: 100%;margin-bottom: 25px;">
                    <div style="display: flex;cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                    <p class="PaulHomeText1"> {{product.name}}
                    </p>
                  </div>
                   
                  
                  </div>
              </div>
            </div>
              </div>
        </div>
    
      
              </div>
            </ng-template>   
          </ng-container>
                    
      </owl-carousel-o>
     
  </div>
  <div class="mobile-only" style="margin-left: -10px;padding-bottom: 20%;">
    <div>
      <div class="container">
      <owl-carousel-o [options]="ProductSliderConfig4" class="slider rounder-corner-nav"style="position: relative;margin-left: 7px;" >
      <ng-container 
        *ngFor="let product of newarrival; let i = index">
        <ng-template carouselSlide>
            <div>
              <div class="baby-newcollection">
                <div class="product-list-description-baby" style="transform: translate(10px, 0px);">
                  <div class="product-centering-baby">
                  <div >
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            style="width: 95%;"  class="newcollection-image-baby"  />
                  </div>
                      <div class="d-flex baby_newprodname">
                        
                        <div style="width: 100%;">
                          <div style="display: flex;cursor: pointer;justify-content: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="PaulHomeText1 taz_prodnmob earthy-product-title" style="font-family: sans-serif;"> {{product.name}}
                          </p>
                        </div>
                          
                        
                        </div>
                    </div>
                  </div>
                    </div>
              </div>
            </div>             
        </ng-template>                 
      </ng-container>
    </owl-carousel-o>
    
      </div>
    </div>
    </div>
  </section>
  <section  class="row special-listing-width mobile-only " id="productRow" *ngIf="CONFIG.title === 'Taazah'" style="padding-bottom: 30px;background-color: #e1e1e1;">
    <div class="">
      <div class="col-10" style="min-width: 97%;max-width: 97%;margin-left: 1%;">
        <div class="" >
          <div style="background-color: #1b52a4;">
          <div class="breadCrumbListing" style="margin-left: 7px; ">
            <span class="home-breadcrumb" routerLink="" style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;">Home</span>
            <span (click)="clearAll()" style="font-size: 13.8px;color: white;font-family: sans-serif;zoom: 1;"><i class="px-2">/</i>{{currentCategoryTaz}}</span>
          </div>
        </div>
          <div style="margin-top: 2%;">
            <h2 style="margin-bottom: 20px; margin-left: 20px; margin-top: 20px;
            font-weight: 600;font-family: 'Lexend',sans-serif;font-size: 25px;color: #1b52a4;">{{currentCategoryTaz}}</h2>
            </div>
            <!-- <div>
              <p style="line-height: 1.6em;color:#565555b3;font-family: 'Hind',sans-serif;font-size:13px;margin-left: 20px;">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Dolore eu fugiat nulla pariatur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt.
  
              </p>
            </div> -->
                   <div>
              <p style="line-height: 1.6em;color:#565555b3;font-family: 'Hind',sans-serif;font-size:13px;margin-left: 20px;">{{categoryDescription}}
              </p>
            </div>
        </div>
  
        <div class="" style="margin-top: 5%;">
          <ul class="products" style="display: grid; grid-template-columns: repeat(2,1fr);">
            <li class="product" style=" width: 96%;margin-bottom: 10px;margin-left: 3%;background-color: white;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              
              <div style="text-align: left; display: flex;justify-content: center;" class="button-overlay">
                <!-- <img [src]="product.assets[0].image_source" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" (click)="productDetails(product.id)" alt="" decoding="async" fetchpriority="high" style="width: 100%;"> -->
                <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+allInOneData[1],product.name+'-'+product.id) : null"
                    onerror="this.onerror=null;this.src='assets/images/taazah/NoImage.png';" alt="{{product.name}}" title="{{product.name}}"
                    class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" decoding="async" fetchpriority="high" style="width: 80%;margin-top: 10px;" />
                <!-- <span style="" class="add_schift-btn" (click)="addToCartSchift(product)">
                
                  <span style=" background-color: white;display: list-item;width: 21px;border-radius: 10px; cursor: pointer;"> <span class="fa fa-shopping-cart" style="font-size:16px;color: black;margin-left: 10%;">
                    
                </span></span>
                  </span> -->
              </div>
             
              <div style="text-align: left; width: 90%;margin-left: 12px;">
                <div >
                  <div style="display: flex;text-align: center;justify-content: center;" *ngIf="product.stock_status == 'Available'">
                    <p style="font-size: 12px;color: gray;">{{product.stock_status}} (In Stock)</p>
                </div>
                  <h2 style="line-height: 1.25em;font-family: Trebuchet MS, sans-serif;font-weight: 600;border: 0;margin-bottom: 0.5em;margin-top: 10px;
                  font-size: 15px;display: -webkit-box !important;-webkit-line-clamp: 2 !important;-webkit-box-orient: vertical !important;text-overflow: ellipsis !important;height: 35px;overflow: hidden !important;text-align: center;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null">{{metaDataMapService.findData(product,groups[0].fields[1].nestedinfo) | titlecase}}</h2>
                  <span class="col-right">
                    <div style="display: flex;justify-content: center; margin-bottom: 10%;" class="justify-center-baby">
                      <p class="taz-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                      </p>
                      <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span>
                  </div>
              </span>
  
                </div>
  
              </div>
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;justify-content: space-between; width: 85%; margin-bottom: 15px;">
                <div>
                  <button *ngIf="product.product_type == 'Variable' " class="btn taz_cart_btn" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null">
                    View Details
                  </button>
                  <button *ngIf="
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 &&
                      product.product_type == 'Simple' &&
                      appService.productIdinCart.indexOf(product.id) ==
                        -1 " class="btn taz_cart_btn" (click)="addToCart(product)">
                    Add to Cart
                  </button>
                  <div *ngFor="
                      let cart of appService.cartProducts.results;
                      let i = index
                    ">
                    <div class="btn viewCart_Taz_list" 
     style="width: 100px; display: flex; align-items: center; justify-content: space-around;" 
     *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
     <button style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 32px;border: none;border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
      <i class="fa fa-minus" (click)="decreaseItem(i)"
         style="font-size: 12px; cursor: pointer; color: white; margin-top: 11.5px;"></i>
    </button>
    <div>
    <span style="color: black; font-size: 12px; width: 30px; display: inline-block; text-align: center;transform: translate(0px, -10%);">
      {{ cart.quantity }}
    </span>
  </div>
    <button style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 32px;border: none;border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
      <i class="fa fa-plus" (click)="increaseItem(i)"
         style="font-size: 12px; cursor: pointer; color: white;margin-top: 11.5px;"></i>
    </button>
</div>
                  </div>
                </div>
                <div>
                  <i class="fa fa-shopping-cart" style="color: transparent!important;-webkit-text-stroke: .5px rgb(174, 174, 174);margin-top: 7px;cursor: pointer;font-size: 20px;" (click)="buyNow(product)"></i>
                </div>
              </div>
            </div>
            </li>
          </ul>
          
        </div>
        <div style="display: flex;justify-content: center;">
          <button *ngIf="showMoreOption" (click)="showMore()" class="btn taz_more_btn">Show more</button>
          </div>
      </div>
  
    </div>
  
  </section>
  <div  *ngIf="CONFIG.title === 'Taazah'" class="mobile-only" >
    <div style=" display: flex;justify-content: center;padding-bottom: 40px;background-color: #e1e1e1;" >
      <div class="cashback_container_taz" style="margin-left: 2%;margin-right: 2%;">
        <!-- <div class="code_number_taz">
            <p class="taz_offcod">USE CODE : T A A Z A S U P E R 0 0 1</p>    
        </div> -->
        <div class="cashback_img_taz">
            <img src="../../../../assets/images/taazah/taz2mob.jpg" alt="OfferBanner" title="OfferBanner">
        </div>
    </div>
    </div>
  </div>
  <button id="launch-model-special" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-special">
  Launch demo modal
</button>
  <div class="modal fade" id="statusModel-special" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div *ngIf="CONFIG.title === 'SpecialWires' || CONFIG.title === 'ShubhCards'" class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form - {{special_pro_name}}</div>
            
          </div>
          <form [formGroup]="enquiryForm_special" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f.name.errors">
                  <div *ngIf="f.name.errors.required">Name is required.</div>
                  <div *ngIf="f.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div *ngIf="f.email.errors.required">Email is required.</div>
                  <div *ngIf="f.email.errors.maxlength">
                    Sender Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f.email.errors.email || f.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f.phone_number.errors">
                  <div *ngIf="f.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f.phone_number.errors.maxlength">
                    Mobile Number can't be more than 10 characters long.
                  </div>
                  <div *ngIf="f.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f.category.invalid && validateForm" formControlName="category" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f.category.errors">
                  <div *ngIf="f.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="product_name" class="form-label">Product Name<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="product_name"
                  [class.is-invalid]="f.product_name.invalid && validateForm" formControlName="product_name" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f.product_name.errors">
                  <div *ngIf="f.product_name.errors.required">
                    Product Name is required.
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group row">
              <div class="col-md-4">
                <label for="drawing" class="form-label">Upload Drawing</label>
              </div>
              <div class="col-md-7">
                <input type="file" class="form-control" id="drawing"
                   formControlName="drawing" accept=".jpeg,.jpeg,.png,.pdf"
                   />
                
              </div>
            </div> -->
            <div class="form-group row" *ngIf="CONFIG.title === 'SpecialWires'">
              <div class="col-md-4">
                <label for="drawing" class="form-label">Upload Chart</label>
              </div>
            <div class="col-md-7">
              <input type="file" (change)="imageupload($event)" style="display: none;" #fileuploadinput />
              <div class="btn-group" name="imageFile" id="uploadButton"
                [class.is-invalid]="validateForm && f.imageFile.errors">
                <button type="file" class="btn btn-primary btn-md shadow-sm" accept="image/*"
                  (click)="fileuploadinput.click()">upload</button>{{imageName}}
              </div>
              <p style="font-size:xx-small;">maximum file size 2MB.Allowed file types JPEG/PNG/JPG</p>
      
              <div class="invalid-feedback" *ngIf="f.imageFile.errors">
                <div *ngIf="f.imageFile.errors.invalid">invalid file name.</div>
                <div *ngIf="f.imageFile.errors.type">invalid file type.</div>
                <div *ngIf="f.imageFile.errors.sizezero">File size should be greater than zero.</div>
                <div *ngIf="f.imageFile.errors.sizehigh">File size should be less than 2MB.</div>
              </div>
      
            </div>
          </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label *ngIf="CONFIG.title === 'SpecialWires'"  for="diameter" class="form-label">Diameter</label>
                <label  *ngIf="CONFIG.title === 'ShubhCards'" for="diameter" class="form-label">Appointment Date</label>
              </div>
              <div class="col-md-7">
                <div ngbDropdown>
                  <button class="datepicker btn btn-link"  ngbDropdownToggle>{{_value?(_value|date:'dd/MM/yy'):label}}</button>
                      <div ngbDropdownMenu >
                        <ngb-datepicker #dp [(ngModel)]="date" (dateSelect)="getDatetime()"[ngModelOptions]="{standalone:true}" ></ngb-datepicker>
                        <!-- <ngb-timepicker [(ngModel)]="time"></ngb-timepicker> -->
                        <!-- <ngb-timepicker [ngModel]="time" (ngModelChange)="time=$event;getDatetime()"[ngModelOptions]="{standalone:true}"></ngb-timepicker> -->
                      </div>
                      </div>
                <!-- <input type="number" class="form-control" id="diameter"
                   formControlName="diameter"
                   /> -->
                
              </div>
            </div>

            <div class="form-group row" *ngIf="CONFIG.title === 'SpecialWires'">
              <div class="col-md-4">
                <label for="e_length" class="form-label">Length</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="e_length"
                   formControlName="e_length"
                   />
                
              </div>
            </div>


            <div class="form-group row">
              <div class="col-md-4">
                <label for="quantity" *ngIf="CONFIG.title === 'SpecialWires'" class="form-label">Quantity</label>
                <label for="quantity" *ngIf="CONFIG.title === 'ShubhCards'" class="form-label">Time</label>
              </div>
              <div class="col-md-7">
                <input    *ngIf="CONFIG.title === 'SpecialWires'" type="number" class="form-control" id="quantity"
                   formControlName="quantity"
                   />
                   <select class="form-select" *ngIf="CONFIG.title === 'ShubhCards'">
                    <option>10.00AM TO 12.00PM</option>
                    <option>12.00PM TO 2.00PM</option>
                    <option>2.00PM TO 4.00PM</option>
                    <option>4.00PM TO 6.00PM</option>
                  </select>
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Enter Specification<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f.message.errors">
                  <div *ngIf="f.message.errors.required">
                    Specification is required.
                  </div>
                  <div *ngIf="f.message.errors.maxlength">
                    Specification can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm_special()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<button id="launch-model-shubhcards" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-shubhcards">
  Launch demo modal
</button>

  <div *ngIf="CONFIG.title === 'ShubhCards'"   class="modal fade" id="statusModel-shubhcards" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div  class="modal-content status-model-container" >
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-bt-shb">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container" style="border-bottom: none;">
              <div class="checkout-alerts">
      <app-alerts *ngIf="checkoutAlerts"></app-alerts>
    </div>
            <div class="m-title" >Enquiry Form - {{special_pro_name}}</div>
            
          </div>
          <form [formGroup]="enquiryForm_special" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label" >Name <span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f.name.errors">
                  <div *ngIf="f.name.errors.required">Name is required.</div>
                  <div *ngIf="f.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label" >Email<span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div *ngIf="f.email.errors.required">Email is required.</div>
                  <div *ngIf="f.email.errors.maxlength">
                    Sender Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f.email.errors.email || f.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label" >Mobile<span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f.phone_number.errors">
                  <div *ngIf="f.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f.phone_number.errors.maxlength">
                    Mobile Number can't be more than 10 characters long.
                  </div>
                  <div *ngIf="f.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label" >Category<span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f.category.invalid && validateForm" formControlName="category" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f.category.errors">
                  <div *ngIf="f.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="product_name" class="form-label" >Product Name<span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="product_name"
                  [class.is-invalid]="f.product_name.invalid && validateForm" formControlName="product_name" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f.product_name.errors">
                  <div *ngIf="f.product_name.errors.required">
                    Product Name is required.
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group row">
              <div class="col-md-4">
                <label for="drawing" class="form-label">Upload Drawing</label>
              </div>
              <div class="col-md-7">
                <input type="file" class="form-control" id="drawing"
                   formControlName="drawing" accept=".jpeg,.jpeg,.png,.pdf"
                   />
                
              </div>
            </div> -->
            
            <div class="form-group row">
              <div class="col-md-4">
                
                <label   for="diameter" class="form-label"  >Appointment Date</label>
              </div>
              <div class="col-md-7">
                <div ngbDropdown>
                  <button class="datepicker btn btn-link"  ngbDropdownToggle >{{_value?(_value|date:'dd/MM/yy'):label}}</button>
                      <div ngbDropdownMenu >
                        <ngb-datepicker #dp [(ngModel)]="date" (dateSelect)="getDatetime()"[ngModelOptions]="{standalone:true}"  [minDate]="minDate"  [maxDate]="maxDate" ></ngb-datepicker>
                        <!-- <ngb-timepicker [(ngModel)]="time"></ngb-timepicker> -->
                        <!-- <ngb-timepicker [ngModel]="time" (ngModelChange)="time=$event;getDatetime()"[ngModelOptions]="{standalone:true}"></ngb-timepicker> -->
                      </div>
                      
                      </div>
            
                
              </div>
            </div>

         


            <div class="form-group row">
              <div class="col-md-4">
               
                <label for="quantity"  class="form-label" >Time</label>
              </div>
              <div class="col-md-7">
                
                   <select class="form-select" *ngIf="CONFIG.title === 'ShubhCards'"  formControlName="quantity"  [class.is-invalid]="f.quantity.invalid && validateForm" required>
                    <option>10.00AM TO 12.00PM</option>
                    <option>12.00PM TO 2.00PM</option>
                    <option>2.00PM TO 4.00PM</option>
                    <option>4.00PM TO 6.00PM</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="f.quantity.errors">
                    <div *ngIf="f.quantity.errors.required">
                      Time is required.
                    </div>
                  </div>
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label" >Enter Specification<span class="required"  >*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f.message.errors">
                  <div *ngIf="f.message.errors.required">
                    Specification is required.
                  </div>
                  <div *ngIf="f.message.errors.maxlength">
                    Specification can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row" *ngIf="setOtp==true">
              <div class="col-md-4">
                <label for="e_length" class="form-label" >OTP <span class="required" >*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="e_length" [class.is-invalid]="f.e_length.invalid && validateForm"
                  formControlName="e_length" required />
                <div class="invalid-feedback" *ngIf="f.e_length.errors">
                  
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px" style="color: black;" *ngIf="setOtp==false">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;background-color: green!important;border: none
                " (click)="getUserDetail(enquiryForm_special.get('phone_number').value)">
                SUBMIT
              </button>
            </div>
            <div style="margin-bottom: 45px" style="color: black;" *ngIf="setOtp==true">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;background-color: green!important
                " (click)="verifyOTP(enquiryForm_special.get('phone_number').value,enquiryForm_special.get('e_length').value)">
                Verify with otp
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>



 

<!-- Modal -->

</div>

<div class="container inq-mt-st  deera-listrow shub_rowlist" *ngIf="CONFIG.title !== 'LinenRaj' && CONFIG.title !== 'Schift Cosmetics' && CONFIG.title !== 'LushNGreen' && CONFIG.title !== 'Babys Pride' && CONFIG.title !== 'Taazah' && CONFIG.title !== 'SriSenbaga' && CONFIG.title !== 'ShubhCards' && CONFIG.title !== 'HOB' && CONFIG.title !== 'PaulCaroline' && CONFIG.title !== 'Srimaware' && CONFIG.title !== 'UrbanBox'">
  <section class="row" id="productRow">
    <div class="checkout-alerts">
      <app-alerts *ngIf="checkoutAlerts"></app-alerts>
    </div>
    <div class="col-md-3" *ngIf="CONFIG.title !== 'AvonSeals' && CONFIG.title !== 'LinenRaj' && CONFIG.title !== 'Deera' && CONFIG.title !== 'SpecialWires' && CONFIG.title !== 'Vistas'">
      <div class="inq-menu-left-st">
        <div class="collection-filter">
          <div class="total-items" id="totalItems">
            <div class="breadCrumbListing"  *ngIf="CONFIG.title == 'Accel'" style="white-space: nowrap;">
              <span class="home-breadcrumb" routerLink=""><i class="fa fa-home" aria-hidden="true"></i>&nbsp;Home</span>
               <span class="li_data"  style="margin-left: 10%;"><i *ngIf="this.allInOneData[1]" class="px-2 "></i> {{this.allInOneData[1]}} </span>
              <span> </span>
            </div>
            <p *ngIf="CONFIG.title !== 'Aiema' && CONFIG.title !== 'KatbookStore' && CONFIG.title !== 'PaulCaroline' && CONFIG.title !== 'AvonSeals' && CONFIG.title !== 'Accel' && CONFIG.title !== 'Vistas' && CONFIG.title !== 'Cle'">
              <span><b>Items found</b></span> - {{ totalItemsOrProducts }}
            </p>
            <p style="font-family: 'proxima-regular', 'sans-serif' !important" *ngIf="CONFIG.title === 'Aiema' || CONFIG.title === 'Cle'">
              <span><b>Companies found</b></span> - {{ totalItemsOrProducts }}
            </p>
            <!-- <p style="font-family: 'proxima-regular','sans-serif' !important;" *ngIf="CONFIG.title === 'Aiema'"><span><b>Companies found</b></span> - {{filterItemsOfType().length}} </p> -->
          </div>
          <div *ngIf="CONFIG.title !== 'Deera'">
            <app-product-filter *ngIf="CONFIG.title !== 'AvonSeals' && CONFIG.title !== 'LinenRaj'  && CONFIG.title !== 'Vistas'" [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
            [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
            [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">

          </app-product-filter>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3" *ngIf="CONFIG.title === 'Deera'" class="mobile-only">
      <div class="inq-menu-left-st">
        <div class="collection-filter">
          <div class="total-items" id="totalItems">
            <p>
              <span><b>Items found</b></span> - {{ totalItemsOrProducts }}
            </p>
            
          </div>
          <div *ngIf="CONFIG.title === 'Deera'" class="mobile-only">
            <app-product-filter [finish]="finish" [features]="features" [prices]="prices" [themes]="themes"
            [filters]="facets" [priceRange]="pricefilters" [size]="size" [thickness]="thickness" [color]="color"
            [type]="type" [material]="material" [age]="age" [affiliation]="affiliation" [standard]="standard" [subject]="subject" [year]="year" [price_range]="price_range" [categoriesList]="categoryList" [configTitle]="CONFIG.title">

          </app-product-filter>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9" *ngIf="
        CONFIG.title !== 'Aiema' &&
        CONFIG.title !== 'Cle' &&
        CONFIG.title !== 'BombayHardware' &&
        CONFIG.title !== 'Deera' && CONFIG.title !== 'BestGifts'&& CONFIG.title !== 'KatbookStore' && CONFIG.title !== 'AvonSeals' && CONFIG.title !== 'Vistas' &&CONFIG.title !== 'Kubendran' && CONFIG.title !== 'Beaubelle' && CONFIG.title !== 'Carience' && CONFIG.title !== 'SpecialWires'&& CONFIG.title !== 'Vimpro'&& CONFIG.title !== 'Karupattiraja' && CONFIG.title !== 'ShubhCards'
      ">
      <div *ngIf="CONFIG.title === 'Accel'">

        <!-- <select name="SORT BY" id=" SORT BY" class="sort" (change)="selectSort($event.target.value)" >
          <option value="sort" style="font-size: 13px;">sortby:Recommended</option>
          <option value="Low to High"   style="font-size: 13px;">Price: Low to High</option>
          <option value="High to Low"  style="font-size: 13px;" >Price: High to Low</option>
        </select> -->
        
        
        <div class=" container">
          
        
          
      
          <section class="main" style="width: 110%;">
            <div class="row accel_list" style="display: grid;grid-template-columns: repeat(3,1fr);">
              <div class="product_list_column"  *ngFor="let product of filterItemsOfType() let i = index">
                <div class="card" style="height: 520px">
                  <!-- <div style=" display: flex;justify-content: center;"> -->
                  <img [src]="product.assets[0].image_source" alt="Avatar" style="width:100%;" (click)="productDetails(product.id)">
                <!-- </div> -->
                  <h4  class="desktop-only accel-card-title" (click)="productDetails(product.id)" style="height: 24%; line-height: 1.5;margin-top: 15px;text-align: left;">{{product.name}}</h4> 
                  <p  class="mobile-only" (click)="productDetails(product.id)" style="text-align: left;"><b >{{product.name}}</b></p> 
                    
                      <p style="line-height:1.5;text-align: left;font-size: 13px;margin-top: 2%">Network Engineering, and Server administration – Windows & Linux, Cloud Technologies and Security Management.</p>
                      <div style="position: inherit;">
                      <div style="display: flex;margin-top: 10px;">
                        
                     <p style="text-align: left;font-size: 14px;margin-right: 28%;color: rgb(191 178 178);">₹60,000</p>
                     <p style="text-align: right;font-size: 15px;color: #4576db;">High on Demand</p>
                     </div>
                      <div> 
                       <button type="button" class="btn btn-info"  style="display: flex;justify-content: left;margin-top:5%;font-size: 13px;"  (click)="submitEnquiry_accel(product)">APPLY NOW</button>
                     </div>
                     <div style="display: flex;">
                       <div style="margin-top: 10px;display: flex;">
                       <i class="fa fa-eye" aria-hidden="true"></i>
                       <p class="accel-card-detail" style="margin-left: 5px;margin-top: -2%; font-size: 11px;color: #ff5c00;" (click)="productDetails(product.id)">6 Months</p> 
                     </div>
                     <div style="margin-left: 10px;margin-top: 10px;display: flex;">
                       <i class="fa fa-clock-o" aria-hidden="true"></i>
                       <p class="accel-card-detail" style="margin-left: 5px;margin-top: -2%;font-size: 11px;color: #ff5c00;" (click)="productDetails(product.id)">420 Hours</p> 
                     </div>
                     <div style="display: flex;margin-left: 10px;margin-top: 10px;">
                     <i class="fa fa-star" aria-hidden="true" style=""></i>
                       <p  class="accel-card-detail" style="margin-left: 5px;margin-top: -2%;font-size: 11px;color: #ff5c00;">CTC-2LPA</p> 
                     </div>
                   </div>
                  </div>
                 
                </div>

              </div>
              <!-- <div class="product_list_column">
                <div class="card">
                  <img src="https://www.accelacademy.in/assets/img/course-full/1.jpg" alt="Avatar" style="width:100%">
                  <h4  class="desktop-only"><b >Post Graduate Diploma in IT Infrastructure Management Services</b></h4> 
                  <p  class="mobile-only"><b >Post Graduate Diploma in IT Infrastructure Management Services</b></p> 
                  <div class="container" style="display: flex;">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">6 Months</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">420 Hours</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                  <i class="fa fa-star" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">CTC - 2LPA</p> 
                  </div>
                </div>
              </div>
            
              <div class="column">
                <div class="card">
                  <img src="https://www.accelacademy.in/assets/img/course-full/3.jpg" alt="Avatar" style="width:100%">
                  <h4  class="desktop-only"><b >Post Graduate Diploma in Cloud Engineering</b></h4> 
                  <p  class="mobile-only"><b >Post Graduate Diploma in Cloud Engineering</b></p> 
                  <div class="container" style="display: flex;">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">6 Months</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">420 Hours</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                  <i class="fa fa-star" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">CTC - 2LPA</p> 
                  </div>
                </div>
              </div>
              
              <div class="column">
                <div class="card">
                  <img src="https://www.accelacademy.in/assets/img/course-full/2.jpg" alt="Avatar" style="width:100%">
                  <h4 class="desktop-only"><b >Post Graduate Diploma in Cyber Security</b></h4> 
                  <p  class="mobile-only"><b >Post Graduate Diploma in Cyber Security</b></p> 
                  <div class="container" style="display: flex;">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">6 Months</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">420 Hours</p> 
                  </div>
                  <div class="container"  style="display: flex;">
                  <i class="fa fa-star" aria-hidden="true"></i>
                    <p style="margin-left: 10%;margin-top: -2%;">CTC - 2LPA</p> 
                  </div>
                </div>
              </div> -->
              
              
            </div>
              
      
            
        </section>
      
          
      
      </div>
  
  
  
      </div>
      <div *ngIf="CONFIG.title !== 'Accel'" >   
        <div class="inq-menu-right-st">
          <h2 class="text-primary" id="productListHead"
            *ngIf="CONFIG.title === 'ShubhCards' || CONFIG.title === 'Deera' || CONFIG.title === 'BestGifts'">
            Products &nbsp; &nbsp; &nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <p class="desktop-only" style="display: inline; font-size: 16px">
              "INCLUDING TEXT PRINT CHARGES"
            </p>
            <p class="mobile-only" style="display: flex; font-size: 16px">
              "INCLUDING TEXT PRINT CHARGES"
            </p>
          </h2>
          <h2 class="text-primary" id="productListHead"
            *ngIf="CONFIG.title !== 'ShubhCards' && CONFIG.title !== 'Deera' && CONFIG.title !== 'Accel' && CONFIG.title !== 'BestGifts'&& CONFIG.title !== 'Kubendran' && CONFIG.title !== 'Beaubelle' && CONFIG.title !== 'PaulCaroline'">
            Products
          </h2>
          <div class="breadCrumbListing"   *ngIf="CONFIG.title !== 'Accel' && CONFIG.title !== 'PaulCaroline' && CONFIG.title !== 'Deera'">
            <!-- <span class="home-breadcrumb" routerLink="">Home</span> -->
            <span><i class="px-2">/</i> <a style="cursor:pointer;color:black !important" (click)="clearAll()"> Products</a> <span><i *ngIf="this.allInOneData[1]" class="px-2">/</i> {{this.allInOneData[1]}} </span></span>
            <span> </span>
          </div>
          <div class="breadCrumbListing"   *ngIf="CONFIG.title === 'Deera'">
            <!-- <span class="home-breadcrumb" routerLink="">Home</span> -->
            <span><i class="px-2">/</i> <a style="cursor:pointer;color:black !important" (click)="clearAll()">Products</a> <span><i *ngIf="currentCategoryTaz" class="px-2">/</i> {{currentCategoryTaz}} </span></span>
            <span> </span>
          </div>
          <div *ngIf="totalLength > 0" class="thumb">
            <div *ngFor="let product of filterItemsOfType() | paginate
                    : {
                        id: 'pagination-controls',
                        itemsPerPage: countPerPage,
                        currentPage: currentPageInPagination,
                        totalItems: totalLength
                      };
                let i = index">
              <div class="inq-pro-sec-st listProduct" style="margin-right:0px !important">
                <div *ngIf="
                    CONFIG.title !== 'Murgasen' &&
                    CONFIG.title !== 'LuckMe' &&
                    CONFIG.title !== 'ShubhCards' &&
                    CONFIG.title !== 'Deera' &&
                    CONFIG.title !== 'BestGifts'  &&
                    CONFIG.title !== 'AvonSeals' && CONFIG.title !== 'Vistas' && CONFIG.title !== 'Kubendran' && CONFIG.title !== 'SpecialWires' && CONFIG.title !== 'Aiema' && CONFIG.title !== 'Cle' &&
                    CONFIG.title !== 'BombayHardware'&& CONFIG.title !== 'Beaubelle' && CONFIG.title !== 'Carience'&& CONFIG.title !== 'Vimpro'
                  ">
                  <div class="earthy-card">
                    <div class="earthy-image">
                      <span class="wishlist-heart"><i class="fa fa-heart fa-lg" (click)="addWishList(product)"
                          [ngStyle]="{
                            color: product.select ? '#BDC62B' : '#dcdcdc'
                          }" aria-hidden="true"></i></span>
                      <div *ngIf="
                          product.assets != undefined &&
                          product.assets.length != 0 &&
                          product.assets[0].image_source
                        ">
                        <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                          onerror="this.onerror=null;this.src='assets/images/vendor/No_Image_old.png';"
                          alt="{{ product.name }}" class="img-fluid product-image" />
                        <div *ngIf="
                            product.assets.length === 0 ||
                            !product.assets[0].image_source
                          ">
                          <img src="assets/images/No_Image_old.png" id="img-list" (click)="productDetails(product.id)"
                            class="img-fluid product-image" />
                        </div>
                      </div>
                    </div>
                    <div class="earthy-description text-center productTitleList">
                      <div class="product-description earthy-product-title" id="img-list"
                        (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                        id="{{ product.id }}" ngbPopover="{{
                          metaDataMapService.findData(
                            product,
                            fields[1].nestedinfo
                          )
                        }}" container="body" *ngIf="fields[1].visibility">
                        <div>
                          {{
                          metaDataMapService.findData(
                          product,
                          fields[1].nestedinfo
                          )
                          }}
                        </div>
                        <div>
                          <ngb-rating style="
                              color: #373b3f !important;
                              font-size: 11px !important;
                            " [max]="5" [(rate)]="currentRating" [readonly]="true"></ngb-rating>
                          <a style="
                              color: #373b3f !important;
                              font-size: 11px !important;
                            ">432 ratings|123 reviews</a>
                        </div>
                        <div class="earthy-worthy-price" id="priceListing">
                          <div *ngIf="
                              fields[3].visibility &&
                              product.product_type != 'Variable'
                            ">
                            ₹
                            {{
                            metaDataMapService.findData(
                            product,
                            fields[3].nestedinfo
                            )
                            }}
                          </div>

                          <div *ngIf="
                              product.product_type == 'Variable' &&
                              product.type == 'Variable'
                            ">
                            ₹
                            {{
                            product.pricing.raw.price_range
                            ? product.pricing.raw.price_range
                            : product.pricing.raw.price
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="earthy-cart-btn">
                        <button *ngIf="
                            appService.productIdinCart.indexOf(product.id) ==
                              -1 &&
                            product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1 &&
                              product.type != 'Variable'
                          " class="btn btn-primary" (click)="addToCart(product)">
                          Add to Cart
                        </button>
                        <button *ngIf="
                            product.product_type == 'Variable' ||
                            product.type == 'Variable'
                          " class="btn btn-primary earthy-btn" (click)="productDetails(product.id)">
                          Select Options
                        </button>
                        <!-- <button     class="btn btn-secondary listing"   *ngIf="(appService.productIdinCart.indexOf(product.id) != -1 && product.product_type!='Variable' && appService.productIdinCart.indexOf(product.id) > -1)"  routerLink="/cart">View Cart</button> -->
                        <div *ngFor="
                            let cart of appService.cartProducts.results;
                            let i = index
                          ">
                          <div class="btn btn-primary inq-btn-st ml-1 viewCart" *ngIf="
                              cart.product_id === product.id ||
                              cart.product_id === product.checkVariantInCart
                            ">
                            <span>
                              <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                            <span class="inq-sp-2" style="color: white">{{
                              cart.quantity
                              }}</span>
                            <span>
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="CONFIG.title === 'LuckMe'">
                  <div class="luckme-card">
                    <div class="luckme-image">
                      <span class="wishlist-heart"><i class="fa fa-heart fa-lg" (click)="addWishList(product)"
                          [ngStyle]="{
                            color: product.select ? '#BDC62B' : '#dcdcdc'
                          }" aria-hidden="true"></i></span>
                      <div *ngIf="
                          product.assets != undefined &&
                          product.assets.length != 0 &&
                          product.assets[0].image_source
                        ">
                        <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                          onerror="this.onerror=null;this.src='assets/images/vendor/No_Image_old.png';"
                          alt="{{ product.name }}" class="product-image" />
                        <div *ngIf="
                            product.assets.length === 0 ||
                            !product.assets[0].image_source
                          ">
                          <img src="assets/images/No_Image_old.png" id="img-list" (click)="productDetails(product.id)"
                            class="product-image" />
                        </div>
                      </div>
                    </div>
                    <div class="luckme-description text-center productTitleList">
                      <div class="product-description luckme-product-title" id="img-list"
                        (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                        id="{{ product.id }}" ngbPopover="{{
                          metaDataMapService.findData(
                            product,
                            fields[1].nestedinfo
                          )
                        }}" container="body" *ngIf="fields[1].visibility">
                        <div>
                          {{
                          metaDataMapService.findData(
                          product,
                          fields[1].nestedinfo
                          )
                          }}
                        </div>
                        <div>
                          <ngb-rating style="
                              color: #373b3f !important;
                              font-size: 11px !important;
                            " [max]="5" [(rate)]="currentRating" [readonly]="true"></ngb-rating>
                          <a style="
                              color: #373b3f !important;
                              font-size: 11px !important;
                            ">432 ratings|123 reviews</a>
                        </div>
                        <div class="luckme-worthy-price" id="priceListing">
                          <div *ngIf="
                              fields[3].visibility &&
                              product.product_type != 'Variable'
                            ">
                            SR
                            {{
                            metaDataMapService.findData(
                            product,
                            fields[3].nestedinfo
                            )
                            }}
                          </div>

                          <div *ngIf="
                              product.product_type == 'Variable' &&
                              product.type == 'Variable'
                            ">
                            SR
                            {{
                            product.pricing.raw.price_range
                            ? product.pricing.raw.price_range
                            : product.pricing.raw.price
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="luckme-cart-btn">
                        <button *ngIf="
                            appService.productIdinCart.indexOf(product.id) ==
                              -1 &&
                            product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1 &&
                              product.type != 'Variable'
                          " class="btn btn-primary luckme-btn" (click)="addToCart(product)">
                          Add to Cart
                        </button>
                        <button *ngIf="
                            product.product_type == 'Variable' ||
                            product.type == 'Variable'
                          " class="btn btn-primary luckme-btn" (click)="productDetails(product.id)">
                          Select Options
                        </button>
                        <!-- <button     class="btn btn-secondary listing"   *ngIf="(appService.productIdinCart.indexOf(product.id) != -1 && product.product_type!='Variable' && appService.productIdinCart.indexOf(product.id) > -1)"  routerLink="/cart">View Cart</button> -->
                        <div *ngFor="
                            let cart of appService.cartProducts.results;
                            let i = index
                          ">
                          <div class="btn btn-primary inq-btn-st ml-1 viewCart" *ngIf="
                              cart.product_id === product.id ||
                              cart.product_id === product.checkVariantInCart
                            ">
                            <span>
                              <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                            <span class="inq-sp-2" style="color: white">{{
                              cart.quantity
                              }}</span>
                            <span>
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="shubhcards-container" *ngIf="CONFIG.title === 'ShubhCards'">
                  <div class="shubhcards-card" >
                    <div class="shubhcards-image">
                      <!-- <span class="wishlist-heart" ><i class="fa fa-heart fa-lg"(click)="addWishList(product)" [ngStyle]="{'color':product.select ? '#BDC62B' : '#dcdcdc' }"  aria-hidden="true"></i></span>    -->
                      <div class="shubhcards-image-container" *ngIf="product.assets != undefined && product.assets.length != 0 && product.assets[0].image_source">
                        <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                          onerror="this.onerror=null;this.src='assets/images/vendor/No_Image_old.png';"
                          alt="{{ product.name }}" class="product-image-shubhcards" />
                        <div *ngIf="product.assets.length === 0 || !product.assets[0].image_source">
                          <img src="assets/images/No_Image_old.png" id="img-list" (click)="productDetails(product.id)"
                            class="product-image" />
                        </div>
                      </div>
                    </div>
                    <div class="shubhcards-description text-center productTitleList" style="display: table-caption" >
                      <div class="product-description shubhcards-product-title" id="img-list"
                        (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)}}" container="body" *ngIf="fields[1].visibility">
                        <div class="float-right-mob desktop-title-grid" >{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</div>
                        <!-- <p style="color: #373b3f">MOQ : {{product.pricing.raw.minimumorderquantity}}</p> -->
                        <div></div>
                        <div class="shubhcards-price" id="priceListing">
                          <div class="float-right-mob" *ngIf="fields[3].visibility && product.product_type != 'Variable'">₹{{metaDataMapService.findData(product,fields[3].nestedinfo)}}</div>
                          <div class="float-right-mob" *ngIf="product.product_type == 'Variable' && product.type == 'Variable'">₹{{product.pricing.raw.price_range? product.pricing.raw.price_range : product.pricing.raw.price}}</div>
                        </div>
                      </div>
                      <div class="shubhcards-cart-btn" style="margin-top: 5%">
                        <button *ngIf="appService.productIdinCart.indexOf(product.id) == -1 && product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1 && product.type != 'Variable'" 
                        class="btn btn-primary shubhcards-btn" (click)="addToCart(product)" style="background-color: #c50 !important; border:2px solid #150982 !important; padding: 5px 17px !important;">Add to Cart</button>
                        <button *ngIf="product.product_type == 'Variable' || product.type == 'Variable'" class="btn btn-primary shubhcards-btn" (click)="productDetails(product.id)">
                          Select Options
                        </button>
                        <!-- <button     class="btn btn-secondary listing"   *ngIf="(appService.productIdinCart.indexOf(product.id) != -1 && product.product_type!='Variable' && appService.productIdinCart.indexOf(product.id) > -1)"  routerLink="/cart">View Cart</button> -->
                        <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                          <div class="btn btn-primary inq-btn-st ml-1 shubhcards-view-cart" *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
                            <span>
                              <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                            <input type="number" style="width: 40%; text-align: center"
                              *ngIf="CONFIG.title == 'ShubhCards'" (change)="ChangeValue(i)"
                              [(ngModel)]="cart.quantity" />
                            <span class="inq-sp-2" *ngIf="CONFIG.title != 'ShubhCards'" style="color: white">{{
                              cart.quantity }}</span>
                            <span>
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="CONFIG.title === 'Murgasen'" class="col-md-12" style="margin-bottom: 20px">
                  <div class="murugesan-card1">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="murugasen-list-image" />
                    </div>
                    <div class="murugesan-description">
                      <div class="murugesan-card-title1">
                        {{ prodName(product.name) }}
                      </div>
                      <div class="murugesan-price" id="priceListing">
                        <div class="murugesan-price" *ngIf="
                            fields[3].visibility &&
                            product.product_type != 'Variable'
                          ">
                          SR
                          {{
                          metaDataMapService.findData(
                          product,
                          fields[3].nestedinfo
                          )
                          }}
                        </div>

                        <div class="murugesan-price" *ngIf="
                            product.product_type == 'Variable' &&
                            product.type == 'Variable'
                          ">
                          SR
                          {{
                          product.pricing.raw.price_range
                          ? product.pricing.raw.price_range
                          : product.pricing.raw.price
                          }}
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                          <div class="inner-star-icon pd-1">
                            <span [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 1
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked'
                              "></span>
                            <span [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 2
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked'
                              "></span>
                            <span [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 3
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked'
                              "></span>
                            <span [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 4
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked'
                              "></span>
                            <span [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 5
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked'
                              "></span>
                            <a routerLink="/product-review/{{ product.id }}" style="
                                font-size: 11px !important;
                                font-weight: 500 !important;
                              ">
                              {{
                              product && product.reviews
                              ? product.reviews.total_reviews
                              : 0
                              }}
                              reviews</a>
                          </div>
                          <div>
                            <i class="fa fa-info-circle fa-lg" style="color: #e48c8c" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 15px">
                      <button class="murugesan-addcart" (click)="addToCart(product)" *ngIf="
                          (product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                          (product.product_type == 'Variable' &&
                            appService.productIdinCart.indexOf(
                              product.checkVariantInCart
                            ) == -1) ||
                          (product.product_type == 'Simple' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                          (product.product_type == 'Variation' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1)
                        ">
                        Add to Cart
                      </button>
                      <div *ngIf="
                          appService.productIdinCart.indexOf(product.id) !=
                            -1 ||
                          appService.productIdinCart.indexOf(
                            product.checkVariantInCart
                          ) != -1
                        ">
                        <div *ngFor="
                            let cart of appService.cartProducts.results;
                            let i = index
                          ">
                          <div class="murugesan-addcart" style="
                              font-size: small;
                              font-weight: bold;
                              padding-left: 4px;
                              padding-right: 4px;
                            " *ngIf="
                              cart.product_id === product.id ||
                              cart.product_id === product.checkVariantInCart
                            ">
                            <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                            <span class="inq-sp-2" style="color: white">{{
                              cart.quantity
                              }}</span>
                            <span>
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="totalLength < 1">
            <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
          </div>
        </div>
        <pagination-controls *ngIf="totalLength > 0 && CONFIG.title === 'Murgasen'" class="my-pagination"
          (pageChange)="pageChange($event)" style="float: right" id="pagination-controls"></pagination-controls>
        <pagination-controls *ngIf="totalLength > 0 && CONFIG.title === 'LuckMe'" (pageChange)="pageChange($event)"
          style="margin-top: 14px; float: right" id="pagination-controls"></pagination-controls>
          <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
            style="float: right" id="pagination-controls"></pagination-controls>
      </div>
    </div>
    <div class="col-md-9" *ngIf="CONFIG.title === 'Aiema'" style="padding-right: 0px !important; padding-left: 0px !important">
      <div style="font-family: 'proxima-regular', 'sans-serif' !important;margin-left:10px;">
        <h2 class="text-primary" id="productListHead">Companies</h2>
        <div class="breadCrumbListing">
          <span class="home-breadcrumb" routerLink="">Home</span>
          <span><i class="px-2">/</i> <a style="cursor:pointer;color:black !important" (click)="clearAll()"> Companies</a> <span><i *ngIf="this.allInOneData[1]" class="px-2">/</i> {{this.allInOneData[1]}} </span> </span>
        </div>
        <div *ngIf="totalLength > 0" style="margin-left:-24px">
          <div class="row inq-pro-sec-st listProduct"
            style="margin-right: 0px !important; padding-right: 0px !important">
            <div *ngFor="
                let product of filterItemsOfType()
                  | paginate
                    : {
                        id: 'pagination-controls',
                        itemsPerPage: countPerPage,
                        currentPage: currentPageInPagination,
                        totalItems: totalLength
                      };
                let i = index
              ">
              <div id="aiema-listing">
                <div id="aiemacards" style="cursor: auto">
                  <div class="aiema text-center">
                    <div class="aiema-img-holder" style="cursor: pointer" (click)="productDetails(product.id)">
                      <div class="aiema-img text-center">
                        <img style="
                            height: 100px !important;
                            width: 100px !important;
                            object-fit: contain !important;
                          " [src]="product.company_profile.logo" />
                      </div>
                    </div>
                    <div class="aiema-description-holder">
                      <!-- <div class="aiema-title" style="font-size: 18px;">{{product.name | titlecase}}</div> -->
                      <div class="aiema-title" style="font-size: 18px">
                        {{ product.name }}
                      </div>
                      <div class="aiema-subtitle">
                        {{ product.categories[0].categories }}
                      </div>
                      <div class="aiema-tabs">
                        <ul class="nav nav-tabs">
                          <li class="nav-item" data-toggle="tooltip" data-placement="top" title="Company Profile">
                            <a data-toggle="tab" href="#profile{{ i }}" role="tab"><i class="fa fa-info-circle"
                                aria-hidden="true"></i></a>
                          </li>
                          <li class="nav-item" data-toggle="tooltip" data-placement="top" title="Company Contacts">
                            <a data-toggle="tab" href="#contacts{{ i }}" role="tab"><i class="fa fa-globe"
                                aria-hidden="true"></i></a>
                          </li>
                          <li data-toggle="tooltip" data-placement="top" title="Company Address">
                            <a data-toggle="tab" href="#location{{ i }}" role="tab"><i class="fa fa-map-marker"
                                aria-hidden="true"></i></a>
                          </li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div class="aiema-profile tab-pane fade show active" id="profile{{ i }}">
                          <div class="row">
                            <div class="col-sm-3 profile-title">Services:</div>
                            <div class="col-sm-9 profile-description">
                              {{
                              product.company_profile.type_of_services
                              ? product.company_profile.type_of_services
                              : "-"
                              }}
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 profile-title">Business:</div>
                            <div class="col-sm-9 profile-description">
                              {{ product.company_profile.nature_of_business }}
                            </div>
                          </div>
                        </div>
                        <div class="aiema-contact tab-pane fade" id="contacts{{ i }}">
                          <div class="row">
                            <div class="col-sm-3 contact-title">Mobile:</div>
                            <div class="col-sm-9 contact-description">
                              <a href="tel:{{ product.contact_details.mobile }}">{{ product.contact_details.mobile
                                }}</a>
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 contact-title">Email:</div>
                            <div class="col-sm-9 contact-description">
                              <a href="mailto: {{
                                  product.contact_details.email
                                }}">{{ product.contact_details.email }}</a>
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 contact-title">Website:</div>
                            <div class="col-sm-9 contact-description">
                              <a [attr.href]="
                                  '//' + product.contact_details.website
                                " target="_blank" target="_blank">{{ product.contact_details.website }}</a>
                            </div>
                          </div>
                        </div>
                        <div class="aiema-contact tab-pane fade" id="location{{ i }}">
                          <div class="row">
                            <div class="col-sm-4 contact-title">
                              Location:
                            </div>
                            <div class="col-sm-8 contact-description">
                              {{ product.company_details.location }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="aiema-submit-btn">
                        <!-- <button class="btn btn-block aiema-btn" (click)="submitEnquiry(product)">Submit Enquiry</button> -->
                        <button class="btn btn-block aiema-btn" (click)="productDetails(product.id)">
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img
            src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1"/>
            <button (click)="clearAll()" class="btn btn-block aiema-btn" style="font-family: 'proxima-regular','sans-serif' !important; font-weight: 600; border: none !important;" ><span class="fa fa-angle-left"></span> Back</button>
        </div>
        

        <pagination-controls *ngIf="totalLength > 0 && CONFIG.title === 'Aiema'" class="my-pagination"
          (pageChange)="pageChange($event)" style="float: right" id="pagination-controls"></pagination-controls>
      </div>
    </div>
    <div class="col-md-9" *ngIf="CONFIG.title === 'Cle'" style="padding-right: 0px !important; padding-left: 0px !important">
      <div style="font-family: 'proxima-regular', 'sans-serif' !important;margin-left:10px;">
        <h2 class="text-primary" id="productListHead">Companies</h2>
        <div class="breadCrumbListing">
          <span class="home-breadcrumb" routerLink="">Home</span>
          <span><i class="px-2">/</i> <a style="cursor:pointer;color:black !important" (click)="clearAll()"> Companies</a> <span><i *ngIf="this.allInOneData[1]" class="px-2">/</i> {{this.allInOneData[1]}} </span> </span>
        </div>
        <div *ngIf="totalLength > 0" style="margin-left:-24px">
          <div class="row inq-pro-sec-st clelistProduct"
            style="margin-right: 0px !important; padding-right: 30px !important">
            <div *ngFor="
                let product of filterItemsOfType()
                  | paginate
                    : {
                        id: 'pagination-controls',
                        itemsPerPage: countPerPage,
                        currentPage: currentPageInPagination,
                        totalItems: totalLength
                      };
                let i = index
              ">
              <div id="aiema-listing">
                <div id="clecards" style="cursor: auto">
                  <div class="aiema text-center">
                    <div class="aiema-img-holder" style="cursor: pointer" (click)="productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id)">
                      <div class="aiema-img text-center">
                        <img style="
                            height: 100px !important;
                            width: 100px !important;
                            object-fit: contain !important;
                          " [src]="product.company_profile.logo" />
                      </div>
                    </div>
                    <div class="aiema-description-holder">
                      <!-- <div class="aiema-title" style="font-size: 18px;">{{product.name | titlecase}}</div> -->
                      <div class="aiema-title" style="font-size: 18px">
                        {{ product.name }}
                      </div>
                      <div class="aiema-subtitle">
                        {{ product.categories[0].categories }}
                      </div>
                      <div class="aiema-tabs">
                        <ul class="nav nav-tabs">
                          <li  data-toggle="tooltip" data-placement="top" title="Company Profile">
                            <a data-toggle="tab" href="#profile{{ i }}" role="tab"><i class="fa fa-info-circle"
                                aria-hidden="true"></i></a>
                          </li>
                          <li  data-toggle="tooltip" data-placement="top" title="Company Contacts">
                            <a data-toggle="tab" href="#contacts{{ i }}" role="tab"><i class="fa fa-globe"
                                aria-hidden="true"></i></a>
                          </li>
                          <li data-toggle="tooltip" data-placement="top" title="Company Address">
                            <a data-toggle="tab" href="#location{{ i }}" role="tab"><i class="fa fa-map-marker"
                                aria-hidden="true"></i></a>
                          </li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div class="aiema-profile tab-pane fade show active" id="profile{{ i }}">
                          <div class="row">
                            <div class="col-sm-3 profile-title">Services:</div>
                            <div class="col-sm-9 profile-description">
                              {{
                              product.company_profile.type_of_services
                              ? product.company_profile.type_of_services
                              : "-"
                              }}
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 profile-title">Business:</div>
                            <div class="col-sm-9 profile-description">
                              {{ product.company_profile.nature_of_business }}
                            </div>
                          </div>
                        </div>
                        <div class="aiema-contact tab-pane fade" id="contacts{{ i }}">
                          <div class="row">
                            <div class="col-sm-3 contact-title">Mobile:</div>
                            <div class="col-sm-9 contact-description">
                              <a href="tel:{{ product.contact_details.mobile }}">{{ product.contact_details.mobile
                                }}</a>
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 contact-title">Email:</div>
                            <div class="col-sm-9 contact-description">
                              <a href="mailto: {{
                                  product.contact_details.email
                                }}">{{ product.contact_details.email }}</a>
                            </div>
                          </div>
                          <div class="row" style="padding-top: 5px">
                            <div class="col-sm-3 contact-title">Website:</div>
                            <div class="col-sm-9 contact-description" (click)="openLink(product.contact_details.website)" style="cursor: pointer;">
                              <span style="color: #0619ed;font-size: 14px;">{{product.contact_details.website ? product.contact_details.website : '-'}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="aiema-contact tab-pane fade" id="location{{ i }}">
                          <div class="row">
                            <div class="col-sm-4 contact-title">
                              Location:
                            </div>
                            <div class="col-sm-8 contact-description">
                              {{ product.company_details.location }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="aiema-submit-btn">
                        <!-- <button class="btn btn-block aiema-btn" (click)="submitEnquiry(product)">Submit Enquiry</button> -->
                       
                        <!-- <button class="btn btn-block button-leather" (click)="productDetails(product.id,product.name+'-'+product.id)"> -->
                        <button class="btn btn-block button-leather"  (click)="productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id)">
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img
            src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1"/>
            <!-- <button (click)="clearAll()" class="btn btn-block aiema-btn" style="font-family: 'proxima-regular','sans-serif' !important; font-weight: 600; border: none !important;" ><span class="fa fa-angle-left"></span> Back</button> -->
            <span (click)="clearAll()" class="aiema-btn" style="font-family: 'proxima-regular','sans-serif' !important; font-weight: 600; border: none !important;cursor: pointer;display: flex;
            justify-content: center;" ><span class="fa fa-angle-left" style="margin-top: 4px;margin-right: 5px;"></span> Back</span>
        </div>
        

        <pagination-controls *ngIf="totalLength > 0 && CONFIG.title === 'Cle'" class="my-pagination"
          (pageChange)="pageChange($event)" style="float: right" id="pagination-controls"></pagination-controls>
      </div>
    </div>

    <div class="col-md-9" *ngIf="CONFIG.title === 'Carience'|| CONFIG.title === 'Vimpro'||CONFIG.title === 'Karupattiraja'"
      style="padding-right: 0px !important; padding-left: 0px !important">
      <div>
        <div class="inq-menu-right-st">
          <h2 class="text-primary" id="productListHead">Products</h2>
          <div class="breadCrumbListing" *ngIf="CONFIG.title !== 'Vimpro'">
            <span class="home-breadcrumb" routerLink="">Home</span>
            <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
          </div>
          <div class="breadCrumbListing" *ngIf="CONFIG.title === 'Vimpro'">
              <span class="home-breadcrumb" routerLink="">Home</span>
              <span (click)="clearAll()"><i class="px-2">/</i> Products </span>
              <span><i class="px-2">/</i><h1 style="font-size: 0.9rem!important;display: inline-block!important;font-weight: 475!important;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif!important;">{{categoryName}}</h1></span>
          </div>
          <!-- <div *ngIf="CONFIG.title === 'Vimpro'">
            <a routerLink="">Home</a>
            <a (click)="clearAll()"><i class="px-2">/</i> Products </a>
            <a><h1 style="font-size: 0.9rem!important;display: inline-block!important;"><i class="px-2">/</i>{{categoryName}}</h1></a>
        </div> -->
          <div *ngIf="totalLength > 0" class="thumb1-deera">
            <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              <div class="row inq-pro-sec-st listProduct">
                <div class="product-list-cards-deera-promo">
                <span *ngFor="let product1 of product.discounts_text" style="margin-bottom: 7px !important">
                  <span *ngIf="product1.product_card_view_promotion" class="seller"> {{ product1.product_card_view_promotion }}</span>
                </span>
              </div>
               
               
                <div *ngIf="CONFIG.title === 'Carience'" class="carience-container">
                 
                  <div *ngIf="product.product_type=='Variable'" class="carience-card">
                    <div id="img-list" style="flex-basis: 100%;justify-content: center;
                    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                    }}" container="body" *ngIf="fields[1].visibility">
                  <div class="d-flex justify-content-between">
                    <div class="cariencetitle">
                      <p (click)="productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id)" class="product-list-tile1">{{product.name}}</p>
                    </div>
                  </div>
                  </div>
                    <!-- {{ product.variant.option_values[0] | json}} -->
                   
                    <div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
                        <div *ngIf="img_colour.is_default">
                          <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id)"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="carience-image-container" />
                        </div>
                    </div>
                    

<div>
  

<div style="display:flex">
<div class="dropdown" style="width:50%">
  <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
    <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionCarience(size.option,product.id,j)" class="dropdown-item">{{size.option}}</a>
  </div>
</div>
<div class="d-flex mt-1" style="float: right;width: 50%; justify-content: right !important;">
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>
</div>





<div  class="colour-select-container">
<div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let j = index" class="colour-select-image">
  
  <img [src]="img_colour.assets[0].image_source_thumbnail" id="img-list" (click)="selectColour(img_colour.color,product.id,j)" [class.active]="img_colour.is_default" class="colour-image"  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"   />
</div>
</div>
<div *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
<div *ngIf="price.is_default" style="display:flex">
  <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" (click)="productDetails(product.id)"
    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
    class="carience-image-container" /> -->

    <div class="carience-listing-price" >
      ₹{{price.pricing.raw.price}}
    </div>
    <div class="carience-strikethrough" >
      ₹{{price.pricing.raw.sale_price}}
    </div>
    <div class="carience-discount-percent" >
      {{price.pricing.raw.discount_percentage}}% off
    </div>
</div>
</div>


<div class="viewcart_list" style="display: flex; justify-content: center;" *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index">

<button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
-1" class="button-63"  (click)="addToCartcarience(price.id)" >
Add to Cart
</button>   

<!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
<div class="btn btn-primary inq-btn-st bombayViewCart listing_viewcart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
<span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
<span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
   <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 


</div>

<!-- <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
  <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
  <div *ngFor="let c of cart.subcart;let j= index" style="display: flex; justify-content: center;">
    <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
      <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
      <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
      <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
    </div>
  </div>
</div>
</div> -->
</div>
</div>

<div *ngIf="product.product_type=='Simple'" class="" style="color: lightgray">
<div class="">

<img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
  class="" />
</div>

<div class="">
<div id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
  id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
  }}" container="body" *ngIf="fields[1].visibility">
  <div class="d-flex justify-content-between">
    <div>
      <p (click)="productDetails(product.id)" class="product-list-tile1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</p>
    </div>
  </div>
</div>

<div class="d-flex justify-content-between mt-1">
  <div>
    <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
    appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
    appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
    appService.productIdinCart.indexOf(product.id) == -1)">

      <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
        <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
        <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
      </p>

    </span>
    <span  *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
      <span *ngFor="let cart of appService.cartProducts.results; let i = index">
        <span *ngIf="cart.product_id === product.id">
            <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
              <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
              <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / product.unit | number : "1.2-2"}}/piece</span>
            </p>
        </span>
      </span>
    </span>

  </div>
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>

<div class="d-flex justify-content-between">
  <button class="deera-atc"  
  (click)="addToCart(product)" *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
        appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
        appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
        appService.productIdinCart.indexOf(product.id) == -1)">
        ADD TO CART
    <span> <i class="fa fa-shopping-cart"></i></span>
  </button>


  <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
    <div *ngFor="let cart of appService.cartProducts.results; let i = index">
      <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
        <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
        <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
        <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      </div>
    </div>
  </div>
</div>
</div>
                    
                    </div>
                  </div>
                </div>
                
                <div *ngIf="CONFIG.title === 'Vimpro'" class="carience-container">
                 
                  <div *ngIf="product.product_type=='Variable'&&product.variant.variant_child" class="carience-card">
                    <div id="img-list" style="flex-basis: 100%;justify-content: center;
                    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                    }}" container="body" *ngIf="fields[1].visibility">
                    
                  <div class="d-flex justify-content-between" style="margin-left:auto;">
                    <div class="cariencetitle">
                      <p (click)="productDetails_vimpro(product.id,product.variant.option_values[product.current_index!=null?product.current_index:0].child[product.child_index].id)" class="product-list-tilevimpro">{{product.name}}</p>
                      
                    </div>
                    
                  </div>
                  <span (click)="productDetails_vimpro(product.id,product.variant.option_values[product.current_index!=null?product.current_index:0].child[product.child_index].id)" style="margin-left: auto;
                  font-weight: 500;
                  /* line-height: 5vh; */
                  padding: 0 0.4rem;
                  background: linear-gradient(to bottom right,#2554C7,#2554C7);
                  color: #fff;
                  max-height: 4vh;">{{product.product_material!=null?product.product_material[0].name:"Not Available"}}</span>
               
                  </div>
                    <!-- {{ product.variant.option_values[0] | json}} -->
                    <div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
                        <div *ngIf="img_colour.is_default">
                          <img [src]="img_colour.assets[0].image_source" id="img-list-vimpro" (click)="productDetails_vimpro(product.id,img_colour.id)"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="carience-image-container" />
                        </div>
                    </div>

<div>
  

<div style="display:flex">
<div class="dropdown" style="width:50%">
  <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
    <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionCarience(size.option,product.id,j)" class="dropdown-item">{{size.option}}</a>
  </div>
</div>
<div class="d-flex mt-1" style="float: right;width: 50%; justify-content: right !important;">
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>
</div>





<div  class="colour-select-container">
<div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let j = index" class="colour-select-image">
  
  <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="selectColour(img_colour.color,product.id,j)" [class.active]="img_colour.is_default" class="colour-image" />
</div>
</div>
<div *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
<div *ngIf="price.is_default" style="display:flex">
  <!-- <img [src]="img_colour.asset[0].image_source" id="img-list" (click)="productDetails(product.id)"
    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
    class="carience-image-container" /> -->

    <div class="carience-listing-price-1" *ngIf="CONFIG.title !== 'Vimpro'">
      ₹{{price.pricing.raw.price}}
    </div>
    <div class="carience-strikethrough" *ngIf="CONFIG.title !== 'Vimpro'">
      ₹{{price.pricing.raw.sale_price}}
    </div>
    <div class="carience-listing-price-1" *ngIf="CONFIG.title === 'Vimpro'">
      ₹{{price.pricing.raw.sale_price}}
    </div>
    <div class="carience-strikethrough" *ngIf="CONFIG.title === 'Vimpro'">
      ₹{{price.pricing.raw.price}}
    </div>
    <div class="carience-discount-percent" >
      {{price.pricing.raw.discount_percentage}}% off
    </div>
</div>
</div>


<div class="add-card-list" style="display: flex; justify-content: center;" *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index">

<button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
-1" class="button-63"  (click)="addtocartKarupatti(price.id)" >
Add to Cart
</button>   

<!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
<div class="btn btn-primary inq-btn-st bombayViewCart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
<span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreasekarupattiitem(appService.productIdinCart.indexOf(price.id))"></i></span>
<span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
   <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 


</div>

<!-- <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
  <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
  <div *ngFor="let c of cart.subcart;let j= index" style="display: flex; justify-content: center;">
    <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
      <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
      <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
      <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
    </div>
  </div>
</div>
</div> -->
</div>
</div>

<div *ngIf="product.product_type=='Simple'" class="" style="color: lightgray">
<div class="">

<img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
  class="" />
</div>

<div class="">
<div id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
  id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
  }}" container="body" *ngIf="fields[1].visibility">
  <div class="d-flex justify-content-between">
    <div>
      <p (click)="productDetails(product.id)" class="product-list-tilevimpro">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</p>
    </div>
  </div>
</div>

<div class="d-flex justify-content-between mt-1">
  <div>
    <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
    appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
    appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
    appService.productIdinCart.indexOf(product.id) == -1)">

      <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
        <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
        <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
      </p>

    </span>
    <span  *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
      <span *ngFor="let cart of appService.cartProducts.results; let i = index">
        <span *ngIf="cart.product_id === product.id">
            <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
              <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
              <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / product.unit | number : "1.2-2"}}/piece</span>
            </p>
        </span>
      </span>
    </span>

  </div>
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>

<div class="d-flex justify-content-between">
  <button class="deera-atc"  
  (click)="addToCart(product)" *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
        appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
        appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
        appService.productIdinCart.indexOf(product.id) == -1)">
        ADD TO CART
    <span> <i class="fa fa-shopping-cart"></i></span>
  </button>


  <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
    <div *ngFor="let cart of appService.cartProducts.results; let i = index">
      <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
        <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
        <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
        <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      </div>
    </div>
  </div>
</div>
</div>
                    
                    </div>
                  </div>

                  <div *ngIf="product.product_type=='Simple'" class="carience-card">
                    <div id="img-list" style="flex-basis: 100%;justify-content: center;
                    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                    }}" container="body" *ngIf="fields[1].visibility">
                    
                  <div class="d-flex justify-content-between">
                    <div class="cariencetitle">
                      <p (click)="productDetails(product.id)" class="product-list-tilevimpro">{{product.name}}</p>
                      
                    </div>
                    
                  </div>
                  <!-- <span (click)="productDetails(product.id)" style="margin-left: auto;
                  font-weight: 500;
                  /* line-height: 5vh; */
                  padding: 0 0.4rem;
                  background: linear-gradient(to bottom right,#2554C7,#2554C7);
                  color: #fff;
                  max-height: 3vh;">{{product.product_material.name[0]}}</span> -->
               
                  </div>
                    <!-- {{ product.variant.option_values[0] | json}} -->
                    <div  class="">
                        <div>
                          <img [src]="product.assets[0].image_source" id="img-list-vimpro" (click)="productDetails(product.id)"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                            class="carience-image-container" />
                        </div>
                    </div>
                    <div>
                      <p class="vimpro_head"style="">Color</p>
                   
                        <span class="bullet_point">&#x2022;</span>
                        <span class="vimpro_foot" *ngFor="let name of product.color;; let isLast=last">{{name.name}}<span *ngIf="!isLast">,</span></span>
  
   <p class="vimpro_head" >Material</p>
 
    <span class="bullet_point">&#x2022;</span><span class="vimpro_foot" *ngFor="let name of product.product_material;; let isLast=last">{{name.name}}<span *ngIf="!isLast">,</span></span>

  <p class="vimpro_head">Thickness</p>

    <span class="bullet_point">&#x2022;</span><span class="vimpro_foot" *ngFor="let name of product.thickness;; let isLast=last">{{name.name}}<span *ngIf="!isLast">,</span></span>
 
  <div class="" style="display: flex; justify-content: center;" >

    <div>
      
    
    
    <button class="button-62" (click)="submitEnquiryForVimpro(product)">
    Submit Enquiry
    </button>   
    
    
    
    <!-- <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
      <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
      <div *ngFor="let c of cart.subcart;let j= index" style="display: flex; justify-content: center;">
        <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
          <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
          <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
          <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
        </div>
      </div>
    </div>
    </div> -->
    </div>
    </div>
                    </div>
                      


                  </div>
                  <div *ngIf="product.product_type=='Variable'&&!product.variant.variant_child" class="carience-card">
                    <div id="img-list" style="flex-basis: 100%;justify-content: center;
                    display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                    }}" container="body" *ngIf="fields[1].visibility">
                    
                  <div *ngIf="product.product_material[0].name!=''" class="d-flex justify-content-between" style="margin-left:auto;overflow: hidden;">
                    <div class="cariencetitle">
                      <p (click)="productDetails_vimpro(product.id,product.variant.option_values[product.current_index!=null?product.current_index:0].id,'/'+currentCategoryTaz,product.name+'-'+product.id)" class="product-list-tilevimpro">{{product.name}}</p>
                      
                    </div>
                    
                  </div>
                  <div *ngIf="product.product_material==null||product.product_material[0].name==''" class="d-flex justify-content-between" style="overflow: hidden;">
                    <div class="cariencetitle">
                      <p (click)="productDetails_vimpro(product.id,product.variant.option_values[product.current_index!=null?product.current_index:0].id,'/'+currentCategoryTaz,product.name+'-'+product.id)" class="product-list-tilevimpro">{{product.name}}</p>
                      
                    </div>
                    
                  </div>
                  <span *ngIf="product.product_material!=null&&product.product_material[0].name!=''"(click)="productDetails(product.id)" style="margin-left: auto;
                  font-weight: 500;
                  /* line-height: 5vh; */
                  padding: 0 0.4rem;
                  background: linear-gradient(to bottom right,#2554C7,#2554C7);
                  color: #fff;
                  max-height: 3vh;">{{product.product_material[0].name}}</span>
               
                  </div>
                    <!-- {{ product.variant.option_values[0] | json}} -->
                    <!-- <div *ngFor="let img_colour of product.variant.option_values;let i = index" class="">
                    
                        <div *ngIf="img_colour.is_default"> -->
                          <div>
                            <div>
                              <img [src]="product.variant.option_values[product.current_index!=null?product.current_index:0].assets[0].image_source" id="img-list-vimpro" (click)="productDetails_vimpro(product.id,product.variant.option_values[product.current_index!=null?product.current_index:0].id,'/'+currentCategoryTaz,product.name+'-'+product.id)"
                              onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                              class="carience-image-container" />
                            </div>
                          </div>
                          
                        <!-- </div>
                    </div> -->

<div>
  

<div style="display:flex">
<div class="dropdown" style="width:50%">
  <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
    <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionCarience(size.option,product.id,j)" class="dropdown-item">{{size.option}}</a>
  </div>
</div>
<div class="d-flex mt-1" style="float: right;width: 50%; justify-content: right !important;">
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>
</div>


<div class="avail_colors">
  <p class="avl_label">Color:</p>
  <!-- <p class="avl_text">Available in all Standard Colors</p> -->
  <p class="avl_text" *ngFor="let name of product.color;; let isLast=last">{{name.name}}<span *ngIf="!isLast">,</span></p>

</div>


<!-- <div  class="colour-select-container">
<div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let j = index" class="colour-select-image">
  
  <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="selectColour(img_colour.color,product.id,j)" [class.active]="img_colour.is_default" class="colour-image" />
</div>
</div> -->
<!-- <div *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class=""> -->
<div class="vimpro_variable_false">
 

    <div class="carience-listing-price" >
      ₹{{product.variant.option_values[product.current_index!=null?product.current_index:0].pricing.raw.price}}
    </div>
    <!-- <div class="carience-strikethrough" >
      ₹{{product.variant.option_values[product.current_index!=null?product.current_index:0].pricing.raw.sale_price!=null?product.variant.option_values[product.current_index!=null?product.current_index:0].pricing.raw.sale_price:0}}
    </div>
    <div class="carience-discount-percent" >
      {{product.variant.option_values[product.current_index!=null?product.current_index:0].pricing.raw.discount_percentage!=null?product.variant.option_values[product.current_index!=null?product.current_index:0].pricing.raw.discount_percentage:0}}% off
    </div> -->
</div>
<!-- </div> -->


<div class="" style="display: flex; justify-content: center;" >

<button *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=null?product.current_index:0].id) ==
-1" class="button-63"  (click)="addtocartKarupatti(product.variant.option_values[product.current_index!=null?product.current_index:0].id)" >
Add to Cart
</button>   
<!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
<div class="btn btn-primary inq-btn-st bombayViewCart" id="quantity_button" *ngIf="appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=null?product.current_index:0].id) >=0">
<span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreasekarupattiitem(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=null?product.current_index:0].id))"></i></span>
<span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=null?product.current_index:0].id)].quantity}}</span>
   <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(product.variant.option_values[product.current_index!=null?product.current_index:0].id))"></i></span> 


</div>

<!-- <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
  <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
  <div *ngFor="let c of cart.subcart;let j= index" style="display: flex; justify-content: center;">
    <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
      <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
      <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
      <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
    </div>
  </div>
</div>
</div> -->
</div>
</div>

<div *ngIf="product.product_type=='Simple'" class="" style="color: lightgray">
<div class="">

<img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
  class="" />
</div>

<div class="">
<div id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
  id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
  }}" container="body" *ngIf="fields[1].visibility">
  <div class="d-flex justify-content-between">
    <div>
      <p (click)="productDetails(product.id)" class="product-list-tilevimpro">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</p>
    </div>
  </div>
</div>

<div class="d-flex justify-content-between mt-1">
  <div>
    <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
    appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
    appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
    appService.productIdinCart.indexOf(product.id) == -1)">

      <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
        <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
        <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
      </p>

    </span>
    <span  *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
      <span *ngFor="let cart of appService.cartProducts.results; let i = index">
        <span *ngIf="cart.product_id === product.id">
            <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
              <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
              <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / product.unit | number : "1.2-2"}}/piece</span>
            </p>
        </span>
      </span>
    </span>

  </div>
  <div class="inner-star-icon review-mob pd-1">
    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  </div>
</div>

<div class="d-flex justify-content-between">
  <button class="deera-atc"  
  (click)="addToCart(product)" *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
        appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
        appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
        appService.productIdinCart.indexOf(product.id) == -1)">
        ADD TO CART
    <span> <i class="fa fa-shopping-cart"></i></span>
  </button>


  <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
    <div *ngFor="let cart of appService.cartProducts.results; let i = index">
      <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
        <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
        <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
        <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      </div>
    </div>
  </div>
</div>
</div>
                    
                    </div>
                  </div>
                </div>
                
                <div
                *ngIf="
                CONFIG.title === 'Karupattiraja'
                "
                class="thumb3"
              >
                <div>
                  <div class="row inq-pro-sec-st listProduct">
                    <div
                      [class]="
                         'karupattiraja-product-list-cards'
                      "
                      style="color: lightgray"
                    >
                      <div>
                        <!------------tams img------>
                  
                        <img
                          [src]="product.assets[0].image_source"
                          id="img-list"
                          (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                          onerror="this.onerror=null;this.src='assets/images/mayan/no img.png';"
                          alt="{{ product.name }}"
                          class="product-list-image mayan_img_center"
                        />
                      </div>
                      <div class="product-list-description_karupatti description">
                        <div class="d-flex justify-content-between">
                          <div>
                            <p title="{{product.name}}"
                              class="product-list-tile-karupatti" 
                            >
                              {{
                                metaDataMapService.findData(
                                  product,
                                  fields[1].nestedinfo
                                )
                              }}
                            </p>
                          </div>
                  
                          <div class="inner-star-icon pd-1">
                            <span 
                              [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 1
                                  ? 'fa fa-star checked'  
                                  : 'fa fa-star unchecked1'
                              "
                            ></span>
                            <span  
                              [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 2
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked1'
                              "
                            ></span>
                            <span
                              [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 3
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked1'
                              "
                            ></span>
                            <span  
                              [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 4
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked1'
                              "
                            ></span>
                            <span  
                              [class]="
                                product &&
                                product.reviews &&
                                product.reviews.average >= 5
                                  ? 'fa fa-star checked'
                                  : 'fa fa-star unchecked1'
                              "
                            ></span>
      
      
      </div>
      
    </div>
                        <!----------variants------>
                        <app-shared-variants
                          [product]="product"
                          [products]="products"
                          
                        ></app-shared-variants>
      
                        <!-- <div>
      
                      <label class='note'  style="font-size: 11px !important; font-weight: 500 !important;color: black !important;">Note: Please select option to add item in
                          cart</label>
      
                  </div> -->
      
                        <!---------------------reviews---------------->
                        <div  
                          class="d-flex justify-content-between mt-1 review-section"
                          style="padding-top: -15px"
                        >
                        <div>
                          <p style="font-size :19px !important;"
                            [class]="'karupatti-product-list-price'
                            "
                            *ngIf="product.pricing.raw.price<=0||product.stock_status!='Available'"
                          >
                          Out of Stock
                          </p>
                          <p
                            [class]="'karupatti-product-list-price'
                            "
                            *ngIf="product.pricing.raw.price&&product.stock_status=='Available'"
                          >
                            ₹{{
                              product.pricing.raw.price
                            }}<span>{{product.sku.toLowerCase().includes('kg')?'/KG':product.sku.toLowerCase().includes('bott')?'/Bottle':product.sku.toLowerCase().includes('pack')?'/Packet':product.sku.toLowerCase().includes('box')?'/Box':product.sku.toLowerCase().includes('ml')?'/ML':product.sku.toLowerCase().includes('jar')?'/Jar':''}}</span>
                          </p>
                          
                        </div>
                          <div>
                           
                            <button *ngIf="appService.productIdinCart.indexOf(product.id) == -1&&product.pricing.raw.price>0&&product.stock_status=='Available'"
                              class="mayancartButton"
                              style="
                                font-size: small;
                                font-weight: bold;
                                width: 70px;position: relative;top: 5px;
                                border: 3px solid #3c2a26 !important;
                                color: #000000 !important;
                              "
                              (click)="addtocartKarupatti(product)"
     
                            >
                              ADD <span> <i class="fa fa-shopping-cart"></i></span>
                            </button>
                            <!---------view cart button-->
                            <div
                              *ngIf="
                                appService.productIdinCart.indexOf(product.id) !=
                                  -1 ||
                                appService.productIdinCart.indexOf(
                                  product.checkVariantInCart
                                ) != -1
                              "
                            >
                              <div
                                *ngFor="
                                  let cart of appService.cartProducts.results;
                                  let i = index
                                "
                              >
                                <div
                                  class="kprviewCart"
                                  *ngIf="
                                    cart.product_id === product.id ||
                                    cart.product_id === product.checkVariantInCart
                                  "
                                >
                                  <span>
                                    <i
                                      class="fa fa-minus mr-3"
                                      (click)="decreasekarupattiitem(i)"
                                      style="font-size: 12px; cursor: pointer"
                                    ></i
                                  ></span>
                                  <span class="inq-sp-2" style="color: white">{{
                                    cart.quantity
                                  }}</span>
                                  <span>
                                    <i
                                      class="fa fa-plus ml-3"
                                      (click)="increaseItem(i)"
                                      style="font-size: 12px; cursor: pointer"
                                    ></i
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
      
                        <!-- <div class="d-flex justify-content-end mt-1">
                                              <a class="product-list-cart">ADD TO CART +</a>
                                          </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              </div>
            </div>
          </div>
          <div *ngIf="totalLength < 1">
            <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
            <!-- <div id="noProductsDialog" class="no-products-container">
              <h3>No products available</h3>
              <p>Sorry, there are currently no products available in this category {{allInOneData[1]}}</p>
              <button class="no-products-button"><a routerlink="/" style="color: #375673 !important; font-weight: 450;" href="#/">GO BACK TO HOME</a></button>
            </div> -->
            
          </div>
          </div>
        <!-- </div> -->
        
        <pagination-controls *ngIf="totalLength >0" class="my-pagination" (pageChange)="pageChange($event)"
          style="float: right" id="pagination-controls">ttebx,nazx.nA>MZX/{{totalLength}}</pagination-controls>
      </div>
    </div>
    <!-- style="padding-right: 0px !important; padding-left: 0px !important" -->
    <div class="col-md-9" *ngIf="CONFIG.title === 'KatbookStore'"
    >
    <div>
      <div class="inq-menu-right-st">
        <div class="desktop-only" style="display: flex;">
          <h5 style="color: black!important;" class="text-primary desktop-only" id="productListHead">KatbookStore</h5>
        <h5 *ngIf="newBreadcrumbs==false" style="color: black!important;" class="text-primary desktop-only" id="productListHead"> &nbsp;>Books</h5>
        <h5  *ngIf="newBreadcrumbs==true" style="color: black!important;" class="text-primary desktop-only" id="productListHead"> &nbsp;>New Arrival</h5>

        </div>
        
        <h5 style="margin-left: 6%;color: #23a6f0!important;"   class="text-primary mobile-only" id="productListHead">KatbookStore</h5>
       
      
        <!-- <div *ngIf="CONFIG.title === 'Vimpro'">
          <a routerLink="">Home</a>
          <a (click)="clearAll()"><i class="px-2">/</i> Products </a>
          <a><h1 style="font-size: 0.9rem!important;display: inline-block!important;"><i class="px-2">/</i>{{categoryName}}</h1></a>
      </div> -->
        <div *ngIf="totalLength > 0" class="thumb1-kbook">
          <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
            <div class="row inq-pro-sec-st listProductkbook">
              <div class="product-list-cards-deera-promo">
              
            </div>
              <div  class="deera-container col-sm-3 col-md-4 col-lg-4 col-xl-4">
                <div class="card shadow-lg p-4 bg-body rounded kbookcrd" >
                  <div class="container" >
                    <div class="row">
                      <div class="col">
                        <div class="katbook_conimage container container_kbook" >
                          
                           <img [src]="product.assets[0].image_source" id="img-list"
                                                                            (click)="productDetails(product.id)"
                                                                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                                                                            alt="{{ product.name}}" class="product-list-image-kbook" style="object-fit: contain;max-width: 100%; max-height: 100%;position: absolute;  top: 0;left: 0; right: 0;  bottom: 0; margin: auto;">
                          
                            

                        </div>
                        <!-- <img [src]="product.assets[0].image_source" id="img-list"
                                                                            (click)="productDetails(product.id)"
                                                                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                                                                            alt="{{ product.name}}" class="product-list-image-kbook" style="object-fit: contain;"> -->
                                                                            
                                                                            
                      </div>
                    </div>
                  </div>
                  
                    
                  <div class="card-body"  class="desktop-only">
                    <div class="container" style="margin-top: 3%;">
                      <!-- <span style="display: flex;justify-content: center;color: #23a6f0;"><b>{{product.sku}}</b></span> -->
                      <div *ngIf="(product.name).length >15" style="display: flex;justify-content: center;color: black;font-weight:500;white-space: nowrap;cursor:pointer;  text-transform: uppercase;" data-toggle="tooltip" data-placement="bottom" title="{{product.name}}" class="desktop-only" >{{product.name.substring(0,20) }}...</div>
                      <div *ngIf="(product.name).length <15" style="display: flex;justify-content: center;color: black;font-weight:500;cursor:pointer;  text-transform: uppercase;" data-toggle="tooltip" data-placement="bottom" title="{{product.name}}" class="desktop-only">{{product.name}}</div>
                      <div *ngIf="product.attributes[0]" style="display: flex;justify-content: center;color: #a12a2a;font-weight:500;cursor:pointer" data-toggle="tooltip" data-placement="bottom" title="{{product.name}}" class="desktop-only">{{product.attributes[0].section_title}}</div>
                      <div *ngIf="product.categorynames" style="display: flex;justify-content: center;color: #23a6f0;font-weight:500;cursor:pointer" data-toggle="tooltip" data-placement="bottom" title="{{product.name}}" class="desktop-only">{{product.categorynames[0].name}}</div>
                      <div style="display: flex;justify-content: center;margin-top: 10%;
                      " >
            
                                                                              
                        <button   type="button" class="btn btn-outline-primary resp-bt" style="text-align-last: center;background-color: #23a6f0;color: white;border:none!important" (click)="productDetails(product.id)">Choose Book</button>
                      </div>
                    
                      <div  style="display: flex;justify-content: space-evenly;color: black;margin-top: 5%;"  class="desktop-only">
                        <!-- <span><b style="font-size:18px;">₹{{ product.pricing.raw.price}}</b></span> -->
                        <!-- <span style="
                        text-decoration: line-through;
                        color:#f8664a!important;
                       "  class="desktop-only">₹{{ product.pricing.raw.msrp}}</span> -->
                       </div>

                    </div>
                   
                  </div>
                  <div class="mobile-only">
                    <div class="container" style="width: 155px;">
                      <div style="height: 90px;">
                      <div  style="display: flex;;color: black;font-weight:500;cursor:pointer;width: 150px;" data-toggle="tooltip" data-placement="bottom" title="{{product.name}}" ><p style="font-size: 11px;width: 150px;" >{{product.name}}</p></div>

                      <div style="margin-top: 5%"  *ngIf="product.attributes[0]"> <span><b style="font-size:11px;text-transform: capitalize;">{{product.attributes[0].section_title}}</b></span>
                        <div style="margin-top: 5%" *ngIf="product.categorynames"> <span><b style="font-size:11px;text-transform: capitalize;">{{product.categorynames[0].name}}</b></span>
                        <!-- <span style="
                        text-decoration: line-through;
                        color:#f8664a!important;font-size: 13px;margin-left: 5px;" >₹{{ product.pricing.raw.msrp}}</span> -->
                      </div>
                    </div>
                  </div>
                      <div style="margin-top: 20%"><button   type="button" class="btn btn-outline-primary resp-bt" style="text-align-last: center;background-color: #23a6f0;color: white;border:none!important" (click)="productDetails(product.id)">Purchase</button>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
             
            
              
              
              
             
            
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
        </div>
      </div>
      <!-- <pagination-controls *ngIf="totalLength >0" class="my-pagination mobile-only" (pageChange)="pageChange($event)"
        style="float: right;" id="pagination-controls">ttebx,nazx.nA>MZX/{{totalLength}}</pagination-controls> -->
      <pagination-controls *ngIf="totalLength >0" class="my-pagination desktop-only" (pageChange)="pageChange($event)"
        style="position: absolute;bottom: 0;right: 0;" id="pagination-controls">ttebx,nazx.nA>MZX/{{totalLength}}</pagination-controls>
    </div>
  </div>
  <div class="col-md-12" *ngIf="CONFIG.title === 'Deera'"
      style="padding-right: 0px !important; padding-left: 0px !important">
      <div>
        <div class="inq-menu-right-st">
          <h2 class="text-primary" id="productListHead" style="margin-left: 7%;">Products</h2> 
          <div class="breadCrumbListing" style="margin-left: 7%;">
            <span class="home-breadcrumb" routerLink="">Home</span>
            <span (click)="clearAll()"><i class="px-2">/</i>Products</span><i class="px-2">/</i>{{currentCategoryTaz}}
          </div> 
         
          <div *ngIf="totalLength > 0" class="thumb2-deera">
            <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
              <div class="row inq-pro-sec-st listProduct">
                <div class="product-list-cards-deera-promo">
                <span *ngFor="let product1 of product.discounts_text" style="margin-bottom: 7px !important">
                  <span *ngIf="product1.product_card_view_promotion" class="seller"> {{ product1.product_card_view_promotion }}</span>
                </span>
              </div>
                <div *ngIf="CONFIG.title === 'Deera' && product.product_type=='Simple'" class="deera-container" [ngClass]="{'disabled': product.stock_status == 'Out of Stock'}">
                  <div class="product-list-cards-deera" style="color: lightgray">
                    <div class="deera-img" [ngClass]="{'disabled': product.stock_status == 'Out of Stock'}">
                      <!-- <span class="seller">Buy More Save More</span> -->

                      <!-- <div> -->
                      <!------------tams img------>
                      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="product-list-image-deera" />
                    </div>
                    <div class="product-list-description-deera">
                      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                        }}" container="body" *ngIf="fields[1].visibility">
                        <div class="d-flex justify-content-between">
                          <!-- <div> -->
                          <div>
                            <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null" class="product-list-tile-deera">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                            </p>
                          </div>
                          <!-- <div> -->
                          <!-- <p [class]="CONFIG.title=='Deera' list-label? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                          <!-- </div> -->
                        </div>
                      </div>
                    
                      <div class="d-flex justify-content-between mt-1">
                        <div>
                          <!-- <p *ngIf="showPricekey==='Sale Price'" class="product-list-price1">₹{{product.pricing.raw.price}}<span style="font-size: 14px !important;color: grey!important;">-taxes extra</span><span *ngIf="priceStrikeOutInListScreen==='true' && strikeOutPriceKey==='MSRP'" style="font-size: 14px !important;margin-left:5px !important;text-decoration: line-through;color: grey!important;">₹{{product.pricing.raw.msrp}}</span><span  style="font-size: 14px !important;margin-left:5px !important;color: grey!important;">- ₹{{product.pricing.raw.price/product.unit}}/piece</span></p> -->
                          <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
                          appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
                          appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
                          appService.productIdinCart.indexOf(product.id) == -1)">
                          <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
                            <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
                            <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
                          </p>
                          </span>
                          <span  *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
                            <span *ngFor="let cart of appService.cartProducts.results; let i = index">
                              <span *ngIf="cart.product_id === product.id">
                                <!-- <p class="product-list-price1">₹{{ cart.product.discount_value / cart.quantity | number : "1.2-2"}} -->
                                    <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
                                  <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
                                  <!-- <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.discount_value / product.unit / cart.quantity | number : "1.2-2"}}/piece</span> -->
                                  <span style="font-size: 14px !important;margin-left: 3px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / product.unit | number : "1.2-2"}}/piece</span>

                                </p>
                              </span>
                            </span>
                            <!-- <p class="product-list-price1">₹{{ discountValue / productQuantity | number : "1.2-2"}}
                              <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
                              <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{discountValue / product.unit / productQuantity | number : "1.2-2"}}/piece</span>
                            </p> -->
                          </span>
                    
                        </div>
                        <div class="inner-star-icon review-mob pd-1" *ngIf="CONFIG.title !== 'Deera'">
                          <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                        </div>
                      </div>
                      <div class="d-flex justify-content-center" *ngIf="product.stock_status == 'Available'">
                        <!-- <div> -->

                        <!-------------Add to cart-->

                        <button class="deera-atc"  
                        (click)="addToCart(product)" *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
                              appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
                              appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
                              appService.productIdinCart.indexOf(product.id) == -1)">
                          ADD TO CART
                          <span> <i class="fa fa-shopping-cart"></i></span>
                        </button>

                        <!---------view cart button-->
                        <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
                          <div *ngFor="let cart of appService.cartProducts.results; let i = index" class="d-flex justify-content-center">
                            <div [class]="CONFIG.title == 'Deera'? 'DeeraviewCart simple_add_deera' : 'mayanviewCart'" style="font-size: small;font-weight: bold;margin-top: 17%;text-align: center;display: flex; justify-content: center;" 
                            *ngIf="cart.product_id === product.id">
                              <span>
                                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
                              <input type="number" style="width: 40%; text-align: center" pattern="[0-9]" onkeypress="if(event.key==='.'){event.preventDefault();}"  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" min="1"  *ngIf="CONFIG.title == 'Deera'" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
                              <span>
                                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                  style="font-size: 12px; cursor: pointer"></i></span>
                            </div>
                          </div>
                        </div>

                        <!-- </div> -->
                      </div>
                      <div class="d-flex justify-content-center" style="margin-top: 10%;" *ngIf="product.stock_status == 'Out of Stock'">
                       <span style="color: #2554c7;font-weight: 700;">Out Of Stock</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="CONFIG.title === 'Deera' && product.product_type=='Variable'" class="deera-container" [ngClass]="{'disabled': product.stock_status == 'Out of Stock'}">
                  <div class="product-list-cards-deera_variable" style="color: lightgray">
                    <div class="deera-img" [ngClass]="{'disabled': product.stock_status == 'Out of Stock'}">
                      <!-- <span class="seller">Buy More Save More</span> -->

                      <!-- <div> -->
                      <!------------tams img------>
                      <img  *ngIf="product.stock_status == 'Out of Stock'" [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="product-list-image-deera" />
                        <img *ngIf="product.stock_status !== 'Out of Stock'" [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="product-list-image-deera" />
                    </div>
                    <div class="product-list-description-deera">
                      <div  id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                        id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                        }}" container="body" *ngIf="fields[1].visibility">
                        <div class="d-flex justify-content-between">
                          <!-- <div> -->
                          <div>
                            <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,'/'+currentCategoryTaz,product.name+'-'+product.id) : null" class="product-list-tile-deera1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                            </p>
                          </div>
                          <!-- <div> -->
                          <!-- <p [class]="CONFIG.title=='Deera' list-label? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                          <!-- </div> -->
                        </div>
                      </div>

                      <div class="d-flex justify-content-between mt-1">
                        <div>
                          <!-- <p *ngIf="showPricekey==='Sale Price'" class="product-list-price1">₹{{product.pricing.raw.price}}<span style="font-size: 14px !important;color: grey!important;">-taxes extra</span><span *ngIf="priceStrikeOutInListScreen==='true' && strikeOutPriceKey==='MSRP'" style="font-size: 14px !important;margin-left:5px !important;text-decoration: line-through;color: grey!important;">₹{{product.pricing.raw.msrp}}</span><span  style="font-size: 14px !important;margin-left:5px !important;color: grey!important;">- ₹{{product.pricing.raw.price/product.unit}}/piece</span></p> -->
                          <!-- <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
                          appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
                          appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
                          appService.productIdinCart.indexOf(product.id) == -1)">
                          <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
                            <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
                            <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
                          </p>
                          </span> -->
                          <span class="col-right" *ngFor="let items of product.variant.option_values; let j = index">
                          <div *ngIf="(appService.productIdinCart.indexOf(items.id) == -1) || (product.product_type == 'Variation' &&
                          appService.productIdinCart.indexOf(items.id) == -1)"  style="display: flex;"> 
                          
                           
                            <p *ngIf="items.is_default" class="product-list-price1" >
                                ₹{{items.pricing.raw.price}}
                              
                               <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP' && items.is_default" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ items.pricing.raw.msrp }}</span>
                            <span *ngIf="items.is_default" style="font-size: 14px !important;margin-left: 3px !important;color: grey !important;">₹{{items.pricing.raw.price / items.unit| number : "1.2-2"}}/piece</span>
                          </p>
                          
                        </div>  
                      </span>
                        <span *ngFor="let items of product.variant.option_values; let j = index">
                            <span  *ngIf="appService.productIdinCart.indexOf(items.id) != -1">
                              <span *ngFor="let cart of appService.cartProducts.results; let i = index">
                                <span *ngIf="cart.product_id === items.id" style="display: flex;">
                                  <span *ngIf="items.is_default">
                                  <!-- <p class="product-list-price1">₹{{ cart.product.discount_value / cart.quantity | number : "1.2-2"}} -->
                                      <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
                                    <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ cart.product.pricing.raw.msrp }}</span>
                                    <!-- <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.discount_value / product.unit / cart.quantity | number : "1.2-2"}}/piece</span> -->
                                    <span style="font-size: 14px !important;margin-left: 3px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / cart.product.unit | number : "1.2-2"}}/piece</span>
  
                                  </p>
                                </span>
                                </span>
                              </span>
                              </span>
                              <!-- <p class="product-list-price1">₹{{ discountValue / productQuantity | number : "1.2-2"}}
                                <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
                                <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{discountValue / product.unit / productQuantity | number : "1.2-2"}}/piece</span>
                              </p> -->
                            </span>
                        </div>
                        <div class="inner-star-icon review-mob pd-1" *ngIf="CONFIG.title !== 'Deera'">
                          <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                          <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                        </div>
                      </div>
                      <div class="col-right" id="simple" *ngIf="CONFIG.title ==='Deera'">
                        <div class="col-right">
                          <p class="sizeText">{{ product.variant.name }} :</p>
                        </div>
                        <div class="col-right btn-group" *ngFor="let items of product.variant.option_values; let j = index">
                          <button type="button" id="button" 
                            class="sizebox sizebutton" [class.active]="items.is_default" (click)="onConfirm1(product,items,items.id,j)" value="items.id">
                            {{ items.option }}
                          </button>
                          <hr />
                        </div>
                      </div>
                      <div *ngIf="product.stock_status == 'Available'">
                      <div class="" *ngFor="let price of product.variant.option_values;let i = index" style="display: flex;
                    justify-content: center;">
  
                      <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==-1" class="deera-atc1" (click)="addToCartDeera(price.id,product)" [disabled]="isDisabled">
                      ADD TO CART
                      <span> <i class="fa fa-shopping-cart"></i></span>
                      </button>   
                      
                      
                      <div [class]="CONFIG.title == 'Deera'? 'DeeraviewCart' : 'mayanviewCart'" style="font-size: small;font-weight: bold;margin-top: 12px;text-align: center;" 
                       *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
                          
                            <span><i class="fa fa-minus mr-2" style="font-size: 12px; cursor: pointer"
                                (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
                            <!-- <span class="inq-sp-2"
                              style="padding-left: 10px;
                        padding-right: 15px;">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span> -->
                        <input type="number" style="width: 40%; text-align: center" onkeypress="return event.charCode >= 48" min="1"
                        (input)="changeDeeraVarValue(appService.productIdinCart.indexOf(price.id),$event)" [(ngModel)]="appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity" />
                            <span><i class="fa fa-plus mr-2" style="font-size: 12px; cursor: pointer;padding-left: 7px;"
                                (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
        
        
                          </div>
                      </div>
                      </div>
                      <div *ngIf="product.stock_status == 'Out of Stock'" style="display: flex;
                      justify-content: center;margin-top: 10%;">
                       <span style="color: #2554c7;font-weight: 700;">Out Of Stock</span>
                      </div>
                    </div>
                  </div>
                </div>                
                
              </div>
            </div>
          </div>
          <div *ngIf="totalLength < 1">
            <!-- <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" /> -->
            <div id="noProductsDialog" class="no-products-container">
              <!-- <img src="path/to/no-products-image.png" alt="No products available"> -->
              <h3>No products available</h3>
              <p>Sorry, there are currently no products available in this category {{allInOneData[1]}}</p>
              <button class="no-products-button"><a routerlink="/" style="color: #375673 !important; font-weight: 450;" href="#/">GO BACK TO HOME</a></button>
            </div>
            
          </div>
          </div>
        <!-- </div> -->
        
        <pagination-controls *ngIf="totalLength >0" class="my-pagination" (pageChange)="pageChange($event)"
          style="float: right" id="pagination-controls">ttebx,nazx.nA>MZX/{{totalLength}}</pagination-controls>
      </div>
    </div>
   


    <div class="col-md-9" *ngIf="CONFIG.title === 'Beaubelle'" style="padding-right: 0px !important;padding-left: 0px !important;">
      <div>
        <div class="inq-menu-right-st">
            <h2 class="text-primary" id="productListHead">Products</h2>
                <div class="breadCrumbListing"><span class="home-breadcrumb" routerLink="">Home</span>
                    <span><i class="px-2">/</i></span>
                    <!-- <span>{{bbcrumb[0]}}</span> -->
                    <span> Products</span>

                        </div>
                        <div *ngIf="totalLength>0" class="thumb1">
                            <div *ngFor="let product of filterItemsOfType() |  paginate: { id:'pagination-controls',itemsPerPage: countPerPage, currentPage: currentPageInPagination, totalItems: totalLength };let i = index">
                                <div class="row inq-pro-sec-st listProduct">
                                    
                                    <span *ngFor="let product1 of product.discounts_text" style="margin-bottom: 7px!important;">
                                     <span *ngIf="product1.product_card_view_promotion" class="seller">
                                       {{product1.product_card_view_promotion}}
                                     </span>
                                    </span>
                                   
                                    <div *ngIf="CONFIG.title === 'Beaubelle'">
                                       
                                                  
                                                    <div class="product-list-cards1" style="color: black;">
                                                       
                                                    <div style="text-align: center;">
                                                           
                                                        <img [src]="product.assets[0].image_source" id="img-list"
                                                                            (click)="productDetails(product.id)"
                                                                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                                                                            alt="{{ product.name}}" class="product-list-image1">
                                                    </div>
                                                    <div class="product-list-description1" >
                                                    <div id="img-list"
                                                    (mouseenter)="mouseEnter(product.id) "
                                                    (mouseleave)="mouseLeave(product.id)" id='{{product.id}}'
                                                    ngbPopover="{{metaDataMapService.findData(product,
                                                            fields[1].nestedinfo)}}" container="body"
                                                    *ngIf="fields[1].visibility">
                                                        <div class="d-flex justify-content-between">
                                                            
                                                            <div>
                                                                <p  (click)="productDetails(product.id)" class="product-list-tile1" style="position: relative; height: 50px;">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</p>
                                                            </div>
                                                            
                                                        </div>
                                                    </div> 
                                                         
                                                        <div class="d-flex justify-content-between mt-1" >
                                                            
                                                            <div>
                                                              <p  *ngIf="product.pricing.raw.price!==0" class="product-list-price11" style="font-size: 16px;color: #e7762d ;font-weight: 600">₹{{ product.pricing.raw.price}}
                                                                </div> 
                                                                <div class="inner-star-icon pd-1">
                                                                    
                                                                   
                                                                   <span [class]="product && product.reviews && product.reviews.average >= 1 ? 'fa fa-star checked' : 'fa fa-star-o'" ></span>
                                                                   <span [class]="product && product.reviews && product.reviews.average >= 2 ? 'fa fa-star checked' : 'fa fa-star-o'"></span>
                                                                   <span [class]="product && product.reviews && product.reviews.average >= 3 ? 'fa fa-star checked' : 'fa fa-star-o'"></span>
                                                                   <span [class]="product && product.reviews && product.reviews.average >= 4 ? 'fa fa-star checked' : 'fa fa-star-o'"></span>
                                                                   <span  [class]="product && product.reviews && product.reviews.average >= 5 ? 'fa fa-star checked' : 'fa fa-star-o'"></span>                                                         
                                                                   
                       
                                                               </div>
                                                            
                                                        </div>
                                                        
                                                       
                    
                                                        
                                                        <div class="d-flex justify-content-between">
                                                      
                                                         
                                                                
                    
                                                        
                                                        <button  class="cartButton_bb"
                                                        (click)="addToCart(product)"
                                                       *ngIf="((product.product_type != 'Variable'&& appService.productIdinCart.indexOf(product.id) == -1  ) || (product.product_type == 'Variable' && appService.productIdinCart.indexOf(product.checkVariantInCart) == -1 )||(product.product_type == 'Simple' && appService.productIdinCart.indexOf(product.id) == -1  ) || (product.product_type == 'Variation' && appService.productIdinCart.indexOf(product.id) == -1  )) && product.pricing.raw.price!==0">ADD TO CART<span><i class="fa fa-shopping-cart"></i></span></button>
                                                       <button  class="enqButton" (click)="submitEnquiry(product)" *ngIf="product.pricing.raw.price==0">SUBMIT ENQUIRY</button>
                                                  
                                                   <div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1 ">
                                                   <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                                                   
                                                        <div [class]="CONFIG.title=='Beaubelle'?'viewCart':'mayanviewCart'"   style="font-size: small;font-weight: bold;width:75%;margin-left:22%;margin-top:4px;text-align: center;"   *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart" >
    
                    
                                                       <span>
                                                           <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                                               style="font-size:12px;cursor:pointer;"></i></span>
                                                               <!-- <input type="number" style="width:40%;text-align:center;" *ngIf="CONFIG.title=='Deera'" (change)="ChangeDeeraValue(i)" [(ngModel)]="cart.quantity"> -->
                                                               <input type="number" style="width:40%;text-align:center;" *ngIf="CONFIG.title=='Beaubelle'" (input)="changeDeeraValue(i,product.id, $event)" [(ngModel)]="cart.quantity"  readonly="">
                                                               
    
    
                                                        
                                                       <span>
                                                           <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                                               style="font-size:12px;cursor:pointer;"></i></span>
                                                  </div>
                    
                                                   </div>
                                                   </div>
                    
                    
                                                           
                                                        </div>
                    
                                                      
                                                    </div>
                                                </div>
                                             
                                    </div>
                              
                                </div>
                            </div>
                        </div>
                        <div *ngIf="totalLength < 1">
                            <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1">
                        </div>
                    </div>
                    <pagination-controls *ngIf="totalLength>0  && CONFIG.title === 'Beaubelle'" class="my-pagination" (pageChange)="pageChange($event)"
                    style="float: right;" id="pagination-controls"></pagination-controls>
                  </div>
                </div>
              <div class="col-md-9" *ngIf="CONFIG.title === 'Kubendran'"
    style="padding-right: 0px !important; padding-left: 0px !important">
    <div>
      <div class="inq-menu-right-st">
        <ul style="display:flex">

          <li>
            <p class="respfilter">
              <span><b>Items found</b></span> - {{ totalItemsOrProducts }}
            </p>
          </li>
          <li style="margin-left:auto">
            <p class="respfilter">
              Filters
              <i class="fa fa-filter" (click)="openNavkub()"></i>
            </p>
          </li>
        </ul>
        
       
        <h2 class="text-primary" id="productListHead">Products</h2>
        <div class="breadCrumbListing">
          <span class="home-breadcrumb" routerLink="">Home</span>
          <span><i class="px-2">/</i> Products</span>
          <span> </span>
          
          
          
          
        </div>
        
        <div *ngIf="totalLength > 0" class="thumbkub">
          <div *ngFor="
              let product of filterItemsOfType()
                | paginate
                  : {
                      id: 'pagination-controls',
                      itemsPerPage: countPerPage,
                      currentPage: currentPageInPagination,
                      totalItems: totalLength
                    };
              let i = index
            ">
            <div class="row inq-pro-sec-st listProduct">
              <!-- <span class="seller">Buy More Save More</span> -->
              <span *ngFor="let product1 of product.discounts_text" style="margin-bottom: 7px !important">
                <span *ngIf="product1.product_card_view_promotion" class="seller">
                  {{ product1.product_card_view_promotion }}
                </span>
              </span>
              <div *ngIf="CONFIG.title === 'Kubendran'" class="carience-container">
                 
                <div *ngIf="product.product_type=='Variable'" class="carience-card">
                  <div id="img-list" style="flex-basis: 100%;justify-content: center;
                  display: flex; " (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)" id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
                  }}" container="body" *ngIf="fields[1].visibility">
                <div class="d-flex justify-content-between">
                  <div class="cariencetitle">
                    <p (click)="productDetails(product.id)" class="product-list-tilekub">{{product.name}}</p>
                  </div>
                </div>
                </div>
                <div  class="">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="carience-image-container" />
                  </div>
              </div>
                  <!-- {{ product.variant.option_values[0] | json}} -->
                  <!-- <div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
                      <div *ngIf="img_colour.is_default">
                        <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                          class="carience-image-container" />
                      </div>
                  </div> -->

<div class="shop_respkub">


<div>
<div class="select_quantity">
  <p *ngFor="let size of product.variant.option_values;let j=index"  (click)="selectOptionCarience(size.option,product.id,j)" class="dropdown-itemkubendran" [class.active]="product.variant.option_values[product.current_index!=null?product.current_index:0].option==size.option">{{size.option}}</p>

</div>
<!-- <div class="dropdown" style="width:50%">
 <button class="dropdown-toggle dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  {{product.variant.option_values[product.current_index!=null?product.current_index:0].option}}
</button>
<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
  <a *ngFor="let size of product.variant.option_values;let j=index" (click)="selectOptionCarience(size.option,product.id,j)" class="dropdown-item">{{size.option}}</a>
</div>
</div> -->

</div>





<div  class="colour-select-container">
<div *ngFor="let img_colour of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let j = index" class="colour-select-image">
  <!-- <a  (click)="selectColour(img_colour.color,product.id,j)" class="dropdown-item">{{img_colour.type}}</a> -->
<button (click)="selectColour(img_colour.color,product.id,j)" class="cartButtonkubweight" [class.active]="img_colour.is_default">{{img_colour.type}}</button>
<!-- <img [src]="img_colour.assets[0].image_source" id="img-list" (click)="selectColour(img_colour.color,product.id,j)" [class.active]="img_colour.is_default" class="colour-image" /> -->
</div>
</div>
<div *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index" class="">
<div *ngIf="price.is_default" style="display:flex">
<!-- <img [src]="img_colour.asset[0].image_source" id="img-list" (click)="productDetails(product.id)"
  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
  class="carience-image-container" /> -->

  <div class="carience-listing-price" >
    ₹{{price.pricing.raw.price}}
  </div>
  <div class="carience-strikethrough" >
    ₹{{price.pricing.raw.sale_price}}
  </div>
  <div class="carience-discount-percent" >
    {{price.pricing.raw.discount_percentage}}% off
  </div>
  <div class="d-flex mt-1" style="float: right;width: 42%; justify-content: right !important;">
    <div class="inner-star-icon review-mob pd-1">
      <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
      <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
      <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
      <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
      <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
    </div>
    </div>
</div>
</div>


<div class="" style="display: flex; justify-content: center;" *ngFor="let price of product.variant.option_values[product.current_index!=null?product.current_index:0].child;let i = index">

<button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
-1" class="cartButtonkub"  (click)="addToCartcarience(price.id)" >
Add to Cart
</button>   

<!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
<div class="btn btn-primary inq-btn-st bombayViewCart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
<span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
<span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
 <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 


</div>

<!-- <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
<div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
<div *ngFor="let c of cart.subcart;let j= index" style="display: flex; justify-content: center;">
  <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
    <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
    <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
    <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
  </div>
</div>
</div>
</div> -->
</div>
</div>

<div *ngIf="product.product_type=='Simple'" class="" style="color: lightgray">
<div class="">

<img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
class="" />
</div>

<div class="">
<div id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
id="{{ product.id }}" ngbPopover="{{metaDataMapService.findData(product,fields[1].nestedinfo)
}}" container="body" *ngIf="fields[1].visibility">
<div class="d-flex justify-content-between">
  <div>
    <p (click)="productDetails(product.id)" class="product-list-tile1">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}</p>
  </div>
</div>
</div>

<div class="d-flex justify-content-between mt-1">
<div>
  <span *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
  appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
  appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
  appService.productIdinCart.indexOf(product.id) == -1)">

    <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price1">₹{{ product.pricing.raw.price}}
      <span *ngIf="priceStrikeOutInListScreen === 'true' && strikeOutPriceKey === 'MSRP'" style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
      <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{product.pricing.raw.price / product.unit| number : "1.2-2"}}/piece</span>
    </p>

  </span>
  <span  *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
    <span *ngFor="let cart of appService.cartProducts.results; let i = index">
      <span *ngIf="cart.product_id === product.id">
          <p class="product-list-price1">₹{{ cart.product.per_quantity_amount | number : "1.2-2"}}
            <span style="font-size: 14px !important;margin-left: 5px !important;text-decoration: line-through;color: grey !important;">₹{{ product.pricing.raw.msrp }}</span>
            <span style="font-size: 14px !important;margin-left: 5px !important;color: grey !important;">- ₹{{cart.product.per_quantity_amount / product.unit | number : "1.2-2"}}/piece</span>
          </p>
      </span>
    </span>
  </span>

</div>
<div class="inner-star-icon review-mob pd-1">
  <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
  <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
</div>
</div>

<div class="d-flex justify-content-between">
<button class="deera-atc"  
(click)="addToCart(product)" *ngIf="(product.product_type != 'Variable' && appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variable' &&
      appService.productIdinCart.indexOf(product.checkVariantInCart) == -1) || (product.product_type == 'Simple' &&
      appService.productIdinCart.indexOf(product.id) == -1) || (product.product_type == 'Variation' &&
      appService.productIdinCart.indexOf(product.id) == -1)">
      ADD TO CART
  <span> <i class="fa fa-shopping-cart"></i></span>
</button>


<div *ngIf="appService.productIdinCart.indexOf(product.id) != -1 || appService.productIdinCart.indexOf(product.checkVariantInCart) != -1">
  <div *ngFor="let cart of appService.cartProducts.results; let i = index">
    <div class="mayanviewCart" style="font-size: small;font-weight: bold;width: 75%;margin-left: 22%;margin-top: 4px;text-align: center;" *ngIf="cart.product_id === product.id">
      <span><i class="fa fa-minus mr-3" (click)="decreaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
      <input type="number" style="width: 40%; text-align: center" (input)="changeDeeraValue(i,product.id, $event)"[(ngModel)]="cart.quantity" />
      <span><i class="fa fa-plus ml-3" (click)="increaseItem(i)" style="font-size: 12px; cursor: pointer"></i></span>
    </div>
  </div>
</div>
</div>
</div>
                  
                  </div>
                </div>
              </div>
              <!-- <span *ngIf="product.product_card_view_promotion" class="seller">{{product.product_card_view_promotion}}</span> -->
              
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
        </div>
      </div>
      <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
        style="float: right" id="pagination-controls"></pagination-controls>
    </div>
  </div>
 

    <div class="col-md-9" *ngIf="CONFIG.title === 'BestGifts'"
    style="padding-right: 0px !important; padding-left: 0px !important">
    <div>
      <style>

  @media (max-width: 1920px) {
  .cartButton{
    font-size: small;
    font-weight: bold;
    width: 50%;
    margin-left: 25%;
    margin-top: 4px;
    background-color: transparent !important;
    border: 3px solid #3c707c !important;
    color: #091214 !important;
  }
  .cartButton1{
    font-size: small;
    font-weight: bold;
    width:152%;
    margin-left:99%;
    margin-top:4px;
    text-align: center;
    background-color:#3C57A6;
  }

  .product-list-image1{
  min-height: 270px !important;
  max-height: 270px !important;
  width: 100% !important;
  border-radius: 10px !important;
  object-fit: contain;
}
.product-list-image-kbook{
 /* min-height: 20px !important; */
  /* max-height: 270px !important; */
  width: 100% !important;
  border-radius: 10px !important;
  object-fit: contain;
}
}


@media (min-width: 360px) and (max-width: 600px) {
  .cartButton{
    font-size: small;
    font-weight: bold;
    width: 98%;
    margin-left: 0%;
    margin-top: 4px;
    background-color: transparent !important;
    border: 3px solid #3c707c !important;
    color: #091214 !important;
  }
  .cartButton1{
    font-size: small;
    font-weight: bold;
    width:182%;
    margin-left:0%;
    margin-top:4px;
    text-align: center;
    background-color:#3C57A6;
  }

  .product-list-image1{
  min-height: 170px !important;
  max-height: 170px !important;
  width: 100% !important;
  border-radius: 10px !important;
  object-fit: contain;
}
.product-list-image-kbook{
  min-height: auto !important;
  max-height: auto !important;
  width: 100% !important;
  border-radius: 10px !important;
  object-fit: contain;
}
}
      </style>
      <div class="inq-menu-right-st">
        <h2 class="text-primary" id="productListHead">Products</h2>
        <div class="breadCrumbListing">
          <span class="home-breadcrumb" routerLink="">Home</span>
          <span *ngIf="CONFIG.title != 'BestGifts'"><i class="px-2">/</i> Products</span>
          <span *ngIf="CONFIG.title === 'BestGifts'"><i class="px-2">/</i> Shop</span>
          <span> </span>
         
          <select name="SORT BY" id=" SORT BY" class="sort" (change)="selectSort($event.target.value)" >
            <option value="sort" style="font-size: 13px;">Sort by: Recommended</option>
            <option value="Low to High"   style="font-size: 13px;">Price: Low to High</option>
            <option value="High to Low"  style="font-size: 13px;" >Price: High to Low</option>
          </select>
          



          <!-- <div class="dropdown"  style="margin-left: 699px">
            <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
              SORT BY
            </button>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" value="1" (click)="getLowtoHighProducts($event.target.value)">Price: Low to High</a></li>
              <li><a class="dropdown-item"  value="1" (click)="getHightoLowProducts($event.target.value)">Price: High to Low</a></li>
              
            </ul>
          </div> -->
        </div>
        <!-- <div *ngIf="totalLength > 0" class="thumb1" style="margin-left: 23px!important;"> -->
          <div *ngIf="totalLength > 0" class="row g-3 g-md-4 row-cols-2 row-cols-md-3 row-cols-lg-3" style="margin-left: 17px!important;">
          <div *ngFor="
              let product of filterItemsOfType()
                | paginate
                  : {
                      id: 'pagination-controls',
                      itemsPerPage: countPerPage,
                      currentPage: currentPageInPagination,
                      totalItems: totalLength
                    };
              let i = index
            ">
            <div class="inq-pro-sec-st listProduct1">
              <!-- <span class="seller">Buy More Save More</span> -->
              <span *ngFor="let product1 of product.discounts_text" style="display: block;height: 0px;">
                <span *ngIf="product1.product_card_view_promotion" class="seller">
                  {{ product1.product_card_view_promotion }}
                </span>
              </span>
              <!-- <span *ngIf="product.product_card_view_promotion" class="seller">{{product.product_card_view_promotion}}</span> -->
              <div *ngIf="CONFIG.title === 'BestGifts'" style="margin-bottom:30px!important">

                <div class="bestgifts-list-cards" style="color: lightgray">
                  <!-- <div style="color: lightgray"> -->
                  <div style="text-align: center">
                    <!-- <span class="seller">Buy More Save More</span> -->

                    <!-- <div> -->
                    <!------------tams img------>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="product-list-image1" />
                  </div>
                  <div class="product-list-description1">
                    <div id="img-list" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                      id="{{ product.id }}" ngbPopover="{{
                        metaDataMapService.findData(
                          product,
                          fields[1].nestedinfo
                        )
                      }}" container="body" *ngIf="fields[1].visibility">
                      <div class="d-flex justify-content-between">
                        <!-- <div> -->
                        <div>
                          <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null" class="product-list-tile2">
                            {{
                            metaDataMapService.findData(
                            product,
                            fields[1].nestedinfo
                            )
                            }}
                          </p>
                        </div>
                        <!-- <div> -->
                        <!-- <p [class]="CONFIG.title=='Deera' ? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                        <!-- </div> -->
                      </div>
                    </div>

                    <div class="d-flex justify-content-between mt-1">
                      <div>
                        <!-- <p *ngIf="showPricekey==='Sale Price'" class="product-list-price1">₹{{product.pricing.raw.price}}<span style="font-size: 14px !important;color: grey!important;">-taxes extra</span><span *ngIf="priceStrikeOutInListScreen==='true' && strikeOutPriceKey==='MSRP'" style="font-size: 14px !important;margin-left:5px !important;text-decoration: line-through;color: grey!important;">₹{{product.pricing.raw.msrp}}</span><span  style="font-size: 14px !important;margin-left:5px !important;color: grey!important;">- ₹{{product.pricing.raw.price/product.unit}}/piece</span></p> -->
                        <p class="product-list-price2">
                          ₹{{ product.pricing.raw.price
                          }}
                          <!-- <span *ngIf="
                              priceStrikeOutInListScreen === 'true' &&
                              strikeOutPriceKey === 'MSRP'
                            " style="
                              font-size: 14px !important;
                              margin-left: 5px !important;
                              text-decoration: line-through;
                              color: grey !important;
                            ">₹{{ product.pricing.raw.msrp }}</span> -->
                            <!-- <span style="
                              font-size: 14px !important;
                              margin-left: 5px !important;
                              color: grey !important;
                            ">- ₹{{
                            product.pricing.raw.price / product.unit
                            | number : "1.2-2"
                            }}/piece</span> -->
                        </p>
                      </div>
                      <div class="inner-star-icon pd-1">
                        <span [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 1
                              ? 'fa fa-star checked'
                              : 'fa fa-star-o'
                          " class="rating1" style="
                            color: orange !important;
                          "></span>
                        <span [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 2
                              ? 'fa fa-star checked'
                              : 'fa fa-star-o'
                          " class="rating1" style="
                            color: orange !important;
                          "></span>
                        <span [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 3
                              ? 'fa fa-star checked'
                              : 'fa fa-star-o'
                          " class="rating1" style="
                            color: orange !important;
                          "></span>
                        <span [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 4
                              ? 'fa fa-star checked'
                              : 'fa fa-star-o'
                          " class="rating1" style="
                            color: orange !important;
                          "></span>
                        <span [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 5
                              ? 'fa fa-star checked'
                              : 'fa fa-star-o'
                          " class="rating1" style="
                            color: orange !important;
                          "></span>
                        <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                      </div>
                    </div>
                    <div class="d-flex justify-content-between" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                      <!-- <div> -->

                      <!-------------Add to cart-->

                      <!-- <button class="cartButton" (click)="addToCart(product)" *ngIf="
                          (product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                          (product.product_type == 'Variable' &&
                            appService.productIdinCart.indexOf(
                              product.checkVariantInCart
                            ) == -1) ||
                          (product.product_type == 'Simple' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                          (product.product_type == 'Variation' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1)
                        ">
                        ADD TO CART
                        <span> <i class="fa fa-shopping-cart"></i></span>
                      </button> -->

                           <button type="button" class="cartButton" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                        GO TO DETAILS
                        <span></span>
                      </button>

                      <!---------view cart button-->
                      <!-- <div *ngIf="
                          appService.productIdinCart.indexOf(product.id) !=
                            -1 ||
                          appService.productIdinCart.indexOf(
                            product.checkVariantInCart
                          ) != -1
                        "> -->
                        <!-- <div *ngFor="
                            let cart of appService.cartProducts.results;
                            let i = index
                          "> -->
                          <!-- <div [class]="
                              CONFIG.title == 'BestGifts'
                                ? 'viewCart'
                                : 'mayanviewCart'
                            " style="
                              font-size: small;
                              font-weight: bold;
                              width: 75%;
                              margin-left: 22%;
                              margin-top: 4px;
                              text-align: center;
                            " *ngIf="
                              cart.product_id === product.id 
                            "> -->
                            <!-- <div class="cartButton1"   *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart" >


                            <span  style="color: white;">
                              <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                         
                              <span class="inq-sp-2"
                                                       style="color: white;">{{cart.quantity}}</span>
                            <span  style="color: white;">
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"></i></span>
                          </div> -->
                        <!-- </div> -->
                      <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
        </div>
      </div>
      <pagination-controls *ngIf="totalLength > 0" class="my-pagination best-pagenation" (pageChange)="pageChange($event)"
        style="float: right" id="pagination-controls"></pagination-controls>
    </div>
  </div>


  <div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'AvonSeals'"
  style="padding-right: 0px !important; padding-left: 0px !important">
 
  <div>
    <div class="inq-menu-right-st">
      <h2 class="text-primary" id="productListHead">Products</h2>
      <div class="breadCrumbListing">
        <span class="home-breadcrumb" routerLink="">Home</span>
        <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
      </div>
      <div *ngIf="totalLength > 0" class="thumb1-avon">
        <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
          <div class="row inq-pro-sec-st listProduct">
           
            <div *ngIf="CONFIG.title === 'AvonSeals'" class="deera-container">
              <div class="product-list-cards-avonseals" style="color: lightgray">
                <div class="deera-img">
                  <!-- <span class="seller">Buy More Save More</span> -->

                  <!-- <div> -->
                  <!------------tams img------>
                  <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                    class="product-list-image-avonseals" />
                    <!-- <img src="assets/images/avonseals/C TYPE2.jpg" id="img-list" (click)="productDetails(product.id)"
                    class="product-list-image-avonseals" /> -->
                </div>
                <div class="product-list-description-deera">
                  <div>
                    <div class="d-flex justify-content-between" style="width: 50%; margin-left: 34%; margin-bottom: 25px;">
                      <!-- <div> -->
                      <div>
                        <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                        </p>
                      </div>
                      <!-- <div> -->
                      <!-- <p [class]="CONFIG.title=='Deera' ? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                      <!-- </div> -->
                    </div>
                  </div>

                  <!-- <div class="d-flex justify-content-between mt-1">
                    <div>
                    
                     
                
                    </div>
                    <div class="inner-star-icon review-mob pd-1">
                      <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                      <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                      <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                      <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                      <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    </div>
                  </div> -->
                  <div class="d-flex justify-content-between" style="margin-bottom: 10px;">

                    <!-------------Add to cart-->

                    <button class="avon-atc" style="border-radius: 25px!important;padding: 5px;"  
                    (click)="productDetails(product.id)" >
                      Buy Now
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div *ngIf="totalLength < 1">
        <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
      </div>
    </div>
    <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
      style="float: right" id="pagination-controls"></pagination-controls>
  </div>
</div>


<div class="col-md-12 desk" *ngIf="CONFIG.title === 'AvonSeals'"
style="padding-right: 0px !important; padding-left: 0px !important;">

<div>
  <div class="inq-menu-right-st">
    <h2 class="text-primary" id="productListHead">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div>
    <div *ngIf="totalLength > 0" class="thumb1-avon">
      <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <div class="row inq-pro-sec-st listProduct">
         
          <div *ngIf="CONFIG.title === 'AvonSeals'" class="deera-container">
            <div class="product-list-cards-avonseals" style="color: lightgray">
              <div class="deera-img">
                <!-- <span class="seller">Buy More Save More</span> -->

                <!-- <div> -->
                <!------------tams img------>
                <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-avonseals" />
                  <!-- <img src="assets/images/avonseals/C TYPE2.jpg" id="img-list" (click)="productDetails(product.id)"
                  class="product-list-image-avonseals" /> -->
              </div>
              <div class="product-list-description-deera">
                <div>
                  <div class="d-flex justify-content-between" style="width: 50%; margin-left: 37%; margin-bottom: 25px;">
                    <!-- <div> -->
                    <div>
                      <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                      </p>
                    </div>
                    <!-- <div> -->
                    <!-- <p [class]="CONFIG.title=='Deera' ? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                    <!-- </div> -->
                  </div>
                </div>

                <!-- <div class="d-flex justify-content-between mt-1">
                  <div>
                  
                   
              
                  </div>
                  <div class="inner-star-icon review-mob pd-1">
                    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                  </div>
                </div> -->
                <div class="d-flex justify-content-between" style="margin-bottom: 10px;">

                  <!-------------Add to cart-->

                  <button class="avon-atc" style="border-radius: 25px!important;padding: 5px;"  
                  (click)="productDetails(product.id)" >
                    Buy Now
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div *ngIf="totalLength < 1">
      <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
    </div>
  </div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
    style="float: right" id="pagination-controls"></pagination-controls>
</div>
</div>
<div class="col-md-9 div-only-mobile" *ngIf="CONFIG.title === 'Vistas'"
style="padding-right: 0px !important; padding-left: 0px !important">

<div>
  <div class="inq-menu-right-st">
    <h2 class="text-primary" id="productListHead">Products</h2>
    <div class="breadCrumbListing">
      <span class="home-breadcrumb" routerLink="">Home</span>
      <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
    </div>
    <div *ngIf="totalLength > 0" class="thumb1-avon">
      <div *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
        <div class="row inq-pro-sec-st listProduct">
         
          <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
            <div class="product-list-cards-avonseals" style="color: lightgray">
              <div class="deera-img">
                <!-- <span class="seller">Buy More Save More</span> -->

                <!-- <div> -->
                <!------------tams img------>
                <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-avonseals" />
                  <!-- <img src="assets/images/avonseals/C TYPE2.jpg" id="img-list" (click)="productDetails(product.id)"
                  class="product-list-image-avonseals" /> -->
              </div>
              <div class="product-list-description-deera">
                <div>
                  <div class="d-flex justify-content-between" style="width: 50%; margin-left: 26%; margin-bottom: 25px;">
                    <!-- <div> -->
                    <div>
                      <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                      </p>
                    </div>
                    <!-- <div> -->
                    <!-- <p [class]="CONFIG.title=='Deera' ? 'product-list-price' : 'mayan-product-list-price'">₹{{product.pricing.raw.price}}.00</p> -->
                    <!-- </div> -->
                  </div>
                </div>

                <!-- <div class="d-flex justify-content-between mt-1">
                  <div>
                  
                   
              
                  </div>
                  <div class="inner-star-icon review-mob pd-1">
                    <span [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                    <span [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                  </div>
                </div> -->
                <div class="d-flex justify-content-between" style="margin-bottom: 10px;">

                  <!-------------Add to cart-->

                  <button class="avon-atc" style="border-radius: 25px!important;padding: 5px;"  
                  (click)="productDetails(product.id)" >
                    Buy Now
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div *ngIf="totalLength < 1">
      <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
    </div>
  </div>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
    style="float: right" id="pagination-controls"></pagination-controls>
</div>
</div>

<div class="col-md-12 desk" *ngIf="CONFIG.title === 'Vistas'"
style="padding-right: 0px !important; padding-left: 0px !important;">

<div>
<div class="inq-menu-right-st">
  <h2 id="productListHead">Products</h2>
  <div class="breadCrumbListing">
    <span class="home-breadcrumb" routerLink="">Home</span>
    <span (click)="clearAll()"><i class="px-2">/</i> Products</span>
  </div>
  <div class="thumb1-avon">
    <!-- <div style="margin-right: 20px;" *ngFor="let product of filterItemsOfType() | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index"> -->
      <div style="margin-right: 20px;">
      <div class="row inq-pro-sec-st listProduct">
       
        <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
          <div class="product-list-cards-avonseals" style="color: lightgray">
            <div class="deera-img">
              <!------------tams img------>
              <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-avonseals" /> -->
                <img src="../../../../../assets/images/vistas/Aa1.png" id="img-list" (click)="productDetails(1)"
                class="product-list-image-avonseals" />
            </div>
            <div class="product-list-description-deera">
              <div>
                <div class="d-flex" style="margin-bottom: 25px;
                justify-content: center;
                text-align: center;">
                  <!-- <div> -->
                  <!-- <div>
                    <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                    </p>
                  </div> -->
                  <div>
                    <p  class="product-list-tile-vistas">Double A paper 70 GSM
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="margin-bottom: 10px;justify-content: center;">
                <button class="vistas-atc" style="border-radius: 25px!important;padding: 5px;"  
                (click)="productDetails(1)" >
                  Buy Now
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
    <div style="margin-right: 20px;">
      <div class="row inq-pro-sec-st listProduct">
       
        <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
          <div class="product-list-cards-avonseals" style="color: lightgray">
            <div class="deera-img">
              <!------------tams img------>
              <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-avonseals" /> -->
                <img src="../../../../../assets/images/vistas/paper one1.png" id="img-list" (click)="productDetails(1)"
                class="product-list-image-avonseals" />
            </div>
            <div class="product-list-description-deera">
              <div>
                <div class="d-flex" style="margin-bottom: 25px;
                justify-content: center;
                text-align: center;">
                  <!-- <div> -->
                  <!-- <div>
                    <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                    </p>
                  </div> -->
                  <div>
                    <p  class="product-list-tile-vistas">Paper one 70 GSM
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="margin-bottom: 10px;justify-content: center;">
                <button class="vistas-atc" style="border-radius: 25px!important;padding: 5px;"  
                (click)="productDetails(1)" >
                  Buy Now
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
    <div style="margin-right: 20px;">
      <div class="row inq-pro-sec-st listProduct">
       
        <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
          <div class="product-list-cards-avonseals" style="color: lightgray">
            <div class="deera-img">
              <!------------tams img------>
              <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-avonseals" /> -->
                <img src="../../../../../assets/images/vistas/Aa2.png" id="img-list" (click)="productDetails(2)"
                class="product-list-image-avonseals" />
            </div>
            <div class="product-list-description-deera">
              <div>
                <div class="d-flex" style="margin-bottom: 25px;
                justify-content: center;
                text-align: center;">
                  <!-- <div> -->
                  <!-- <div>
                    <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                    </p>
                  </div> -->
                  <div>
                    <p (click)="productDetails(2)" class="product-list-tile-vistas">Aa2
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="margin-bottom: 10px;justify-content: center;">
                <button class="vistas-atc" style="border-radius: 25px!important;padding: 5px;"  
                (click)="productDetails(2)" >
                  Buy Now
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
    <div style="margin-right: 20px;">
      <div class="row inq-pro-sec-st listProduct">
       
        <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
          <div class="product-list-cards-avonseals" style="color: lightgray">
            <div class="deera-img">
              <!------------tams img------>
              <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-avonseals" /> -->
                <img src="../../../../../assets/images/vistas/IK Copy 70 GSM.png" id="img-list" (click)="productDetails(3)"
                class="product-list-image-avonseals" />
            </div>
            <div class="product-list-description-deera">
              <div>
                <div class="d-flex" style="margin-bottom: 25px;
                justify-content: center;
                text-align: center;">
                  <!-- <div> -->
                  <!-- <div>
                    <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                    </p>
                  </div> -->
                  <div>
                    <p (click)="productDetails(3)" class="product-list-tile-vistas">IK Copy 70 GSM
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
                <button class="vistas-atc" style="border-radius: 25px!important;padding: 5px;"  
                (click)="productDetails(3)" >
                  Buy Now
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
    <div style="margin-right: 20px;">
      <div class="row inq-pro-sec-st listProduct">
       
        <div *ngIf="CONFIG.title === 'Vistas'" class="deera-container">
          <div class="product-list-cards-avonseals" style="color: lightgray">
            <div class="deera-img">
              <!------------tams img------>
              <!-- <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-avonseals" /> -->
                <img src="../../../../../assets/images/vistas/IK copy for 80 GSM.png" id="img-list" (click)="productDetails(4)"
                class="product-list-image-avonseals" />
            </div>
            <div class="product-list-description-deera">
              <div>
                <div class="d-flex" style="margin-bottom: 25px;
                justify-content: center;
                text-align: center;">
                  <!-- <div> -->
                  <!-- <div>
                    <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                    </p>
                  </div> -->
                  <div>
                    <p (click)="productDetails(4)" class="product-list-tile-vistas">IK Copy 80 GSM
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex" style="margin-bottom: 10px;justify-content: center;">
                <button class="vistas-atc" style="border-radius: 25px!important;padding: 5px;"  
                (click)="productDetails(4)" >
                  Buy Now
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
  </div>
  <div *ngIf="totalLength < 1">
    <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
  </div>
</div>
<pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
  style="float: right" id="pagination-controls"></pagination-controls>
</div>
</div>

    <div class="col-md-9" *ngIf="CONFIG.title === 'BombayHardware'"
      style="padding-right: 0px !important; padding-left: 0px !important">
      <div style="font-family: 'proxima-regular', 'sans-serif' !important">
        <h2 class="text-primary" style="color: #000 !important; margin-left:10px;" id="productListHead">
          Products
        </h2>
        <div class="breadCrumbListing" style="margin-left:10px;">
          <span class="home-breadcrumb" routerLink="">Home</span>
          <span  (click)="clearAll()"><i class="px-2">/</i> Products</span>
          <span *ngIf="this.allInOneData.length>0"><i  class="px-2">/</i> {{  allInOneData[1][0] | titlecase }} </span>
        </div>
        <div *ngIf="totalLength > 0">
          <div class="row">
            <div class="col-sm-12">
              <div class="collection-product-wrapper bombayhardware-container-temp" id="products">
                <div class="col-grid-box" *ngFor="
                    let product of filterItemsOfType() | paginate
                        : {
                            id: 'pagination-controls',
                            itemsPerPage: countPerPage,
                            currentPage: currentPageInPagination,
                            totalItems: totalLength
                          };let i = index">
                  
                  <div>
                    <div class="shubhcards-card bombayhardware-card-temp">
                      <div class="shubhcards-image bh-image-temp" (click)="productSubDetails(product.id,product.subname,product.size,product.categories[0].categories,product.name+'-'+product.id)">
                    
                        <h6 class="brand" id="img-list" class="brand-bh product-image"> {{product.brand.name ? product.brand.name : "-" }}</h6>

                        <!-- <a class="mobile-only" *ngIf="(product.size.length==0)" style="color: red !important; position: relative;font-size: small;left: 90%;top: 30%;">Select&nbsp;size</a>
                        <a class="mobile-only" *ngIf="product.size[1]==''" style="color: red !important; position: relative;font-size: small;left: 90%;top: 30%;">Select&nbsp;{{product.dropdown_consider[0]}}</a> -->
                        
                        <div *ngIf=" product.assets.length == 0 || !product.assets[0].image_source" class="shubhcards-image-container bh-temp-image-container">
                          <img src="assets/images/product-noimage.jpeg" id="img-list" class="product-image bh-temp-mob" style="width:120%;margin-top:-8%;border-bottom: 1px solid #ddd; height: 180px;" />
                        </div>
                        <div *ngIf="product.assets != undefined && product.assets.length != 0 && product.assets[0].image_source" class="shubhcards-image-container bh-temp-image-container">
                          <img [src]="product.assets[0].image_source" id="img-list" class="product-image bh-temp-mob" style="width:120%;margin-top:-8%;border-bottom: 1px solid #ddd; height: 180px;" alt="{{ product.name }}" />
                        </div>
                        
                      </div>
                      <div *ngIf="product.dropdown_consider.length==1" class="shubhcards-description text-center bh-temp-desc" style="display: table-caption;" >
                        <div class="product-description-bh shubhcards-product-title" id="img-list" container="body">
                          <div class="mob-title" style="width:109%;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                            <a class="bh-temp-float-left ttl">
                              <a class="bh-title" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                              id="{{ product.id }}" ngbPopover="{{product.subname}}" container="body" *ngIf="fields[1].visibility">{{ product.subname | titlecase }}</a>
                              <!-- <span class="tooltip-bh">{{product.subname}}</span> -->
                            </a>
                          </div>
                        </div>
                        <div class="bh-cart-btn">

                          <div *ngIf="product.childs.type !=0">
                            <div class="dropdown dropdownstyle1">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                type
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.type" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                                  {{ product.size[0]}}{{product.dropdown_consider[0]}}
                                </div>
                                
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.size" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_pipe !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ product.size[0]}}{{product.dropdown_consider[0]}}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.size_pipe;let i = index"  class="dropdown-item">
                                  <div *ngIf="product.dropdown_consider == 'inch'" (click)="selectOption1(size.inch,product.id)">
                                    {{ size.inch }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider == 'mm'" (click)="selectOption1(size.mm,product.id)">
                                    {{ size.mm }}
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_ml !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ product.size[0]}}{{product.dropdown_consider[0]}}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.size_ml" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_pn !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ product.size[0]}}{{product.dropdown_consider[0]}}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.size_pn;let i = index" class="dropdown-item">
                                  <div *ngIf="product.dropdown_consider == 'pn'" (click)="selectOption1(size.pn,product.id)">
                                    {{ size.pn }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider == 'mm'" (click)="selectOption1(size.mm ,product.id)">
                                    {{ size.mm }}
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.diameter !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle1" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ product.size[0]}}{{product.dropdown_consider[0]}}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="min-width: 80%;max-width: fit-content;">
                                <a *ngFor="let size of product.childs.diameter" (click)="selectOption1(size.value,product.id)" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div style="height:50px; margin-top:7%">
                            <span class="fa fa-shopping-cart small-cart-bh">
                              <div *ngFor="let pro of this.appService.cartProducts.results;let i=index" class="summary-bh">
                                <div *ngIf="pro.product_id==product.id" class="isempty">
                                  <div *ngFor="let c of pro.subcart;let j=index">
                                    <a>{{pro.subcart[j]}} x{{pro.subquantity[j]}}</a>
                                  </div>
                                </div>
                                  <!-- <a>{{subcart}} x{{product.subquantity[i]}}</a> -->
                              </div>
                              <div *ngIf="!this.appService.subProductinCart.includes(product.subname)"  class="summary-bh">
                                <a>Select Size</a>
                              </div>
                            </span>
                          </div>
                          <!-- <div>
                            <button class="bh-temp-cart btn btn-primary shubhcards-btn">Add to cart</button>
                          </div> -->
                          <div class="bombayhardware-submit-btn">
                            <button class="bh-temp-cart btn btn-primary shubhcards-btn" *ngIf="!this.appService.subProductinCart.includes(product.subname)" [disabled]="product.name==product.subname" (click)="addSubProduct(product)" >
                              Add to Cart
                            </button>                           
                              
                              <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
                                <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
                                <div *ngFor="let c of cart.subcart;let j= index">
                                  <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
                                    <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
                                    <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
                                    <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="select-size-listing1" *ngIf="(product.size.length==0)">Select&nbsp;{{product.dropdown_consider[0]}}</a>
                        </div>
                      </div>
                      <div *ngIf="product.dropdown_consider.length==2" class="shubhcards-description text-center bh-temp-desc" style="display: table-caption;" >
                        <div class="product-description-bh shubhcards-product-title" id="img-list" container="body">
                          <div class="mob-title" style="width:109%;white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                            <a class="bh-temp-float-left ttl">
                              <a class="bh-title" (mouseenter)="mouseEnter(product.id)" (mouseleave)="mouseLeave(product.id)"
                              id="{{ product.id }}" ngbPopover="{{product.subname}}" container="body" *ngIf="fields[1].visibility">{{ product.subname | titlecase }}</a>
                            </a>
                          </div>                          <!-- <p style="color: #373b3f">MOQ : {{product.pricing.raw.minimumorderquantity}}</p> -->
                        </div>
                        <div class="bh-cart-btn">
                          <!-- <button     class="btn btn-secondary listing"   *ngIf="(appService.productIdinCart.indexOf(product.id) != -1 && product.product_type!='Variable' && appService.productIdinCart.indexOf(product.id) > -1)"  routerLink="/cart">View Cart</button> -->
                          <div *ngIf="product.childs.type !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle-default" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                                  {{product.size[0]}}{{product.dropdown_consider[1]}}
                                </div>
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.type" (click)="selectFirstSCH(size.sch_value,product.id)" class="dropdown-item">{{size.sch_value}}</a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px;">
                                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;">
                                  {{product.size[1]}}{{product.dropdown_consider[0]}}
                                </div>
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.type">
                                  <div *ngIf="size.sch_value == product.size[2]">
                                    <div *ngFor="let v of size.values"  class="dropdown-item">
                                      <div *ngIf="product.dropdown_consider[0] == 'inch'" (click)="selectSecondSCH(v.inch,product.id)">
                                        {{ v.inch }}
                                      </div>
                                      <div *ngIf="product.dropdown_consider[0] == 'mm'" (click)="selectSecondSCH(v.mm,product.id)">
                                        {{ v.mm }}
                                      </div>
                                      <div *ngIf="product.dropdown_consider[0] == 'Thickness/Class' || product.dropdown_consider[0] == 'Thickness'" (click)="selectSecondSCH(v.Thickness,product.id)">
                                        {{ v.Thickness }}
                                      </div>
                                      <div *ngIf="product.dropdown_consider[0] == 'class'" (click)="selectSecondSCH(v.class,product.id)">
                                        {{ v.class }}
                                      </div>
                                      <div *ngIf="product.dropdown_consider[0] == 'SCH'" (click)="selectSecondSCH(v.sch,product.id)">
                                        {{ v.sch }}
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                <div *ngIf="product.size.length!=3">
                                  <div class="dropdown-item">
                                    <div>
                                      Select {{product.dropdown_consider[1]}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div *ngIf="product.childs.size !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                size
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                sch
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_pipe !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                size_pipe
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                sch
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_ml !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                size_ml
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                sch
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.size_pn !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                {{ product.size[0]}}{{ product.dropdown_consider[0] }}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size_pn" class="dropdown-item">
                                  <div *ngIf="product.dropdown_consider[0] == 'inch'" (click)="selectFirst(size.inch,product.id)">
                                    {{ size.inch }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider[0] == 'mm'" (click)="selectFirst(size.mm,product.id)">
                                    {{ size.mm }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider[0] == 'pn'" (click)="selectFirst(size.pn,product.id)">
                                    {{ size.pn }}
                                  </div>
                                </a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh dropdownstyle2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                {{ product.size[1]}}{{ product.dropdown_consider[1] }}
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size_pn" class="dropdown-item">
                                  <div *ngIf="product.dropdown_consider[1] == 'inch'" (click)="selectSecond(size.inch,product.id)">
                                    {{ size.inch }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider[1] == 'mm'" (click)="selectSecond(size.mm,product.id)">
                                    {{ size.mm }}
                                  </div>
                                  <div *ngIf="product.dropdown_consider[1] == 'pn'" (click)="selectSecond(size.pn,product.id)">
                                    {{ size.pn }}
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>

                          <div *ngIf="product.childs.diameter !=0">
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                               dia
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                            <div class="dropdown">
                              <button class="btn btn-secondary dropdown-toggle size-btn-bh" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width:100px">
                                sch
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a *ngFor="let size of product.childs.size" class="dropdown-item">{{size.value}}</a>
                              </div>
                            </div>
                          </div>

                          <div style="height:50px; margin-top:7%">
                            <span class="fa fa-shopping-cart small-cart-bh-2">
                              <div *ngFor="let pro of this.appService.cartProducts.results;let i=index" class="summary-bh">
                                <div *ngIf="pro.product_id==product.id" class="isempty">
                                  <div *ngFor="let c of pro.subcart;let j=index">
                                    <a>{{pro.subcart[j]}} x{{pro.subquantity[j]}}</a>
                                  </div>
                                </div>
                                  <!-- <a>{{subcart}} x{{product.subquantity[i]}}</a> -->
                              </div>
                              <div *ngIf="!this.appService.subProductinCart.includes(product.subname)"  class="summary-bh">
                                <a>Select Size</a>
                              </div>
                            </span>
                          </div>
                          <!-- <div>
                            <button class="bh-temp-cart btn btn-primary shubhcards-btn">Add to cart</button>
                          </div> -->
                          <div class="bombayhardware-submit-btn">
                            <button class="bh-temp-cart btn btn-primary shubhcards-btn" *ngIf="!this.appService.subProductinCart.includes(product.subname)" [disabled]="product.size[1]=='' || product.name==product.subname" (click)="addSubProduct(product)" >
                              Add to Cart
                            </button>                           
                              
                              <div *ngFor="let cart of appService.cartProducts.results; let i = index;">
                                <div *ngIf="this.appService.cartProducts.results[i].subcart.includes(product.subname)">
                                <div *ngFor="let c of cart.subcart;let j= index">
                                  <div class="btn btn-primary inq-btn-st bombayViewCart" *ngIf="this.appService.cartProducts.results[i].subcart[j]==product.subname">
                                    <span><i class="fa fa-minus mr-3" (click)="decreaseSubItem(i,j,product.id)" style="font-size: 12px; cursor: pointer"></i></span>
                                    <input type="number" class="inq-sp-2 bombay-input" (input)="minQuantity0(i,j,product.id,$event)"  [(ngModel)]="cart.subquantity[j]">
                                    <span><i class="fa fa-plus ml-3" (click)="increaseSubItem(i,j,product.id)"style="font-size: 12px; cursor: pointer"></i></span> 
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <a class="select-size-listing2" *ngIf="(product.size.length==0)">Select&nbsp;{{product.dropdown_consider[1]}}</a>
                          <a class="select-size-listing2-1" *ngIf="product.size[1]=='' && product.dropdown_consider[0]!='Thickness/Class'">Select&nbsp;{{product.dropdown_consider[0]}}</a>
                          <a class="select-size-listing2-1-long" *ngIf="product.size[1]==''&& product.dropdown_consider[0]=='Thickness/Class'">Select&nbsp;{{product.dropdown_consider[0]}}</a>
                        </div>
                      </div>
                    </div>
                  </div>                
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="totalLength < 1">
          <img src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg" class="img-fluid1" />
          <button (click)="clearAll()" class="btn btn-block" style="font-family: 'proxima-regular','sans-serif' !important; font-weight: 600; border: none !important;" ><span class="fa fa-angle-left"></span> Back</button>
        </div>
        <pagination-controls *ngIf="totalLength > 0 && CONFIG.title === 'BombayHardware'" class="my-pagination"
          (pageChange)="pageChange($event)" style="float: right" id="pagination-controls"></pagination-controls>
      </div>
    </div>
  </section>
</div>
<button id="launch-model" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel">
  Launch demo modal
</button>
<div class="modal fade" id="statusModel" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div *ngIf="CONFIG.title === 'Beaubelle'" class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form</div>
          </div>
          <form [formGroup]="enquiryForm" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f.name.errors">
                  <div *ngIf="f.name.errors.required">Name is required.</div>
                  <div *ngIf="f.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div *ngIf="f.email.errors.required">Email is required.</div>
                  <div *ngIf="f.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f.email.errors.email || f.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f.phone_number.errors">
                  <div *ngIf="f.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f.phone_number.errors.maxlength">
                    Mobile Number can't be more than 15 characters long.
                  </div>
                  <div *ngIf="f.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
           
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f.message.errors">
                  <div *ngIf="f.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<button id="launch-model-accel" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-accel">
  Launch demo modal
</button>
<div class="modal fade" id="statusModel-accel" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div *ngIf="CONFIG.title === 'Accel'" class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form</div>
          </div>
          <form [formGroup]="enquiryForm" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="(f.name.invalid && validateForm)"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f.name.errors">
                  <div *ngIf="f.name.errors.required">Name is required.</div>
                  <div *ngIf="f.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div *ngIf="f.email.errors.required">Email is required.</div>
                  <div *ngIf="f.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f.email.errors.email || f.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="phone_number"
                  [class.is-invalid]="f.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f.phone_number.errors">
                  <div *ngIf="f.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f.phone_number.errors.maxlength">
                    Mobile Number can't be more than 15 characters long.
                  </div>
                  <div *ngIf="f.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f.category.invalid && validateForm" formControlName="category" required readonly>
                <div class="invalid-feedback" *ngIf="f.category.errors">
                  <div *ngIf="f.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">12th Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">UG Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Higher Education Certificate</label>
              </div>
              <div class="col-md-7">
                <input type="file" id="myFile" name="filename">
                
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f.message.errors">
                  <div *ngIf="f.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- end -->
<button id="launch-model-vimpro" style="display: none" type="button" class="btn btn-primary" data-toggle="modal"
  data-target="#statusModel-vimpro">
  Launch demo modal
</button>
<div class="modal fade" id="statusModel-vimpro" tabindex="-1" role="dialog" aria-labelledby="statusModelTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document" style="
      max-width: 640px !important;
      position: relative !important;
      bottom: -30px !important;
      -webkit-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -moz-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      -o-transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
      transition: opacity 0.3s ease-out, bottom 0.3s ease-out !important;
    ">
    <div *ngIf="CONFIG.title === 'Vimpro'" class="modal-content status-model-container">
      <div class="modal-body" style="border: none !important">
        <div class="model-content m-content">
          <button #closeModal type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 1.6rem !important" aria-hidden="true">&times;</span>
          </button>
          <div class="title-container">
            <div class="m-title">Enquiry Form - {{vimpro_pro_name}}</div>
            
          </div>
          <form [formGroup]="enquiryForm_vimpro" class="gift-form" novalidate>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="name" class="form-label">Name <span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="name" [class.is-invalid]="f_vimpro.name.invalid && validateForm"
                  formControlName="name" required />
                <div class="invalid-feedback" *ngIf="f_vimpro.name.errors">
                  <div *ngIf="f_vimpro.name.errors.required">Name is required.</div>
                  <div *ngIf="f_vimpro.name.errors.maxlength">
                    Name can't be more than 80 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="content" class="form-label">Email<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="email" class="form-control" id="email" [class.is-invalid]="f_vimpro.email.invalid && validateForm"
                  formControlName="email" maxlength="50" email />
                <div class="invalid-feedback" *ngIf="f_vimpro.email.errors">
                  <div *ngIf="f_vimpro.email.errors.required">Email is required.</div>
                  <div *ngIf="f_vimpro.email.errors.maxlength">
                    Seneder Email can't be more than 50 characters long.
                  </div>
                  <div *ngIf="f_vimpro.email.errors.email || f_vimpro.email.errors.pattern">
                    Email must be a valid email address
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="phone_number" class="form-label">Mobile<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="phone_number"
                  [class.is-invalid]="f_vimpro.phone_number.invalid && validateForm" formControlName="phone_number" required />
                <div class="invalid-feedback" *ngIf="f_vimpro.phone_number.errors">
                  <div *ngIf="f_vimpro.phone_number.errors.required">
                    Mobile Number is required.
                  </div>
                  <div *ngIf="f_vimpro.phone_number.errors.maxlength">
                    Mobile Number can't be more than 15 characters long.
                  </div>
                  <div *ngIf="f_vimpro.phone_number.errors.pattern">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Category<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="category"
                  [class.is-invalid]="f_vimpro.category.invalid && validateForm" formControlName="category" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_vimpro.category.errors">
                  <div *ngIf="f_vimpro.category.errors.required">
                    Category is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="product_name" class="form-label">Product Name<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <input type="text" class="form-control" id="product_name"
                  [class.is-invalid]="f_vimpro.product_name.invalid && validateForm" formControlName="product_name" required
                  readonly />
                <div class="invalid-feedback" *ngIf="f_vimpro.product_name.errors">
                  <div *ngIf="f_vimpro.product_name.errors.required">
                    Product Name is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="length" class="form-label">Length(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="length"
                   formControlName="length" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.length.errors">
                  <div *ngIf="f_vimpro.length.errors.required">
                    Length is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="thickness" class="form-label">Thickness(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="thickness"
                   formControlName="thickness" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.thickness.errors">
                  <div *ngIf="f_vimpro.thickness.errors.required">
                    Thickness is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="height" class="form-label">Height(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="height"
                   formControlName="height" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.height.errors">
                  <div *ngIf="f_vimpro.height.errors.required">
                    Height is required.
                  </div>
                </div> -->
              </div>
            </div>


            <div class="form-group row">
              <div class="col-md-4">
                <label for="Width" class="form-label">Width(mm)</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="width"
                   formControlName="width" 
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.height.errors">
                  <div *ngIf="f_vimpro.height.errors.required">
                    Height is required.
                  </div>
                </div> -->
              </div>
            </div>





            <div class="form-group row">
              <div class="col-md-4">
                <label for="quantity" class="form-label">Quantity</label>
              </div>
              <div class="col-md-7">
                <input type="number" class="form-control" id="quantity"
                   formControlName="quantity"
                   />
                <!-- <div class="invalid-feedback" *ngIf="f_vimpro.quantity.errors">
                  <div *ngIf="f_vimpro.quantity.errors.required">
                    Quantity is required.
                  </div>
                </div> -->
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="material" class="form-label">Material</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="material">
                  <option *ngFor="let c of material_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="color" class="form-label">Color</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="color">
                  <option *ngFor="let c of color_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="color" class="form-label">Usage</label>
              </div>
              <div class="col-md-7">
                <select  formControlName="usage">
                  <option *ngFor="let c of usage_vimpro">{{ c }}</option>
              </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-4">
                <label for="category" class="form-label">Message<span class="required">*</span></label>
              </div>
              <div class="col-md-7">
                <textarea class="form-control" id="message" [class.is-invalid]="f_vimpro.message.invalid && validateForm"
                  formControlName="message" required rows="5"></textarea>
                <div class="invalid-feedback" *ngIf="f_vimpro.message.errors">
                  <div *ngIf="f_vimpro.message.errors.required">
                    Message is required.
                  </div>
                  <div *ngIf="f_vimpro.message.errors.maxlength">
                    Message can't be more than 600 characters long.
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-bottom: 45px">
              <button class="btn btn-primary" style="
                  border-radius: 5px !important;
                  font-size: 1rem;
                  padding: 5px 25px;
                  margin-top: 5px;
                  float: right;
                " (click)="saveForm_vimpro()">
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>


 <section *ngIf="CONFIG.title ==='LinenRaj'">
  <style>
    .linencard {
  height: auto;
  /*min-width: 90%;*/
  /* background-color: white; */
  margin: 0px auto 0px;
  /* background-image: url('https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/LinenRaj/Product/MicrosoftTeams-image+(7).png')!important; */
  background-size: contain;
  object-fit: cover;
  max-width: 600px;
  box-sizing: border-box;
  border-radius: 10px;
  
 
 
}
.linencard1 {
  height: auto;
  /*min-width: 90%;*/
  background-color: white;
  margin: 0px auto 0px;
  background-size: contain;
  object-fit: cover;
  max-width: 600px;
  box-sizing: border-box;
  border-radius: 10px;
} 
.linencard1 img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-sizing: border-box;
}
.linencard img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-sizing: border-box;
}
.linencard:hover{
  width: 100%!important;
  animation: ani-fadeIn 1.25s cubic-bezier(.26,.54,.32,1) forwards;
  transform: scale(1.2);
  transition: opacity .3s,transform 8s cubic-bezier(.25,.30,.45,.94);
  height: 90%!important;
  max-height: 500px!important;
  border-radius: 10px;
  box-sizing: border-box;
 

}

.linencard img:hover {
  opacity: 0;
  box-sizing: border-box;
  
 
}
  </style>
     
  <div class="row linenraj_roweee">
    <div class="col-1">  
    </div>
    <div class="col-10">  
      <div class="bbcrumb" style="margin-left: 5%;">
        <span routerLink="" style="
        font-size: 10px!important">Home</span>
        <span><i class="px-2">/</i> <a class="bbcrumb"   style="cursor:pointer;" (click)="clearAll()"> Products</a> <span><i *ngIf="this.allInOneData[1]" class="px-2">/</i> {{this.allInOneData[1]}} </span></span>
        <span> </span>
      </div>
      <h2 class="bb_ln" id="productListHead" style="margin-left: 5%;margin-bottom: 25px!important;">
        All Shirts
    </h2>
  
    <div>
      <div class="linen-toolbar__section">
        <!-- <div class="ln-toolbar__col--left">
          <div class="ln-icon-wrapper">
            <div class="ln-filters-icon--sidebar">
              <a data-toggle="modal" data-target="#exampleModal">
                <img src="../../../../../assets/images/linenraj/filter.png" style="height: 17px;">
                <span style="font-size: x-small;;margin-left: 4px;font-family: 'Lato', sans-serif;letter-spacing: 2px !important;">FILTERS</span>
              </a> -->
              <!-- <span style="font-size: xx-small;margin-left: 25px;letter-spacing: 2px !important;" >
                <SELECT name="ddl" style="border: none;font-weight: unset;font-family: 'Lato', sans-serif; letter-spacing: 2px !important;">
                  <option value='blue'>Blue</option>
                  <option value='green'>Green</option>
                  <option value='red'>Red</option>
                  <option value='yellow'>Yelllow</option>
                  <option value='' selected>CATEGORY</option>
                  <option value='white'>White</option>
                  </SELECT>
                
                </span> -->
                <!-- <span style="font-size: x-small;margin-left: 25px;" >
                  <SELECT name="ddl" style="border: none;font-weight: unset;font-family: 'Lato', sans-serif; letter-spacing: 2px !important;">
                    <option value='blue'>S</option>
                    <option value='green'>M</option>
                    <option value='red'>L</option>
                    <option value='yellow'>XL</option>
                    <option value='white'>XXL</option>
                    <option value='' selected>BY SIZE</option>
                  
                    </SELECT>
                  
                  </span>
             
            </div>
          </div>

        </div> -->
        <!-- <div  class="ln-toolbar__col--right"  >
          <span style="font-size: x-small;letter-spacing: 2px !important;font-family: 'Lato', sans-serif;">1 PRODUCT</span>
          <span style="font-size: x-small;margin-left: 25px;letter-spacing: 2px !important;" >
            <select   name="languages"style="border-top: none;border-right: none;border-left: none;padding-bottom: 5px;font-weight: unset;font-family: 'Lato', sans-serif; letter-spacing: 2px !important;">
              <option style="margin-bottom: 5px;" class="ft_option"   value='HIGH TO LOW'>HIGH TO LOW</option>
              <option   class="ft_option"  value='LOW TO HIGH'>LOW TO HIGH</option>
              <option    class="ft_option" value='' selected>SORT BY : LATEST ARRIVALS</option>
              </select>
            
            </span>
        </div> -->

        <!-- <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">FILTERS</h5>
           
          </div>
          <div class="offcanvas-body">
          
              
              <a  data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
              <i class="fa fa-angle-down arrow-size"></i>&nbsp;&nbsp;BY PRICE
              </a>
          
            <div class="collapse" id="collapseExample">
              <div class="card card-body">
                <input role="spinbutton" type="number" aria-valuemin="1790" aria-valuemax="7990" aria-valuenow="1790" class="fs-input-number-input" autocomplete="off" max="7990" min="1790" step="100" data-testid="filter-range-min" style="width: 40%;">
                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
              </div>
            </div>
            <div class="dropdown mt-3">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown">
                Dropdown button
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li><a class="dropdown-item" href="#">Action</a></li>
                <li><a class="dropdown-item" href="#">Another action</a></li>
                <li><a class="dropdown-item" href="#">Something else here</a></li>
              </ul>
            </div>
          </div>
        </div> -->
        








      </div>



      <div class="container" style="margin-top: 30px;">
        <div class="row">
            <div class="col-md-4" *ngFor="
            let product of filterItemsOfType() | paginate
                : {
                    id: 'pagination-controls',
                    itemsPerPage: countPerPage,
                    currentPage: currentPageInPagination,
                    totalItems: totalLength
                  };let i = index">
                <div class="content" *ngIf="product.product_type=='Variable'"> 
                  <div style="overflow: hidden;">
                     <div class="linencard" style="background-image: url('{{product.assets[1].image_source}}')!important;" (click)="productDetails(product.id)">
                      <img [src]="product.assets[0].image_source" id="img-list"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="product-list-image-vistas" />
                    </div>
                  </div>
                        
                        <div class="linen_container">
                          <div class="grid_info">
                            <p (click)="productDetails(product.id)" class="product-list-tile-vistas">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                            </p>
                            <!-- <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price3">₹{{product.pricing.raw.price_range_from}}-{{product.pricing.raw.price_range_to}}</p> -->
                          </div>
                          <button type="button" style="white-space: nowrap;" class="linen_btn primary" (click)="addToCartForLinenRaj(product)">ADD TO BAG</button>
                           
                          
                        </div>
                    </div>
                    <div class="content" *ngIf="product.product_type=='Simple'"> 
                      <div style="overflow: hidden;"> 
                        <div class="linencard1">
                          <img [src]="product.assets[0].image_source" id="img-list"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}" class="product-list-image-vistas"
                             />
                        </div>
                      </div>
                            
                            <div class="linen_container">
                              <div class="grid_info">
                                <p class="product-list-tile-vistas">{{metaDataMapService.findData(product,fields[1].nestedinfo)}}
                                </p>
                                <!-- <p *ngIf="showPricekey === 'Sale Price'" class="product-list-price3">₹{{product.pricing.raw.price_range_from}}-{{product.pricing.raw.price_range_to}}</p> -->
                              </div>
                              
                               
                              
                            </div>
                        </div>
                    
            </div>
         
          
            
        </div>
    </div>


    </div>


    </div>
    <div class="col-1">  
    </div>
  
  </div>
  






</section>







<!-- Modal -->
<div class="modal fade" *ngIf="CONFIG.title === 'LinenRaj'" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog filter">
    <div class="modal-content filter-content">
      <div class="modal-header">
        <h5 class="modal-title ft_modal" id="exampleModalLabel">FILTERS</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <div>
          <a  class="ft_modal" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
            <i class="fa fa-angle-down arrow-size"></i>&nbsp;&nbsp;BY PRICE
            </a>
        
          <div class="collapse" id="collapseExample">
            <div class="card card-body">
              <div class="ln-filter-range__amount">
                <input role="spinbutton" type="number" now="1790" class="fs-input-number-input" autocomplete="off" max="7990" min="1790" step="100" data-testid="filter-range-min" style="width: 40%;">
                <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                <input role="spinbutton" type="number"now="1790" class="fs-input-number-input" autocomplete="off" max="7990" min="1790" step="100" data-testid="filter-range-min" style="width: 40%;">
                
  
  
              </div>
              <div class="range" style="margin-top: 10%;">
                <div class="range-slider">
                  <span class="range-selected"></span>
                </div>
                <div class="range-input">
                  <input type="range" class="min" min="0" max="1000" value="300" step="10">
                  <input type="range" class="max" min="0" max="1000" value="700" step="10">
                </div>
                <!-- <div class="range-price">      
                  <label for="min">Min</label>
                  <input type="number" name="min" value="300">      
                  <label for="max">Max</label>
                  <input type="number" name="max" value="700">      
                </div> -->
              </div> 
              
            
            </div>
          </div>

        </div>
        <div>

          <a  class="ft_modal" data-toggle="collapse" data-target="#collapseSize" aria-expanded="false" aria-controls="collapseSize">
            <i class="fa fa-angle-down arrow-size "></i>&nbsp;&nbsp;BY SIZE
            </a>
            
          <div class="collapse" id="collapseSize">
            <div class="card card-body">
              <div >
                <div>
                  <input type="checkbox" id="S" name="S" value="S">
                <label for="S" class="ft_modal">&nbsp;S</label><br>
                </div>
                <div>
                  <input type="checkbox" id="M" name="M" value="M">
                <label for="M"  class="ft_modal">&nbsp;M</label><br>
                </div>
                <div>
                  <input type="checkbox" id="L" name="L" value="L">
                  <label for="L"  class="ft_modal">&nbsp;L</label><br>
                </div>
                <div>
                  <input type="checkbox" id="XL" name="XL" value="XL">
                <label for="XL"  class="ft_modal">&nbsp;XL</label><br>
                </div>
                <div>
                  <input type="checkbox" id="XXL" name="XXL" value="XXL">
                  <label for="XXL"  class="ft_modal">&nbsp;XXL</label><br>
                </div>
                
                
               
                
               
  
  
              </div>
            
              
            
            </div>
          </div>
  
        </div>
       
      
        
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>




<button type="button" *ngIf="CONFIG.title === 'LinenRaj'" id="linenrajcart4" class="btn btn-primary" data-toggle="modal" data-target="#addToCart_ln4" style="display: none;" >
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade addtocart"*ngIf="CONFIG.title === 'LinenRaj'"id="addToCart_ln4" tabindex="-1" role="dialog" aria-labelledby="addToCart_ln4" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered add_cart" role="document" id="cart_ln">
    <div class="title_message linen-pop111">
      <div class="modal-content add_cart" style="min-width: 120%;">
        <div class="modal-header">
          <h5 class="modal-title" id="addToCart_ln">Select Size</h5>
          <button  id="closemodal1"  type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          
        </div>
        <div class="modal-body" style="margin-left: 5%;">
          <div style="display: flex;">
            <div><img style="height: 100px" [src]="product1"></div>
            
            <div>
              <span>
                <p style="font-size: 13px;margin-left: 3%;width: 100%;">{{LinenName}} </p>
              </span>
              <span>
                <p style="font-size: 13px;margin-left: 3%;">₹ {{LinenPrice}}</p>
  
              </span>
              <!-- <span>
                <a   class="view_detail_ln" (click)="viewDetail()">View Details</a>
              </span> -->
              
             
  
            </div>
          </div>
          <div style="display:flex;margin-top: 10px; ">
            <div *ngFor="let option of linenRajOption.variant.option_values;let i = index" style=" width: 20%;">
              <!-- <div class="swatch-button-title-text" swatch-inside="true"><span [class.active]="option.is_default" class="colour-image" swatch-inside="true" (click)="selectOptionCarience(option.option,product3,i)" style="cursor: pointer; width: 40px; display: flex;justify-content: center;margin-right: 10px;height: 30px;border-radius: 7px;"><p style="text-align: center; font-size: 10px;margin-top: 7px;">{{option.option}}</p></span></div> -->
              <button [class.active]="option.is_default" class="colour-image" swatch-inside="true" (click)="selectOptionLinenraj(option.option,product3,i)" style="cursor: pointer; width: 40px; display: flex;justify-content: center;margin-right: 10px;height: 30px;border-radius: 7px; width: 76%;" swatch-inside="true" style="width:
              80%">
            <span class="droptext" style="text-align: center; font-size: 10px;margin-top: 7px;">{{option.option}}</span>
          </button>
            </div> 
          </div>
          <!-- <button type="button" style="white-space: nowrap;height:15%;width: 90%;margin-top: 50px" class="linen_btn"   (click)="addToCartcarience(product.variant.option_values[current_index].id)">ADD TO BAG</button> -->
  
          <div class="" style="display: flex; justify-content: center;" *ngFor="let price of linenRajOption.variant.option_values;let i = index">
  
            <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
            -1" class="linen_btn" type="button" style="white-space: nowrap;height:15%;width: 90%;margin-top: 10%" (click)="addToCartLinenraj(price.id)" >
            ADD TO BAG
            </button>   
            
            <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
            <div class="btn btn-primary inq-btn-st linenViewCart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
            <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
            <span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
               <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 
            
            
            </div>
            </div>
          
         
        </div>
       
      <!-- </div> -->
        <!-- <div class="modal-footer"> -->
          <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="title_message1">
      <div class="modal-content add_cart" style="min-width: 160%;">
        <div class="modal-header">
          <h5 class="modal-title" id="addToCart_ln">Select Size</h5>
          <button  id="closemodal1"  type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          
        </div>
        <div class="modal-body" style="margin-left: 5%;">
          <div style="display: flex;">
            <div><img style="height: 100px" [src]="product1"></div>
            
            <div>
              <span>
                <p style="font-size: 13px;margin-left: 3%;">{{LinenName}} </p>
              </span>
              <span>
                <p style="font-size: 13px;margin-left: 3%;">₹ {{LinenPrice}}</p>
  
              </span>
              <!-- <span>
                <a   class="view_detail_ln" (click)="viewDetail()">View Details</a>
              </span> -->
              
             
  
            </div>
          </div>
          <div style="display:flex;margin-top: 10px; ">
            <div style="display: grid;
            grid-template-columns: repeat(4, 1fr);
            margin-left: 5%;
            margin-right: 0%;
            grid-column-gap: 2%;
            margin-top:5%;width: 85%;">
              <div *ngFor="let option of linenRajOption.variant.option_values;let i = index" style=" width: 100%;">
                <!-- <div class="swatch-button-title-text" swatch-inside="true"><span [class.active]="option.is_default" class="colour-image" swatch-inside="true" (click)="selectOptionCarience(option.option,product3,i)" style="cursor: pointer; width: 40px; display: flex;justify-content: center;margin-right: 10px;height: 30px;border-radius: 7px;"><p style="text-align: center; font-size: 10px;margin-top: 7px;">{{option.option}}</p></span></div> -->
                <button [class.active]="option.is_default" class="colour-image" swatch-inside="true" (click)="selectOptionLinenraj(option.option,product3,i)" style="cursor: pointer; width: 40px; display: flex;justify-content: center;margin-right: 10px;height: 30px;border-radius: 7px; width: 76%;" swatch-inside="true" style="width:
                80%;margin-top: 10%;">
              <span class="droptext" style="text-align: center; font-size: 10px;margin-top: 7px;">{{option.option}}</span>
            </button>
              </div> 
            </div>
     
          </div>
          <!-- <button type="button" style="white-space: nowrap;height:15%;width: 90%;margin-top: 50px" class="linen_btn"   (click)="addToCartcarience(product.variant.option_values[current_index].id)">ADD TO BAG</button> -->
  
          <div class="" style="display: flex; justify-content: center;" *ngFor="let price of linenRajOption.variant.option_values;let i = index">
  
            <button *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) ==
            -1" class="linen_btn" type="button" style="white-space: nowrap;height:15%;width: 90%;margin-top: 14%" (click)="addToCartLinenraj(price.id)" >
            ADD TO BAG
            </button>   
            
            <!-- {{appService.productIdinCart.indexOf(price.id)}}                         -->
            <div class="btn btn-primary inq-btn-st linenViewCart" id="quantity_button" *ngIf="price.is_default&&appService.productIdinCart.indexOf(price.id) >=0">
            <span><i class="fa fa-minus mr-3"  style="font-size: 12px; cursor: pointer" (click)="decreaseItem(appService.productIdinCart.indexOf(price.id))"></i></span>
            <span class="inq-sp-2" style="color: white">{{appService.cartProducts.results[appService.productIdinCart.indexOf(price.id)].quantity}}</span>
               <span><i class="fa fa-plus ml-3" style="font-size: 12px; cursor: pointer"  (click)="increaseItem(appService.productIdinCart.indexOf(price.id))"></i></span> 
            
            
            </div>
            </div>
          
         
        </div>
       
      <!-- </div> -->
        <!-- <div class="modal-footer"> -->
          <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>














